try { console.log('%c[tmb-coach] coach page JS, build 2026-06-14 r3 (per-week diff preview)', 'color:#1E7A47;font-weight:600;'); } catch (_e) {}
window.__tmbCoachBuild = '2026-06-14-r3';
window.__tmbTourBuild = '2026-06-04-r5-programmed-sets';

(function () {
  // Install the 📊 Activity click handler FIRST, before any other IIFE
  // code that could throw. The previous spot near line 4844 was being
  // skipped on production, clicks reached document but the handler
  // had never installed. Function declarations are hoisted within the
  // IIFE scope, so openCoachInsightsDrawer_ resolves at click time
  // even though it's defined further down. Capture phase + closest()
  // matching means clicks land regardless of how often the admin table
  // is re-rendered by the background poll.
  document.addEventListener('click', function (e) {
    try {
      var btn = e.target && e.target.closest && e.target.closest('[data-athlete-insights]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var athleteToken = btn.getAttribute('data-athlete-insights');
      var name = btn.getAttribute('data-athlete-name') || '';
      openCoachInsightsDrawer_(athleteToken, name);
    } catch (err) {
      console.error('[coach] activity click handler error:', err);
    }
  }, true);

  // Delegated click for the overflow menu's "Ask LLM for update"
  // item. Same code path as the drawer's button but one click
  // higher. Closes the overflow menu first (so the page doesn't
  // look frozen), opens the loading modal immediately, then the
  // shared requestAskLlmBundle_ swaps in the bundle when ready.
  document.addEventListener('click', function (e) {
    try {
      var btn = e.target && e.target.closest && e.target.closest('[data-athlete-ask-llm], [data-athlete-ask-llm-full]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var isFull = btn.hasAttribute('data-athlete-ask-llm-full');
      var athleteToken = btn.getAttribute(isFull ? 'data-athlete-ask-llm-full' : 'data-athlete-ask-llm');
      var athleteName  = btn.getAttribute('data-athlete-name') || '';
      try { closeOpenOverflowMenu_(); } catch (_e) {}
      requestAskLlmBundle_(athleteToken, athleteName, { full: isFull });
    } catch (err) {
      console.error('[coach] ask-llm click handler error:', err);
    }
  }, true);

  // Tier classes on <body> drive LLM-zone visibility via CSS:
  //   body:not(.tmb-tier-premium) .tmb-llm-zone { display:none!important }
  // Called whenever coachInfo loads (state.info.trainer.role tells
  // us the tier: 'base' | 'premium' | 'admin'). Admin is a superset
  // of premium, so admin trainers get both classes. Default at
  // boot is no class set, so the LLM zone hides until coachInfo
  // resolves, safer than a flash-of-premium-content for base
  // trainers if the coachInfo POST is slow.
  // ═══════════════════════════════════════════════════════════════
  //  In-page guided tours, "❓ How to" pill bottom-right of the
  //  coach page. Click → menu of tours → each tour walks the
  //  trainer through a workflow with speech bubbles pointing at
  //  real UI elements. Pure JS, no library deps.
  //
  //  Adding a tour: append an entry to TMB_TOURS_ below. Steps
  //  reference real selectors on the page; if a selector isn't
  //  in the DOM (e.g. a form not yet opened), the bubble centers
  //  on screen instead of erroring. New features should land
  //  with their how-to tour in the same PR, see the
  //  HOWTO-TRAINER.md maintenance contract.
  // ═══════════════════════════════════════════════════════════════
  var TMB_TOURS_ = {
    'add-athlete': {
      title: 'Add an athlete',
      icon: '👤',
      description: 'Set up a new athlete on the system.',
      steps: [
        {
          title: 'Adding an athlete',
          body: 'This takes about 10 seconds. The system will:\n\n- Create their personal plan\n- Set up storage for their photos and videos\n- Email them a welcome link',
        },
        {
          target: '#coach-show-new-athlete',
          title: 'Click **+ New Athlete**',
          body: 'Opens the form. You\'ll need three things:\n\n- Their **name**\n- Their **email**\n- Their **time zone**',
          placement: 'bottom',
        },
        {
          target: '#coach-show-demo',
          title: 'Or try the example first',
          body: 'Not sure what you\'re creating? Click **👤 Try example plan** to see a fully set-up athlete with sample workouts, photos, and notes.\n\nGreat way to explore before making a real one.',
          placement: 'bottom',
        },
        {
          title: 'Fill in their details and hit Create',
          body: 'They\'ll show up in your list straight away.',
        },
        {
          title: 'They get a welcome email',
          body: 'Ask them to click the **confirm link** in the email. That turns on their notifications (like the weekly digest).',
        },
      ],
    },
    'see-insights': {
      title: 'See an athlete\'s activity',
      icon: '📊',
      description: 'The activity panel, what they\'ve done, what they\'ve logged, and key trends.',
      requires: { hasAthletes: true },
      steps: [
        {
          title: 'The activity panel',
          body: 'A side view per athlete showing:\n\n- Last 7 days of workouts (done, missed, notes)\n- Photos and videos they uploaded\n- Past replies you\'ve sent them\n- The AI\'s notes about this athlete\n- Trends (adherence + volume) over the last 12 weeks\n- Active injuries',
        },
        {
          target: '[data-athlete-insights]',
          ensureOpen: 'details.admin-athletes-block',
          title: 'Click **📊** next to the athlete',
          body: 'Opens the panel from the right side of the screen.',
          placement: 'left',
        },
        {
          target: '#coach-insights-overlay .ci-day, #coach-insights-overlay .ci-session',
          skipIfMissing: true,
          title: 'Daily workout cards',
          body: 'Each day groups the workouts. Each card shows:\n\n- **Status** (green DONE, grey TODAY, red MISSED)\n- The athlete\'s **note** in a quoted box\n- **Photos** and **videos** they uploaded\n- A **▸ View workout** link to see what was prescribed\n- A **▸ ✉️ Reply** option to message them about it',
          placement: 'left',
        },
        {
          target: '#coach-insights-overlay .ci-mark-day-seen',
          skipIfMissing: true,
          title: 'Mark a day as seen',
          body: 'Each day has a **Mark seen** button. Click it once you\'ve reviewed that day. The NEW flag clears. Hit **Mark unseen** to flip it back if you want to revisit.',
          placement: 'left',
        },
        {
          target: '#coach-insights-overlay .ci-plan-context',
          skipIfMissing: true,
          title: 'Plan context (Premium)',
          body: 'Further down the panel:\n\n- **🧠 Athlete context**: the AI\'s summary of where this athlete is right now\n- **📝 Update log**: every change made to their plan, when and why\n\nBoth update each time you do an AI plan update.',
          placement: 'left',
        },
        {
          target: '#coach-insights-overlay .ci-metrics',
          skipIfMissing: true,
          title: 'Metrics',
          body: 'At the bottom:\n\n- **Adherence**: % of workouts done over the last 12 weeks, plus a tiny bar chart\n- **Volume**: average training time per week\n- **Active injuries** if any',
          placement: 'left',
        },
      ],
    },
    'invite-athlete': {
      title: 'Invite or resend an athlete\'s welcome',
      icon: '📧',
      description: 'Send (or resend) the welcome email with their personal plan link.',
      requires: { hasAthletes: true },
      steps: [
        {
          title: 'Athlete welcome emails',
          body: 'Every athlete gets a welcome email when you create them. It has their personal plan link and a button to confirm their email address.\n\nIf they didn\'t get it (spam, bad address) or never confirmed, you can resend.',
        },
        {
          target: '.admin-row-overflow',
          ensureOpen: 'details.admin-athletes-block',
          title: 'Click **⋯** next to the athlete',
          body: 'The menu opens. Look in the **ATHLETE** section.',
          placement: 'left',
        },
        {
          title: 'Click Send invite (or Resend invite)',
          body: 'Says "Send invite" if they\'ve never confirmed; "Resend invite" if they have. Either way it fires off a fresh welcome email to whatever address is on file.',
        },
        {
          title: 'If their email is wrong',
          body: 'Use **Edit** in the same menu to fix the email first, then send the invite.',
        },
      ],
    },
    'set-up-group': {
      title: 'Set up a group or gym',
      icon: '👥',
      description: 'A shared plan for multiple athletes (small group, gym timetable, or large cohort).',
      steps: [
        {
          title: 'What\'s a group?',
          body: 'A shared plan that multiple athletes follow. Three flavours:\n\n- **Small group**: like a personal plan but shared. Members tick workouts individually.\n- **Gym**: class timetable instead of workouts. Members book class slots.\n- **Large group**: broadcast mode for 200+ athletes. Read-only for members.',
        },
        {
          target: '#coach-show-new-group',
          title: 'Click **+ New Group**',
          body: 'In the **Your groups & gyms** section.',
          placement: 'bottom',
        },
        {
          title: 'Pick a group type and fill in details',
          body: 'Name, time zone, and the group type. Hit Create. Same provisioning as an athlete (takes ~10 s).',
        },
        {
          title: 'Add members',
          body: 'After it\'s created:\n\n- Click **⋯** next to the group\n- Pick **View members**\n- Paste in member emails (one per line)\n- They each get a welcome email with the group link',
        },
      ],
    },
    'import-plan': {
      title: 'Import a plan from CSV files',
      icon: '📥',
      description: 'Bulk-edit an athlete\'s plan by uploading CSV files (manually written or AI-generated).',
      requires: { hasAthletes: true },
      steps: [
        {
          title: 'When to use Import',
          body: 'Two main times:\n\n- Loading the AI\'s response after **Ask AI for update**\n- Writing changes yourself in a spreadsheet and uploading',
        },
        {
          target: '.admin-row-overflow',
          ensureOpen: 'details.admin-athletes-block',
          title: 'Click **⋯** next to the athlete',
          body: 'In the menu, look in the **PLAN** section and click **Import plan**.',
          placement: 'left',
        },
        {
          title: 'Drop in your CSV files',
          body: 'A dialog opens. Drag in one or more files. The system matches each filename to the right tab:\n\n- `import.csv` → workouts\n- `weeks.csv` → week dates\n- `update-log.csv` → AI notes\n- `athlete-context.csv` → AI summary',
        },
        {
          title: 'Click **Preview changes** first',
          body: 'Always preview before committing. Shows you:\n\n- How many rows will be added / kept / replaced\n- Any date-discipline warnings (non-Monday starts, gaps, weird formats)\n\nNo writes happen yet.',
        },
        {
          title: 'Hit **Apply** to commit',
          body: 'The current programme gets backed up first (recoverable), then your changes are written.\n\n**Past sessions are preserved by default**: your edits only apply from today forward.',
        },
      ],
    },
    'edit-programme': {
      title: 'Edit an athlete\'s programme',
      icon: '📝',
      description: 'Three ways to change what an athlete is doing.',
      requires: { hasAthletes: true },
      steps: [
        {
          title: 'Three ways to edit',
          body: 'Pick whichever fits the change:\n\n- **Google Sheets**: direct cell edits, best for quick tweaks\n- **CSV Import**: bulk changes, written yourself or from the AI\n- **Ask AI for update**: collaborative LLM update *(Premium)*',
        },
        {
          target: '.admin-row-overflow',
          ensureOpen: 'details.admin-athletes-block',
          title: 'Click **⋯** next to the athlete',
          body: 'The menu has all three options in the **PLAN** section.',
          placement: 'left',
        },
        {
          title: 'For a quick tweak: Open Google Sheet ↗',
          body: 'Opens their plan as a Google Sheet in a new tab. Edit the **Import** tab to change workouts. Changes go live within ~60 seconds.',
        },
        {
          title: 'For bigger changes: Import plan',
          body: 'Upload a set of CSV files. See the **Import a plan** tour for details. Preview before you Apply.',
        },
        {
          title: 'For AI-assisted: Ask AI for update *(Premium)*',
          body: 'Download a bundle → chat with ChatGPT or Claude → get CSV files back → Import them. See the **Get AI help with a plan update** tour for the full flow.',
        },
      ],
    },
    'programmed-sets': {
      title: 'Author Programmed Sets: per-session targets',
      icon: '🎯',
      description: 'Prescribe sets / reps / weight / distance / pace per movement, not just text.',
      requires: { hasAthletes: true },
      steps: [
        {
          title: 'What Programmed Sets is',
          body: 'Every session can carry a **structured prescription** alongside its written Description. Each row prescribes one movement with targets: **sets · reps · weight · distance · time · pace · RPE**.\n\nThe athlete\'s sets editor pre-populates these as targets. They log achieved vs target. That\'s how plans become measurable.',
        },
        {
          target: '.admin-row-overflow',
          ensureOpen: 'details.admin-athletes-block',
          title: 'Open the athlete\'s plan page',
          body: 'Click **⋯** next to the athlete → **Open plan ↗** (in the PLAN section).\n\nThe Programmed Sets panel lives on the athlete plan page, not the coach page.',
          placement: 'left',
        },
        {
          title: 'On the plan page: enable trainer mode',
          body: 'You should already be in trainer mode if you opened the plan via the coach overflow menu. If not, tap the **🔧 Trainer mode** chip at the top right.\n\nIn trainer mode each session pill gets an **✎ Edit** button.',
        },
        {
          title: 'Open the session-edit drawer',
          body: 'Tap **✎ Edit** on any session pill. A drawer slides in from the right with editable fields: Title, Description, Slot, Priority, and **Programmed sets**.',
        },
        {
          title: 'The Programmed Sets panel',
          body: 'One row per movement. For each row:\n\n- **Movement**: text input with autocomplete from the canonical library (start typing; pick from the dropdown)\n- **Sets · Reps · Weight · Distance · Time · Pace · RPE**: fill the cells that apply to the movement\'s type; leave the rest blank\n- **Notes**: per-row free text (tempo cue, alternative load, scaling)\n- **×** deletes the row; **+ Add programmed movement** appends a fresh one',
        },
        {
          title: 'Save commits everything atomically',
          body: 'One Save button at the drawer footer commits the field changes AND the Programmed Sets in a single save.\n\nThe athlete\'s next plan refresh shows the new prescription, each programmed row has a **red left strip** in their sets editor so they know which rows came from you.',
        },
        {
          title: 'Three ways to author',
          body: 'Same Programmed Sets rows under the hood, different inputs:\n\n- **Drawer panel**: what we just walked through (best for hand-authoring)\n- **AI chat** *(Premium)*, ask *"program a push session for tomorrow"*; it writes the rows via the `program_session` / `add_session_with_program` tools\n- **Direct sheet edit**: paste rows into the Programmed Sets tab in the athlete\'s Google Sheet when bulk-editing many sessions',
        },
      ],
    },
    'new-programme': {
      title: 'Start a new programme for an athlete',
      icon: '🔄',
      description: 'Archive the current plan and start fresh, for new training blocks or seasons.',
      requires: { hasAthletes: true },
      steps: [
        {
          title: 'When to start a new programme',
          body: 'Use this when the athlete is moving to a clearly new phase, end of one block, start of another. Examples:\n\n- Finished base building, now starting race-specific\n- Coming back from a long injury layoff\n- Moving from one sport to another',
        },
        {
          target: '.admin-row-overflow',
          ensureOpen: 'details.admin-athletes-block',
          title: 'Click **⋯** next to the athlete',
          body: 'In the **PLAN** section, click **New programme**.',
          placement: 'left',
        },
        {
          title: 'What gets archived',
          body: 'These tabs move to hidden archive tabs (recoverable):\n\n- Workouts (Import)\n- Week structure\n- Block overview\n- Roadmap / Checkpoints / Categories',
        },
        {
          title: 'What stays',
          body: 'These keep their history:\n\n- **Export** (their tick + note + photo history)\n- **Sets** (set logs)\n- **PBs** (personal bests)\n- **Athlete Context** + **Update Log** (AI memory)\n\nSo their training history is preserved across programmes.',
        },
        {
          title: 'Then load the new plan',
          body: 'After archiving, write or import the new programme. See the **Edit an athlete\'s programme** tour for options.',
        },
      ],
    },
    'reply-to-note': {
      title: 'Reply to an athlete\'s note',
      icon: '✉️',
      description: 'Send a personal message about a specific workout.',
      requires: { hasAthletes: true },
      steps: [
        {
          title: 'Reply to a workout note',
          body: 'When an athlete leaves a note (like *"knee felt twingy today"*), you can reply directly. They get your reply as an email.',
        },
        {
          target: '[data-athlete-insights]',
          ensureOpen: 'details.admin-athletes-block',
          title: 'Click **📊** next to the athlete',
          body: 'Opens their activity panel, a side view showing what they did this week.',
          placement: 'left',
        },
        {
          target: '#coach-insights-overlay .ci-session',
          skipIfMissing: true,
          title: 'Find the workout in the panel',
          body: 'Each workout card has:\n\n- Status (done / today / missed)\n- The athlete\'s note in a quoted box on the right\n- Photos and videos if they uploaded any',
          placement: 'left',
        },
        {
          target: '#coach-insights-overlay .ci-reply',
          skipIfMissing: true,
          title: 'Click **▸ ✉️ Reply to athlete**',
          body: 'Below the workout card. A text box opens. Write your reply and hit **Send**.',
          placement: 'left',
        },
        {
          title: 'They get an email',
          body: 'Sent from you, with a quote of their original note for context.\n\nWhen they reply, it goes **straight to your inbox**, not through the system.',
        },
      ],
    },
    'ask-ai': {
      title: 'Get AI help with a plan update',
      icon: '🤖',
      description: 'Use ChatGPT or Claude to update an athlete\'s plan. (Premium only.)',
      requires: { hasAthletes: true, tier: 'premium' },
      steps: [
        {
          title: 'How the AI helps you',
          body: 'A six-step round trip. You stay in control the whole way:\n\n- Download a folder of files about the athlete\n- Drop them into ChatGPT or Claude\n- Answer the AI\'s questions\n- Load the AI\'s changes back in\n\nThe AI never changes anything without you reviewing it first.',
        },
        {
          target: '.admin-row-overflow',
          ensureOpen: 'details.admin-athletes-block',
          title: 'Click **⋯** next to the athlete',
          body: 'A menu opens. Find the **🤖 AI** section and click **Ask AI for update**.',
          placement: 'left',
        },
        {
          title: 'Wait for the download',
          body: 'A box pops up with a loading spinner. **5 to 30 seconds.**\n\nWhen it\'s done, hit the big green **Download** button.',
        },
        {
          title: 'Drop the files into ChatGPT or Claude',
          body: 'Open a project in Claude (or a custom GPT in ChatGPT). Drag **every file** from the downloaded folder into it.\n\nThen type: *"Read 00-PROMPT.md and proceed."*',
        },
        {
          title: 'Answer the AI\'s questions',
          body: 'The AI writes a quick summary, then asks 3-6 questions, things like:\n\n- How many weeks should I change?\n- Anything to fix about Saturday?\n- Any new injuries or events?\n\nType your answers in the chat.',
        },
        {
          title: 'Download the AI\'s changes',
          body: 'The AI replies with **CSV files**. Download them.',
        },
        {
          title: 'Load the changes back in',
          body: 'On the coach page:\n\n- Click **⋯** next to the athlete\n- **Import plan**\n- Drop the files in\n- **Preview changes** to see what\'ll change\n- **Apply** to save\n\nThe system checks the AI\'s work and flags any mistakes before saving.',
        },
      ],
    },
  };

  var tmbTourState_ = { active: null, stepIdx: 0, overlay: null, originalState: null };

  // Snapshot enough of the coach page state to undo whatever the
  // tour opened. The Activity drawer + Ask AI modal are fully
  // removed via .remove() when closed (vs the athlete-page timer
  // which only toggles display) so existence == open here.
  function snapshotTmbTourState_() {
    var snap = {
      scrollY: window.scrollY || 0,
      drawerOpen: !!document.getElementById('coach-insights-overlay'),
      askLlmOpen: !!document.getElementById('coach-ask-llm-modal'),
      closedDetails: [],
      openMenus: [],
    };
    document.querySelectorAll('details').forEach(function (d) {
      if (!d.open) snap.closedDetails.push(d);
    });
    document.querySelectorAll('.admin-row-overflow-menu.is-open').forEach(function (m) {
      snap.openMenus.push(m);
    });
    return snap;
  }

  function restoreTmbTourState_(snap, opts) {
    if (!snap) return;
    opts = opts || {};
    if (!snap.drawerOpen) {
      var drawer = document.getElementById('coach-insights-overlay');
      if (drawer) drawer.remove();
    }
    if (!snap.askLlmOpen) {
      var modal = document.getElementById('coach-ask-llm-modal');
      if (modal) modal.remove();
    }
    snap.closedDetails.forEach(function (d) { if (d && d.open) d.open = false; });
    document.querySelectorAll('.admin-row-overflow-menu.is-open').forEach(function (m) {
      if (snap.openMenus.indexOf(m) === -1) {
        try { closeOpenOverflowMenu_(); } catch (_e) { m.classList.remove('is-open'); }
      }
    });
    if (!opts.skipScroll) {
      // Positional form ignores any `html { scroll-behavior: smooth }`
      // rule the coach page CSS might pick up, restore should JUMP,
      // not animate.
      window.scrollTo(0, snap.scrollY || 0);
    }
  }

  // True if `el` is inside a position:fixed ancestor (modal,
  // drawer overlay). The rect of fixed elements is viewport-
  // relative, so scrollY math would move the page randomly. Skip.
  function isInFixedAncestor_(el) {
    while (el && el !== document.body && el.nodeType === 1) {
      var cs = getComputedStyle(el);
      if (cs.position === 'fixed') return true;
      el = el.parentElement;
    }
    return false;
  }

  // Native scrollIntoView so the browser handles scroll containers /
  // document boundaries / sticky bars via `scroll-padding-top`. The
  // manual maxScroll math was clamping landings hundreds of pixels
  // short of the target when document.documentElement.scrollHeight
  // didn't match the actual reachable scroll range.
  function smartScrollToEl_(el, opts) {
    if (!el) return false;
    if (isInFixedAncestor_(el)) return false;
    opts = opts || {};
    var pad = 12;
    var stickyOffset = pad;
    var nav = document.querySelector('.coach-nav');
    if (nav) {
      var ns = getComputedStyle(nav);
      if (ns.position === 'sticky' || ns.position === 'fixed') {
        stickyOffset += nav.getBoundingClientRect().height;
      }
    }
    try { document.documentElement.style.scrollPaddingTop = stickyOffset + 'px'; } catch (_e) {}
    void el.offsetHeight;
    var rect = el.getBoundingClientRect();
    var elH = rect.height || el.offsetHeight || 0;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var preferStart = opts.block === 'start' || elH > vh * 0.6;
    var block = preferStart ? 'start' : 'center';
    var scrollYBefore = window.scrollY || 0;
    try {
      el.scrollIntoView({ behavior: 'instant', block: block, inline: 'nearest' });
    } catch (_e1) {
      try { el.scrollIntoView({ behavior: 'auto', block: block, inline: 'nearest' }); }
      catch (_e2) { el.scrollIntoView(true); }
    }
    try {
      var rectAfter = el.getBoundingClientRect();
      console.log('[tmb-tour] scroll (native)', {
        sel: opts._sel || null,
        elH: Math.round(elH),
        block: block,
        stickyOffset: stickyOffset,
        rectTopBefore: Math.round(rect.top),
        rectTopAfter: Math.round(rectAfter.top),
        scrollYBefore: Math.round(scrollYBefore),
        scrollYAfter: Math.round(window.scrollY || 0),
      });
    } catch (_e) {}
    return true;
  }

  // Comma-separated selectors are an OR, querySelector returns the
  // first matching element in DOCUMENT order, not the first matching
  // CLAUSE. Char-by-char parser splits on top-level commas only
  // (skipping commas inside brackets / parens / quoted strings) so
  // attribute selectors like `[data-foo="a,b"]` survive the split.
  function querySelectorOrdered_(selector) {
    if (!selector) return null;
    if (selector.indexOf(',') === -1) return document.querySelector(selector);
    var parts = [];
    var depth = 0, inQuote = null, start = 0;
    for (var i = 0; i < selector.length; i++) {
      var ch = selector.charAt(i);
      if (inQuote) {
        if (ch === inQuote) inQuote = null;
        continue;
      }
      if (ch === '"' || ch === "'") { inQuote = ch; continue; }
      if (ch === '[' || ch === '(') depth++;
      else if (ch === ']' || ch === ')') depth--;
      else if (ch === ',' && depth === 0) {
        parts.push(selector.substring(start, i));
        start = i + 1;
      }
    }
    parts.push(selector.substring(start));
    for (var j = 0; j < parts.length; j++) {
      var p = parts[j].trim();
      if (!p) continue;
      try {
        var el = document.querySelector(p);
        if (el) {
          if (window.__tmbTourDebug) console.log('[tmb-tour] selector matched', { clauseIdx: j, clause: p });
          return el;
        }
      } catch (e) {
        if (window.__tmbTourDebug) console.warn('[tmb-tour] selector parse error', p, e);
      }
    }
    if (window.__tmbTourDebug) console.log('[tmb-tour] no clause matched', { selector: selector });
    return null;
  }

  function openTmbTourMenu_() {
    // If a prior tour is mid-flight, restore its prior state before
    // opening the menu, otherwise re-starting from the menu would
    // snapshot over the previous tour's already-opened modals.
    closeTmbTour_({ restore: true });
    var menu = document.createElement('div');
    menu.id = 'tmb-tour-menu';
    // Anchor under the top-nav ❓ button. Fall back to bottom-right
    // if the button isn't on the page for some reason (e.g. user
    // is on the gate / loading view).
    var anchor = document.getElementById('coach-nav-help');
    var menuStyle = 'position:fixed;z-index:10000;background:#FFFFFF;border:1px solid #E5E2D9;border-radius:12px;box-shadow:0 12px 32px rgba(0,0,0,0.18);padding:10px;width:320px;max-width:calc(100vw - 40px);';
    if (anchor) {
      var r = anchor.getBoundingClientRect();
      // 8 px gap below the button; right-align so the menu's right
      // edge matches the button's right edge (keeps it from hanging
      // off the viewport on the right).
      var top = Math.round(r.bottom + 8);
      var right = Math.max(20, Math.round(window.innerWidth - r.right));
      menuStyle += 'top:' + top + 'px;right:' + right + 'px;';
    } else {
      menuStyle += 'bottom:20px;right:20px;';
    }
    menu.style.cssText = menuStyle;
    // Resolve each tour's prerequisites against current state so
    // we can show "this tour needs an athlete first" inline rather
    // than letting the trainer start a tour that points at UI
    // they don't have yet. Returns a string reason if unmet, or
    // null if all requirements are satisfied.
    // Three states per tour:
    //   'ok': all prerequisites met; tour can run as-is.
    //   'demo': needs an athlete; can be satisfied by
    //                 auto-provisioning the demo (or using an
    //                 existing one). Clickable; provisions on
    //                 click if needed.
    //   'blocked': hard requirement that can't be auto-fixed
    //                 from here (e.g. wrong tier). Dimmed.
    function checkTour_(tour) {
      var req = tour.requires || {};
      var info = state.info || {};
      if (req.tier === 'premium') {
        var role = info.trainer && String(info.trainer.role || '').toLowerCase();
        if (role !== 'premium' && role !== 'admin') {
          return { state: 'blocked', reason: 'Premium tier required, contact your admin to upgrade.' };
        }
      }
      if (req.hasAthletes) {
        var atks = (info.athletes || []).filter(function (a) {
          return String(a.status || '').toLowerCase() !== 'archived';
        });
        if (!atks.length) {
          return { state: 'demo', reason: 'Will set up a demo athlete to run the tour on.' };
        }
      }
      return { state: 'ok' };
    }
    var rows = Object.keys(TMB_TOURS_).map(function (k) {
      var t = TMB_TOURS_[k];
      var c = checkTour_(t);
      var disabled = c.state === 'blocked';
      var demoMode = c.state === 'demo';
      var tint = disabled ? '#9a9a92' : '#1A1918';
      var bg = disabled ? '#F7F6F2' : 'transparent';
      var badge = disabled ? ' <span style="font-size:10px;color:#c74638;font-weight:700;letter-spacing:0.04em;text-transform:uppercase;">· unavailable</span>'
                : demoMode ? ' <span style="font-size:10px;color:#1E7A47;font-weight:700;letter-spacing:0.04em;text-transform:uppercase;">· uses demo</span>'
                : '';
      var bodyText = disabled ? c.reason
                   : demoMode ? c.reason
                   : t.description;
      return '<button type="button" data-tour-key="' + k + '" data-tour-state="' + c.state + '"' +
        ' style="display:block;width:100%;text-align:left;padding:12px 14px;border:0;border-radius:8px;background:' + bg + ';cursor:' + (disabled ? 'not-allowed' : 'pointer') + ';font:inherit;font-size:13px;color:' + tint + ';">' +
        '<div style="font-weight:600;margin-bottom:3px;">' + (t.icon || '') + ' ' + escapeHtml(t.title) + badge + '</div>' +
        '<div style="font-size:11px;color:' + (disabled ? '#9a9a92' : '#777775') + ';line-height:1.4;">' +
          escapeHtml(bodyText) +
        '</div>' +
      '</button>';
    }).join('');
    menu.innerHTML =
      '<div style="font-size:11px;font-weight:700;color:#555;letter-spacing:0.04em;text-transform:uppercase;padding:6px 10px 10px;">How to…</div>' +
      rows +
      '<button type="button" id="tmb-tour-menu-close" style="display:block;width:100%;padding:8px;border:0;border-top:1px solid #E5E2D9;margin-top:6px;background:transparent;color:#777775;cursor:pointer;font:inherit;font-size:12px;">Close</button>';
    document.body.appendChild(menu);
    menu.querySelectorAll('[data-tour-key]').forEach(function (b) {
      var tourState = b.getAttribute('data-tour-state');
      var disabled = tourState === 'blocked';
      b.addEventListener('click', function () {
        if (disabled) return;
        var k = b.getAttribute('data-tour-key');
        // Go through closeTmbTourMenuIfOpen_ so the outside-click
        // listener attached by openTmbTourMenu_ is removed. A bare
        // menu.remove() leaves the document handler attached and
        // every menu-open + tour-start pair accumulated another
        // one, read as "❓ pill click is slow / doesn't register"
        // because every click on the page paid for N stale handlers.
        closeTmbTourMenuIfOpen_();
        if (tourState === 'demo') ensureDemoThenStartTour_(k);
        else startTmbTour_(k);
      });
      if (!disabled) {
        b.addEventListener('mouseenter', function () { b.style.background = '#F0EEE7'; });
        b.addEventListener('mouseleave', function () { b.style.background = 'transparent'; });
      }
    });
    menu.querySelector('#tmb-tour-menu-close').addEventListener('click', closeTmbTourMenuIfOpen_);
    setTimeout(function () {
      var off = function (e) {
        if (!menu.contains(e.target) && !e.target.closest('#coach-nav-help')) {
          closeTmbTourMenuIfOpen_();
        }
      };
      // Stash the off handler on the menu element so the unified
      // close path can remove it regardless of how the menu is
      // dismissed. Without this, toggle-close (re-clicking the
      // nav button) left old listeners attached, accumulating
      // dozens after a few open/close cycles and reading as
      // "massive click delay" on the help button.
      menu._tourMenuOff = off;
      document.addEventListener('click', off, true);
    }, 0);
  }

  // Single tear-down path for the tour menu. Removes the outside-
  // click handler before removing the DOM node so listeners don't
  // accumulate across repeated opens.
  function closeTmbTourMenuIfOpen_() {
    var menu = document.getElementById('tmb-tour-menu');
    if (!menu) return;
    if (menu._tourMenuOff) {
      try { document.removeEventListener('click', menu._tourMenuOff, true); } catch (_e) {}
      delete menu._tourMenuOff;
    }
    menu.remove();
  }

  function startTmbTour_(key) {
    var tour = TMB_TOURS_[key];
    if (!tour) return;
    tmbTourState_ = {
      active: key,
      stepIdx: 0,
      originalState: snapshotTmbTourState_(),
    };
    renderTmbTourStep_();
  }

  // For tours that need an athlete to point at, auto-provision the
  // demo athlete (or reuse an existing one owned by this trainer)
  // and then start the tour. Shows a brief "setting up demo…"
  // modal while the server provisions, same loader pattern as
  // the Ask AI bundle. Once the demo is ready, refreshes the
  // coach state so the tour can find the row.
  // Mini markdown renderer for tour bubble bodies. Supports:
  //   - **bold**
  //   - `code`
  //   - line-starting "- " bullets (consecutive lines → <ul>)
  //   - blank-line paragraph breaks
  // Output is HTML-safe, input is escaped first, then markdown
  // tokens are unwrapped post-escape.
  function renderTourMarkdown_(text) {
    var safe = escapeHtml(String(text || ''));
    safe = safe.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    safe = safe.replace(/`([^`]+)`/g, '<code style="font:12px/1 ui-monospace,Menlo,monospace;background:rgba(0,0,0,0.06);padding:1px 5px;border-radius:3px;">$1</code>');
    // Split into paragraphs by blank lines. Each paragraph: if
    // every non-empty line starts with "- ", render as <ul>;
    // otherwise <p> with <br> for single line breaks.
    var paragraphs = safe.split(/\n\s*\n/);
    var html = paragraphs.map(function (p) {
      var lines = p.split('\n').filter(function (l) { return l.length; });
      if (!lines.length) return '';
      var allBullets = lines.every(function (l) { return /^-\s+/.test(l); });
      if (allBullets) {
        return '<ul style="margin:0 0 0 16px;padding:0;">' + lines.map(function (l) {
          return '<li style="margin:4px 0;">' + l.replace(/^-\s+/, '') + '</li>';
        }).join('') + '</ul>';
      }
      return '<p style="margin:0 0 8px 0;">' + lines.join('<br>') + '</p>';
    }).join('');
    return html || safe;
  }

  function ensureDemoThenStartTour_(key) {
    // If trainer already has any non-archived athlete, just start
    // the tour, provisionDemo would still work but we prefer to
    // use whatever's already there.
    var info = state.info || {};
    var anyAthlete = (info.athletes || []).some(function (a) {
      return String(a.status || '').toLowerCase() !== 'archived';
    });
    if (anyAthlete) { startTmbTour_(key); return; }

    // No athlete, overlay a tiny prep modal while we provision.
    var overlay = document.createElement('div');
    overlay.id = 'tmb-tour-prep';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:10001;background:rgba(0,0,0,0.45);align-items:center;justify-content:center;padding:20px;';
    overlay.style.setProperty('display', 'flex', 'important');
    overlay.innerHTML =
      '<div style="background:#FFFFFF;border-radius:12px;padding:32px 30px;max-width:380px;text-align:center;box-shadow:0 20px 50px rgba(0,0,0,0.25);">' +
        '<div style="width:36px;height:36px;border:3px solid #E5E2D9;border-top-color:#1A1918;border-radius:50%;margin:0 auto 16px;animation:tmbSpin 1s linear infinite;"></div>' +
        '<div style="font-size:16px;font-weight:600;color:#1A1918;margin-bottom:6px;">Setting up a demo athlete…</div>' +
        '<div style="font-size:13px;color:#777775;line-height:1.5;">This takes about 10 seconds. We\'ll use the demo to walk you through the tour.</div>' +
      '</div>';
    if (!document.getElementById('tmb-spin-style')) {
      var st = document.createElement('style');
      st.id = 'tmb-spin-style';
      st.textContent = '@keyframes tmbSpin{to{transform:rotate(360deg);}}';
      document.head.appendChild(st);
    }
    document.body.appendChild(overlay);

    postAction('provisionDemo', {})
      .then(function (j) {
        if (!j || !j.ok) {
          overlay.remove();
          toast('Couldn\'t set up the demo: ' + ((j && j.error) || 'unknown error'), 'error');
          return;
        }
        // Refresh state so the tour sees the new athlete in
        // state.info.athletes (otherwise the tour\'s selector
        // for [data-athlete-insights] would still find nothing).
        fetchInfo().then(function (j2) {
          state.info = j2; writeInfoCache(j2); render();
          overlay.remove();
          startTmbTour_(key);
        }).catch(function () {
          overlay.remove();
          // Worst case start the tour anyway; the row may render
          // on the next background poll.
          startTmbTour_(key);
        });
      })
      .catch(function (e) {
        overlay.remove();
        toast('Network error setting up demo: ' + ((e && e.message) || 'unknown'), 'error');
      });
  }

  // Tear-down for the tour overlay. Pass {restore: true} from Done /
  // Skip / Esc to undo every modal + details the tour opened so the
  // page lands back in the state the trainer started from. Done
  // additionally passes {toTop: true} so we scroll back up, the
  // user asked for "close everything and return to the top" when
  // they hit Done at the end of a tour.
  function closeTmbTour_(opts) {
    opts = opts || {};
    var existing = document.getElementById('tmb-tour-overlay');
    if (existing) existing.remove();
    var snap = tmbTourState_ && tmbTourState_.originalState;
    if (opts.restore && snap) {
      // Skip the snapshot's auto scroll when we're heading to top,
      // the smooth scrollTo(0) below would otherwise race against it.
      restoreTmbTourState_(snap, { skipScroll: !!opts.toTop });
    }
    if (opts.toTop) {
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      catch (_e) { window.scrollTo(0, 0); }
    }
    tmbTourState_ = { active: null, stepIdx: 0, originalState: null };
  }

  function renderTmbTourStep_() {
    var tour = TMB_TOURS_[tmbTourState_.active];
    if (!tour) return closeTmbTour_();
    var step = tour.steps[tmbTourState_.stepIdx];
    if (!step) return closeTmbTour_();

    // Remove previous overlay/bubble, then rebuild.
    var existing = document.getElementById('tmb-tour-overlay');
    if (existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.id = 'tmb-tour-overlay';
    // z-index 100001 sits above the Activity drawer (9999), Ask
    // AI modal (9999) and the demo provisioning modal (99999) so
    // tour bubbles aren't covered when an earlier step opened
    // one of those overlays. Highlight cutout still shows the
    // underlying element through the dim via box-shadow.
    // z-index 100200 sits above any modal on the page (Activity
    // drawer / Ask AI bundle / Demo modal). Tour bubbles must
    // remain visible if a step opened one of these overlays.
    overlay.style.cssText = 'position:fixed;inset:0;z-index:100200;pointer-events:none;';
    document.body.appendChild(overlay);

    // Optional ensureOpen step lets a tour expand collapsed
    // <details> elements (e.g. "Your athletes" section) so the
    // real target inside them is in the layout flow and has a
    // measurable bounding rect. Pass a CSS selector for the
    // <details> to open.
    if (step.ensureOpen) {
      document.querySelectorAll(step.ensureOpen).forEach(function (d) {
        if (d.tagName === 'DETAILS' && !d.open) d.open = true;
      });
    }

    // Optional openTarget step lets a tour click a button to open
    // a menu / drawer / modal before highlighting something
    // inside it. e.g. step targets `.admin-row-overflow` for the
    // "click ⋯" step, then the NEXT step uses openTarget on the
    // ⋯ button + target on the LLM section inside the menu.
    // Idempotent-ish: if the openTarget element is the same as
    // a previously-clicked one, the second click would toggle
    // closed, engine checks if the actual `target` is already
    // visible first and skips the click if so.
    if (step.openTarget) {
      var opener = querySelectorOrdered_(step.openTarget);
      if (opener) {
        // Close buttons always fire, closing a closed modal is a
        // no-op, but skipping the click because the target appears
        // visible (just covered by the modal) keeps the modal up
        // and the highlight buried.
        var isCloser = opener.matches('.comp-modal-close, .tmb-modal-close, [data-modal-close], [aria-label="Close"], [data-drawer-close]');
        if (isCloser) {
          opener.click();
        } else if (step.target) {
          var existsAlready = querySelectorOrdered_(step.target);
          var rectExisting = existsAlready && existsAlready.getBoundingClientRect();
          var visible = rectExisting && rectExisting.width > 0 && rectExisting.height > 0;
          if (!visible) opener.click();
        } else {
          opener.click();
        }
      }
    }

    // Find target element (if any). Scroll into view; compute rect.
    if (step.target) {
      var el = querySelectorOrdered_(step.target);
      if (el) {
        // Walk up parents and open any collapsed <details> that
        // contains the target, without this, getBoundingClientRect
        // returns zero-size for elements inside a closed <details>
        // and the highlight collapses to a dot.
        var anc = el.parentElement;
        while (anc) {
          if (anc.tagName === 'DETAILS' && !anc.open) anc.open = true;
          anc = anc.parentElement;
        }
        // Two-frame settle, then scroll, then a third 180 ms wait
        // before measuring. Retries up to 2× if the rect comes back
        // zero (target rendered async).
        var attemptC = 0;
        function _afterScrollC() {
          void el.offsetHeight;
          var r = el.getBoundingClientRect();
          if (window.__tmbTourDebug) {
            console.log('[tmb-tour] measure', {
              sel: step.target,
              attempt: attemptC,
              top: Math.round(r.top), left: Math.round(r.left),
              w: Math.round(r.width), h: Math.round(r.height),
              scrollY: Math.round(window.scrollY),
            });
          }
          if ((r.width === 0 || r.height === 0) && attemptC < 2) {
            attemptC++;
            setTimeout(_afterScrollC, 200);
            return;
          }
          if (r.width === 0 && r.height === 0) {
            drawTmbTourFrame_(overlay, step, tour, null);
          } else {
            drawTmbTourFrame_(overlay, step, tour, { x: r.left, y: r.top, w: r.width, h: r.height });
          }
        }
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            smartScrollToEl_(el, { behavior: 'auto', block: step.scrollBlock || 'center', _sel: step.target });
            setTimeout(_afterScrollC, 180);
          });
        });
        return;
      }
    }
    // No target, centred bubble.
    drawTmbTourFrame_(overlay, step, tour, null);
  }

  function drawTmbTourFrame_(overlay, step, tour, rect) {
    overlay.innerHTML = '';
    // Dim layer with optional cut-out (box-shadow trick).
    var dim = document.createElement('div');
    dim.style.cssText = 'position:fixed;inset:0;background:transparent;pointer-events:auto;';
    overlay.appendChild(dim);

    if (rect) {
      // Cap tall sections so the highlight stays on-screen and
      // there's room for the bubble below it.
      var vhCap = (window.innerHeight || 800) * 0.55;
      var capped = { x: rect.x, y: rect.y, w: rect.w, h: rect.h };
      if (capped.h > vhCap) capped.h = Math.max(120, vhCap);
      // Grow tiny targets (overflow ⋯ buttons, icon-only nav) to a
      // minimum visible size so the dim doesn't swallow them.
      var minSide = 44;
      if (capped.w < minSide) { capped.x -= (minSide - capped.w) / 2; capped.w = minSide; }
      if (capped.h < minSide) { capped.y -= (minSide - capped.h) / 2; capped.h = minSide; }
      rect = capped;
      var hl = document.createElement('div');
      hl.className = 'tmb-tour-highlight';
      // Inline positioning only; the pulsing box-shadow comes from
      // the .tmb-tour-highlight CSS animation so the user's eye is
      // pulled in even on small targets like the 📊 button.
      hl.style.cssText = 'position:fixed;top:' + (rect.y - 4) + 'px;left:' + (rect.x - 4) + 'px;width:' + (rect.w + 8) + 'px;height:' + (rect.h + 8) + 'px;border-radius:8px;pointer-events:none;';
      overlay.appendChild(hl);
    } else {
      // No target → full-screen dim.
      dim.style.background = 'rgba(0,0,0,0.55)';
    }

    // Bubble. Position next to target (placement preferred side
    // with safe fallback) or centre if no target.
    var bubble = document.createElement('div');
    // Bigger card (max-w 440) + generous padding + fade-in
    // animation so steps don't snap in jarringly. Progress bar
    // along the top of the card makes "where am I in this tour"
    // obvious at a glance.
    bubble.style.cssText = 'position:fixed;background:#FFFFFF;color:#1A1918;border-radius:12px;padding:0;box-shadow:0 16px 40px rgba(0,0,0,0.22);max-width:440px;width:calc(100vw - 40px);font:inherit;font-size:14px;line-height:1.55;pointer-events:auto;z-index:1;opacity:0;transform:translateY(6px) scale(0.98);transition:opacity 0.18s ease-out, transform 0.18s ease-out;overflow:hidden;';
    var idx = tmbTourState_.stepIdx + 1;
    var total = tour.steps.length;
    var pct = Math.round((idx / total) * 100);
    bubble.innerHTML =
      // Top progress strip, visual cue for tour length.
      '<div style="height:3px;background:#E5E2D9;">' +
        '<div style="height:100%;width:' + pct + '%;background:#1E7A47;transition:width 0.2s ease-out;"></div>' +
      '</div>' +
      '<div style="padding:18px 22px;">' +
        '<div style="display:flex;align-items:baseline;gap:8px;margin-bottom:10px;">' +
          '<span style="font-size:10px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;color:#1E7A47;">Step ' + idx + ' of ' + total + '</span>' +
          '<span style="font-size:11px;color:#777775;">' + escapeHtml(tour.title) + '</span>' +
        '</div>' +
        '<div style="font-size:17px;font-weight:600;margin-bottom:10px;line-height:1.35;">' + escapeHtml(step.title) + '</div>' +
        '<div style="margin-bottom:18px;color:#1A1918;">' + renderTourMarkdown_(step.body || '') + '</div>' +
        '<div style="display:flex;gap:8px;align-items:center;">' +
          (idx > 1 ? '<button type="button" id="tmb-tour-prev" style="padding:8px 14px;border:1px solid #D6D2C7;border-radius:6px;background:#FFFFFF;color:#1A1918;cursor:pointer;font:inherit;font-size:13px;">← Back</button>' : '') +
          '<button type="button" id="tmb-tour-close" style="padding:8px 12px;border:0;background:transparent;color:#777775;cursor:pointer;font:inherit;font-size:12px;text-decoration:underline;">Skip tour</button>' +
          '<button type="button" id="tmb-tour-next" style="margin-left:auto;padding:8px 18px;border:0;border-radius:6px;background:#1E7A47;color:#fff;cursor:pointer;font:inherit;font-size:13px;font-weight:600;">' + (idx < total ? 'Next →' : 'Done ✓') + '</button>' +
        '</div>' +
      '</div>';

    overlay.appendChild(bubble);
    // Position the bubble after it's in the DOM so we can measure it.
    requestAnimationFrame(function () {
      var bw = bubble.offsetWidth, bh = bubble.offsetHeight;
      var vw = window.innerWidth, vh = window.innerHeight;
      // Sticky coach-nav pushes the top edge of usable space down.
      var stickyTop = 0;
      var nav2 = document.querySelector('.coach-nav');
      if (nav2) {
        var ns2 = getComputedStyle(nav2);
        if (ns2.position === 'sticky' || ns2.position === 'fixed') {
          stickyTop = nav2.getBoundingClientRect().height;
        }
      }
      var top, left;
      if (rect) {
        // Space available on each side of the highlight.
        var spaceTop    = rect.y - stickyTop - 12;
        var spaceBottom = vh - (rect.y + rect.h) - 12;
        var spaceLeft   = rect.x - 12;
        var spaceRight  = vw - (rect.x + rect.w) - 12;
        var placement = step.placement || 'bottom';
        function fits(p) {
          if (p === 'top')    return spaceTop    >= bh;
          if (p === 'bottom') return spaceBottom >= bh;
          if (p === 'left')   return spaceLeft   >= bw;
          if (p === 'right')  return spaceRight  >= bw;
          return false;
        }
        if (!fits(placement)) {
          var alt = ['bottom', 'top', 'right', 'left'].filter(function (p) { return fits(p); });
          if (alt.length) placement = alt[0];
          else placement = 'corner';
        }
        if (placement === 'bottom') { top = rect.y + rect.h + 12; left = rect.x + rect.w / 2 - bw / 2; }
        else if (placement === 'top') { top = rect.y - bh - 12; left = rect.x + rect.w / 2 - bw / 2; }
        else if (placement === 'right') { top = rect.y + rect.h / 2 - bh / 2; left = rect.x + rect.w + 12; }
        else if (placement === 'left') { top = rect.y + rect.h / 2 - bh / 2; left = rect.x - bw - 12; }
        else {
          // Corner mode for huge highlights, bottom-right keeps the
          // top-left of the highlighted content (titles, headers)
          // clear so the user can still read what we're describing.
          top = vh - bh - 16;
          left = vw - bw - 16;
        }
        if (top < stickyTop + 12) top = stickyTop + 12;
        if (top + bh > vh - 12) top = vh - bh - 12;
        if (left < 12) left = 12;
        if (left + bw > vw - 12) left = vw - bw - 12;
      } else {
        top = vh / 2 - bh / 2;
        left = vw / 2 - bw / 2;
      }
      bubble.style.top = top + 'px';
      bubble.style.left = left + 'px';
      // Fade + slight rise once positioned so the bubble doesn't
      // appear-then-jump. Second rAF ensures the transition runs.
      requestAnimationFrame(function () {
        bubble.style.opacity = '1';
        bubble.style.transform = 'translateY(0) scale(1)';
      });
    });

    // Skip / Esc → restore prior state, leave scroll alone. Done →
    // restore prior state AND scroll back to the top (clean landing).
    bubble.querySelector('#tmb-tour-close').addEventListener('click', function () {
      closeTmbTour_({ restore: true });
    });
    bubble.querySelector('#tmb-tour-next').addEventListener('click', function () {
      tmbTourState_.stepIdx++;
      if (tmbTourState_.stepIdx >= tour.steps.length) {
        closeTmbTour_({ restore: true, toTop: true });
      } else {
        renderTmbTourStep_();
      }
    });
    var prevBtn = bubble.querySelector('#tmb-tour-prev');
    if (prevBtn) prevBtn.addEventListener('click', function () {
      tmbTourState_.stepIdx = Math.max(0, tmbTourState_.stepIdx - 1);
      renderTmbTourStep_();
    });
    var esc = function (e) {
      if (e.key === 'Escape') {
        closeTmbTour_({ restore: true });
        document.removeEventListener('keydown', esc);
      }
    };
    document.addEventListener('keydown', esc);
  }

  function setTierBodyClasses_(role) {
    var b = document.body || document.querySelector('body');
    if (!b) return;
    b.classList.remove('tmb-tier-premium', 'tmb-tier-admin');
    var r = String(role || '').toLowerCase();
    if (r === 'admin')   { b.classList.add('tmb-tier-premium', 'tmb-tier-admin'); }
    else if (r === 'premium') { b.classList.add('tmb-tier-premium'); }
    // 'base' (or anything else) → no tier class, LLM zone hidden.
  }

  // Esc-anywhere kill switch for any stuck overlay. Installed up here
  // for the same reason, wants to survive any error further down.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var anyKilled = false;
    ['#coach-insights-overlay', '#coach-demo-ready-modal', '#coach-open-demo-pill', '#coach-fallback-open'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) { el.remove(); anyKilled = true; }
    });
    if (anyKilled) e.preventDefault();
  });

  var STORAGE_KEY = 'tmb_coach_token';
  var root = document.getElementById('coach-root');
  // Endpoint is injected by the Liquid section via data-endpoint
  // on #coach-root so this whole IIFE can live in an external
  // .js asset (no per-render Liquid interpolation needed).
  var ENDPOINT = (root && root.getAttribute('data-endpoint')) || '';

  if (!ENDPOINT) {
    root.innerHTML = '<p class="meta">Coach page not configured. Add the Apps Script /exec URL in the section settings.</p>';
    return;
  }

  var state = {
    token: localStorage.getItem(STORAGE_KEY) || '',
    info: null,         // response from coachInfo
    showNewAthlete: false,
    showNewGroup: false,
    showNewTrainer: false,
    showIntake: false,
    showFromIntake: false,
    intakeParsed: null,  // { name, timeZone } pulled from a parsed intake.md
    intakeSeed:   '',    // raw intake markdown to seed Athlete Context
    // Pending group-form member rows. Each entry is { name, email }; we
    // store them on state so re-renders preserve input across +Add /
    // remove clicks. Defaults to two empty rows.
    newGroupMembers: [{ name: '', email: '' }, { name: '', email: '' }],
    error: '',
    view: 'home',       // 'home' | 'preferences'
    // Admin dashboard table, search, sort, filter, overflow menu state.
    adminSearch: '',
    adminSort: { column: 'lastActivity', dir: 'desc' },
    adminFilters: { active: true, blocked: true, archived: false },
    openOverflow: null,  // athleteToken whose ⋯ menu is open, or null
  };
  // Boot-time URL param handling:
  //   ?view=preferences , switch to email-prefs view
  //   ?token=<token>: auto-sign-in (e.g. from "Confirm email & sign in"
  //                        button in the welcome email). Saves to localStorage,
  //                        strips the param.
  //   ?confirm=1: when paired with ?token=, fires a fire-and-forget
  //                        request to the multi-tenant /exec to flip
  //                        Email Confirmed = true + subscribe Klaviyo.
  //                        Doesn't block sign-in, runs in background.
  var pendingConfirmToken = '';
  try {
    var qs = new URLSearchParams(window.location.search);
    var v = (qs.get('view') || '').toLowerCase();
    if (v === 'preferences') state.view = 'preferences';

    var urlToken = (qs.get('token') || '').trim();
    if (urlToken) {
      state.token = urlToken;
      try { localStorage.setItem(STORAGE_KEY, urlToken); } catch (e) {}
      if ((qs.get('confirm') || '') === '1') pendingConfirmToken = urlToken;
    }

    if (urlToken) {
      // Strip params so a refresh / share doesn't leak the token.
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('token');
        url.searchParams.delete('confirm');
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
  } catch (e) {}
  // Fire-and-forget background confirmation. Runs after DOM ready so any
  // failures don't block sign-in. Server is idempotent, re-confirming a
  // previously-confirmed trainer is a no-op.
  if (pendingConfirmToken) {
    document.addEventListener('DOMContentLoaded', function () {
      try {
        fetch(ENDPOINT + '?action=confirmEmail&type=trainer&token=' +
          encodeURIComponent(pendingConfirmToken), { method: 'GET', mode: 'no-cors' });
      } catch (e) {}
    });
  }
  function setView(v) {
    state.view = v;
    try {
      var url = new URL(window.location.href);
      if (v === 'home') url.searchParams.delete('view');
      else url.searchParams.set('view', v);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
    render();
  }

  function toast(msg, ms) {
    var el = document.createElement('div');
    el.className = 'coach-toast visible';
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(function () { el.classList.remove('visible'); }, ms || 3000);
    setTimeout(function () { el.remove(); }, (ms || 3000) + 400);
  }

  // ── Bug report modal ──────────────────────────────────────────────────
  // Lazy-built once per page load. POSTs through the trainer dispatcher
  // (action: 'reportBug') which routes to handleReportBugTrainerAction_
  // → shared handleReportBug_ → Drive folder + admin email.
  function openCoachBugModal() {
    var existing = document.getElementById('coach-bug-modal');
    if (existing) { existing.classList.add('open'); return existing; }
    var modal = document.createElement('div');
    modal.id = 'coach-bug-modal';
    modal.className = 'coach-bug-overlay';
    modal.innerHTML =
      '<div class="coach-bug-card">' +
        '<div class="coach-bug-head">' +
          '<div>' +
            '<div class="coach-bug-eyebrow">Report a bug</div>' +
            '<div class="coach-bug-title">Tell us what went wrong</div>' +
          '</div>' +
          '<button type="button" class="coach-bug-close" aria-label="Close" data-bug-close>×</button>' +
        '</div>' +
        '<form>' +
          '<label class="coach-bug-label">What happened?' +
            '<textarea name="description" rows="6" required ' +
              'placeholder="Tell us what you were trying to do, what you saw, and anything that looks wrong."></textarea>' +
          '</label>' +
          '<label class="coach-bug-label">Attach a screenshot (optional)' +
            '<input type="file" name="image" accept="image/*">' +
          '</label>' +
          '<div class="coach-bug-status" data-bug-status></div>' +
          '<button type="submit" class="coach-bug-submit">Send report</button>' +
        '</form>' +
      '</div>';
    var coachRoot = document.querySelector('.coach-root') || document.body;
    coachRoot.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.dataset.bugClose != null) modal.classList.remove('open');
    });

    var form = modal.querySelector('form');
    var statusEl = modal.querySelector('[data-bug-status]');
    var submitBtn = modal.querySelector('.coach-bug-submit');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var desc = (form.elements['description'].value || '').trim();
      if (!desc) {
        statusEl.textContent = 'Please describe the bug.';
        statusEl.dataset.kind = 'error';
        form.elements['description'].focus();
        return;
      }
      var fileInp = form.elements['image'];
      var file = fileInp && fileInp.files && fileInp.files[0];
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';
      statusEl.textContent = '';
      var send = function (imageDataUrl, imageFilename) {
        postAction('reportBug', {
          description:   desc,
          imageDataUrl:  imageDataUrl || '',
          imageFilename: imageFilename || '',
          metadata:      collectCoachBugMetadata(),
        }).then(function (res) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Send report';
          if (!res || !res.ok) {
            statusEl.dataset.kind = 'error';
            statusEl.textContent = 'Send failed: ' + ((res && res.error) || 'unknown') + '. Please try again.';
            return;
          }
          statusEl.dataset.kind = 'ok';
          statusEl.textContent = 'Thanks. Bug ' + res.bugNumber + ' filed. The team will take a look.';
          form.reset();
          setTimeout(function () { modal.classList.remove('open'); }, 1800);
        }).catch(function (err) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Send report';
          statusEl.dataset.kind = 'error';
          statusEl.textContent = 'Send failed: ' + (err && err.message || 'network error');
        });
      };
      if (file) {
        readAndResizeBugImage(file, 1600, 0.85, function (dataUrl) {
          send(dataUrl, file.name || 'screenshot.jpg');
        });
      } else {
        send('', '');
      }
    });

    modal.classList.add('open');
    setTimeout(function () {
      var ta = modal.querySelector('textarea[name="description"]');
      if (ta) ta.focus();
    }, 50);
    return modal;
  }

  function collectCoachBugMetadata() {
    var meta = {};
    try { meta.url = String(location.href); } catch (e) {}
    try { meta.userAgent = String(navigator.userAgent); } catch (e) {}
    try { meta.viewport = String(window.innerWidth) + 'x' + String(window.innerHeight); } catch (e) {}
    try {
      if (state && state.info && state.info.trainer) {
        meta.trainerName = String(state.info.trainer.name || '');
        meta.trainerRole = String(state.info.trainer.role || '');
      }
      meta.view = String(state && state.view || '');
    } catch (e) {}
    return meta;
  }

  function readAndResizeBugImage(file, maxDim, quality, cb) {
    var fr = new FileReader();
    fr.onload = function () {
      var img = new Image();
      img.onload = function () {
        try {
          var w = img.naturalWidth, h = img.naturalHeight;
          var scale = Math.min(1, maxDim / Math.max(w, h));
          var cw = Math.round(w * scale), ch = Math.round(h * scale);
          var canvas = document.createElement('canvas');
          canvas.width = cw; canvas.height = ch;
          canvas.getContext('2d').drawImage(img, 0, 0, cw, ch);
          cb(canvas.toDataURL('image/jpeg', quality));
        } catch (e) {
          cb(String(fr.result || ''));
        }
      };
      img.onerror = function () { cb(String(fr.result || '')); };
      img.src = String(fr.result || '');
    };
    fr.onerror = function () { cb(''); };
    fr.readAsDataURL(file);
  }

  // ── Plan export / import helpers ──────────────────────────────────
  // Tabs the trainer can export / import. Order matters: matches the
  // server's PLAN_AUTHORING_TABS_ for round-trip stability.
  var PLAN_TABS_ = [
    'Import', 'Weeks', 'Day Notes', 'Block Overview',
    'Roadmap', 'Checkpoints', 'Injury Management', 'Categories',
    'Programmed Sets',
    // Non-programme tabs, handled separately server-side but match
    // by filename here so the trainer can drop in LLM bundle CSVs.
    'Athlete Context', 'Update Log', 'Movements',
  ];

  // Trigger a browser download of a CSV blob.
  function downloadCsv_(filename, content) {
    var blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click();
    setTimeout(function () { URL.revokeObjectURL(url); a.remove(); }, 1000);
  }

  // Match a filename to one of the PLAN_TABS_ entries, ignoring case
  // and non-alphanumerics. Returns the canonical tab name or null.
  function matchTabFromFilename_(name) {
    // Normalise: strip extension, lowercase, drop any leading digits +
    // separator (export prefixes like "07-"), and strip trailing
    // suffixes the export adds ("current" / "recent"). This lets the
    // bundle's downloaded shape (e.g. "07-import.current.csv") re-import
    // directly without renaming.
    var stem = String(name || '').replace(/\.csv$/i, '').toLowerCase();
    stem = stem.replace(/^\d+[\s_\-.]+/, '');           // drop "07-" / "10_" / etc.
    stem = stem.replace(/[\s_\-.]+(current|recent)$/, '');  // drop ".current" / "-recent"
    var normalised = stem.replace(/[^a-z0-9]+/g, '');
    for (var i = 0; i < PLAN_TABS_.length; i++) {
      var canonical = PLAN_TABS_[i].toLowerCase().replace(/[^a-z0-9]+/g, '');
      if (normalised === canonical || normalised.endsWith(canonical)) return PLAN_TABS_[i];
    }
    return null;
  }

  // Read a File as UTF-8 text. Returns a Promise.
  function readFileAsText_(file) {
    return new Promise(function (resolve, reject) {
      var fr = new FileReader();
      fr.onload = function () { resolve(String(fr.result || '')); };
      fr.onerror = function () { reject(new Error('read failed: ' + file.name)); };
      fr.readAsText(file);
    });
  }

  // Import-plan modal, multi-file picker, mode selector, preview of
  // matched tabs, confirm + submit.
  // Force-close any open overflow menu without re-rendering. Used by
  // overflow-menu click handlers that open a modal, re-rendering
  // would wipe the freshly-opened modal, and the document-level
  // click handler explicitly skips closing the menu when a modal is
  // up. So clear the state + strip the menu DOM directly.
  function closeOpenOverflowMenu_() {
    state.openOverflow = null;
    document.querySelectorAll('.admin-overflow-menu').forEach(function (m) { m.remove(); });
  }

  function openImportPlanModal_(athleteToken, athleteName) {
    closeOpenOverflowMenu_();
    var overlay = document.createElement('div');
    overlay.className = 'athlete-edit-overlay';
    overlay.innerHTML =
      '<div class="athlete-edit-drawer" style="max-width:520px;">' +
      '<h3>Import plan for ' + escapeHtml(athleteName) + '</h3>' +
      '<p style="color:var(--note);font-size:13px;margin:0 0 14px;line-height:1.5;">' +
      'Pick one or more CSV files. Each filename should contain the tab name (e.g. <code>import.csv</code>, <code>weeks.csv</code>, <code>programmed-sets.csv</code>, <code>movements.csv</code>, <code>athlete-context.csv</code>, <code>update-log.csv</code>). ' +
      'At least one CSV is required.<br><br>' +
      'The current plan is archived (recoverable) before the new one is written. ' +
      '<strong>Athlete Context</strong> replaces; <strong>Update Log</strong> appends. ' +
      'Click <strong>Preview changes</strong> first to dry-run without writing anything.' +
      '</p>' +
      '<label>CSV files</label>' +
      '<div id="ip-dropzone" class="ip-dropzone" tabindex="0">' +
        '<div class="ip-dropzone-icon">📂</div>' +
        '<div class="ip-dropzone-main">Drop CSVs here, or <span class="ip-dropzone-link">click to pick</span></div>' +
        '<div class="ip-dropzone-sub">Filenames must contain a tab name (import.csv, weeks.csv, etc.)</div>' +
      '</div>' +
      '<input id="ip-files" type="file" accept=".csv" multiple hidden>' +
      '<div id="ip-matched" style="color:var(--note);font-size:12px;min-height:28px;margin:8px 0;"></div>' +
      '<label style="display:flex;align-items:center;gap:8px;font-size:13px;color:var(--heading);font-weight:500;margin:14px 0 4px;cursor:pointer;text-transform:none;letter-spacing:0;">' +
      '<input id="ip-preserve" type="checkbox" checked style="margin:0;width:16px;height:16px;cursor:pointer;">' +
      'Preserve past sessions (recommended)' +
      '</label>' +
      '<p style="color:var(--note);font-size:12px;margin:0 0 14px 24px;line-height:1.45;">' +
      'When checked, sessions and weeks dated <strong>today or earlier</strong> are kept verbatim from the current plan ' +
      '(same session IDs → ticks, notes, sets all preserved). Only <strong>tomorrow onwards</strong> is replaced from the CSV. ' +
      'Uncheck to wipe and replace the entire plan from scratch.' +
      '</p>' +
      '<div class="athlete-edit-actions">' +
      '<button class="secondary" id="ip-cancel">Cancel</button>' +
      '<button class="secondary" id="ip-preview" disabled>Preview changes</button>' +
      '<button id="ip-submit" disabled>Import</button>' +
      '</div>' +
      '<div id="ip-preview-result" style="margin-top:12px;"></div>' +
      '</div>';
    var coachRoot = document.querySelector('.coach-root') || document.body;
    coachRoot.appendChild(overlay);

    var fileInput  = overlay.querySelector('#ip-files');
    var matchedEl  = overlay.querySelector('#ip-matched');
    var submitBtn  = overlay.querySelector('#ip-submit');
    var previewBtn = overlay.querySelector('#ip-preview');
    var previewEl  = overlay.querySelector('#ip-preview-result');
    var picked     = []; // [{tab, file}]

    function close() { overlay.remove(); }
    overlay.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target === overlay) close();
    });
    overlay.addEventListener('mousedown', function (e) { e.stopPropagation(); });
    overlay.querySelector('#ip-cancel').addEventListener('click', close);

    // Shared handler so drag-drop + click-to-pick both feed the same
    // matched-list / submit-gate logic.
    function processFiles(files) {
      picked = [];
      var lines = [];
      var seenTabs = {}; // (Audit Q15) refuse duplicate tab routes
      Array.from(files || []).forEach(function (f) {
        var tab = matchTabFromFilename_(f.name);
        if (tab) {
          if (seenTabs[tab]) {
            lines.push('⚠️ ' + escapeHtml(f.name) + '. ALREADY have a CSV for <strong>' + tab + '</strong> (' + escapeHtml(seenTabs[tab]) + '). Drop only ONE file per tab.');
            return;
          }
          seenTabs[tab] = f.name;
          picked.push({ tab: tab, file: f });
          lines.push('✓ ' + escapeHtml(f.name) + ' → <strong>' + tab + '</strong>');
        } else {
          lines.push('✗ ' + escapeHtml(f.name) + '. No tab match, skipped');
        }
      });
      if (picked.length) {
        var tabsPicked = picked.map(function (p) { return p.tab; }).join(', ');
        lines.push(
          '<div style="margin-top:8px;padding:8px 10px;background:#E8F0F8;border:1px solid #B5CEE5;border-radius:6px;color:#1E4569;font-size:12px;">' +
            'Will replace: <strong>' + escapeHtml(tabsPicked) + '</strong>. Other tabs (Categories, Settings, etc.) stay unchanged.' +
          '</div>'
        );
      }
      matchedEl.innerHTML = lines.join('<br>');
      submitBtn.disabled = !picked.length;
      previewBtn.disabled = !picked.length;
      submitBtn.title = picked.length
        ? 'Run the import'
        : 'Pick at least one CSV that matches a tab name (Import, Weeks, Roadmap, Block Overview, Day Notes, Checkpoints, Injury Management, Categories, Athlete Context, or Update Log)';
      previewBtn.title = picked.length
        ? 'Run a dry-run that shows what would change. Without writing anything'
        : 'Pick at least one CSV first';
      // Reset the preview pane when the file selection changes, old
      // preview is stale.
      previewEl.innerHTML = '';
    }

    fileInput.addEventListener('change', function () { processFiles(fileInput.files); });

    // Drop-zone: click to open the file picker; drag-drop CSV files
    // straight in. dragover/dragenter need preventDefault to let the
    // drop event fire. is-hover class gives visual feedback while
    // the user hovers a valid drag.
    var dropzone = overlay.querySelector('#ip-dropzone');
    if (dropzone) {
      dropzone.addEventListener('click', function () { fileInput.click(); });
      dropzone.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); fileInput.click(); }
      });
      ['dragenter', 'dragover'].forEach(function (evt) {
        dropzone.addEventListener(evt, function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          dropzone.classList.add('is-hover');
        });
      });
      ['dragleave', 'dragend'].forEach(function (evt) {
        dropzone.addEventListener(evt, function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          dropzone.classList.remove('is-hover');
        });
      });
      dropzone.addEventListener('drop', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        dropzone.classList.remove('is-hover');
        var files = ev.dataTransfer && ev.dataTransfer.files;
        if (!files || !files.length) return;
        processFiles(files);
      });
    }

    // Read the picked files into a { tab → csv text } map. Shared by
    // the Preview (dry-run) and Import paths.
    function readPickedCsvs_() {
      return Promise.all(picked.map(function (p) {
        return readFileAsText_(p.file).then(function (text) {
          return { tab: p.tab, text: text };
        });
      })).then(function (results) {
        var csvs = {};
        results.forEach(function (r) { csvs[r.tab] = r.text; });
        return csvs;
      });
    }

    previewBtn.addEventListener('click', function () {
      if (!picked.length) return;
      var preserve = !!overlay.querySelector('#ip-preserve').checked;
      previewBtn.disabled = true; previewBtn.textContent = 'Validating…';
      previewEl.innerHTML =
        '<div style="padding:10px 12px;background:#F4F0E5;border:1px solid #D9CFAE;border-radius:6px;color:#5E4F1E;font-size:13px;">' +
          'Reading files + checking schema… this usually takes a few seconds.' +
        '</div>';
      readPickedCsvs_().then(function (csvs) {
        return postAction('importPlan', {
          athleteToken: athleteToken,
          preservePast: preserve,
          csvs:         csvs,
          dryRun:       true,
        });
      }).then(function (j) {
        previewBtn.disabled = false; previewBtn.textContent = 'Preview changes';
        if (!j.ok) {
          previewEl.innerHTML =
            '<div style="padding:10px 12px;background:#FCE4DC;border:1px solid #E8B5A4;border-radius:6px;color:#5E2419;font-size:13px;">' +
              '<strong>Preview failed:</strong> ' + escapeHtml(j.error || 'unknown') +
            '</div>';
          return;
        }
        previewEl.innerHTML = renderImportPreview_(j);
      }).catch(function (e) {
        previewBtn.disabled = false; previewBtn.textContent = 'Preview changes';
        previewEl.innerHTML =
          '<div style="padding:10px 12px;background:#FCE4DC;border:1px solid #E8B5A4;border-radius:6px;color:#5E2419;font-size:13px;">' +
            '<strong>Network error:</strong> ' + escapeHtml(e.message) +
          '</div>';
      });
    });

    submitBtn.addEventListener('click', function () {
      var preserve = !!overlay.querySelector('#ip-preserve').checked;
      var msg = preserve
        ? 'Update ' + athleteName + '\'s plan from tomorrow onwards?\n\n' +
          'Past + current sessions are kept exactly as they are (same IDs, ticks and notes intact). ' +
          'Only sessions dated tomorrow onwards are replaced from the CSV.\n\n' +
          'A snapshot of the current plan is also archived to hidden tabs (recoverable any time).\n\n' +
          'Proceed?'
        : 'Replace ' + athleteName + '\'s ENTIRE plan?\n\n' +
          'All current sessions, weeks, blocks, day notes, roadmap, checkpoints, ticks and ' +
          'per-set logs will be archived (recoverable) and replaced wholesale by the CSV.\n\n' +
          'Past tick history will be moved to the archive. The new plan starts with an empty ' +
          'progress slate. Use this only when you genuinely want a from-scratch reset.\n\n' +
          'Proceed?';
      if (!confirm(msg)) return;
      submitBtn.disabled = true; submitBtn.textContent = 'Reading files…';
      // Big imports can take 30-60 s (Drive copy + N tabs of setValues
      // calls). Without a visible status the trainer thinks the page
      // froze. Surface a hint that this is normal.
      matchedEl.innerHTML =
        '<div style="margin-top:8px;padding:10px 12px;background:#E8F0F8;border:1px solid #B5CEE5;border-radius:6px;color:#1E4569;font-size:13px;line-height:1.5;">' +
          '<strong>Importing…</strong> this can take 30-60 seconds because the server is ' +
          'archiving the current programme (recoverable), then writing each tab cell-by-cell. ' +
          'Don\'t close this window. We\'ll surface a result when it\'s done.' +
        '</div>';
      readPickedCsvs_().then(function (csvs) {
        submitBtn.textContent = 'Importing…';
        return postAction('importPlan', { athleteToken: athleteToken, preservePast: preserve, csvs: csvs });
      }).then(function (j) {
        if (!j.ok) {
          submitBtn.disabled = false; submitBtn.textContent = 'Import';
          matchedEl.innerHTML =
            '<div style="margin-top:8px;padding:10px 12px;background:#FCE4DC;border:1px solid #E8B5A4;border-radius:6px;color:#5E2419;font-size:13px;line-height:1.5;">' +
              '<strong>Import failed:</strong> ' + escapeHtml(j.error || 'unknown') +
            '</div>';
          toast('Import failed: ' + (j.error || 'unknown'));
          return;
        }
        // Per-tab failure surfacing, server's `writes` array carries
        // 'X: failed, ...' strings when a single tab errors mid-import;
        // without scanning these, the trainer sees a green "Imported"
        // toast and never knows a tab silently failed. (Audit H5.)
        var writes  = j.writes || [];
        var failed  = writes.filter(function (w) { return /:\s*failed/i.test(w); });
        // Warnings (server returns `warnings` for auditing-integrity
        // gaps + Publish-Date heuristic + Movement/Session orphans).
        // Render alongside the toast so they're visible on success too.
        // (Audit H6.)
        var warnings = j.warnings || [];
        if (failed.length || warnings.length) {
          var html = [];
          if (failed.length) {
            html.push('<div style="margin-top:8px;padding:10px 12px;background:#FCE4DC;border:1px solid #E8B5A4;border-radius:6px;color:#5E2419;font-size:13px;line-height:1.5;">');
            html.push('<strong>' + failed.length + ' tab(s) failed mid-import:</strong><ul style="margin:6px 0 0;padding-left:20px;">');
            failed.forEach(function (w) { html.push('<li>' + escapeHtml(w) + '</li>'); });
            html.push('</ul></div>');
          }
          if (warnings.length) {
            html.push('<div style="margin-top:8px;padding:10px 12px;background:#FFF8E1;border:1px solid #F0D080;border-radius:6px;color:#5E4A19;font-size:13px;line-height:1.5;">');
            html.push('<strong>' + warnings.length + ' warning(s). Import succeeded but worth reviewing:</strong><ul style="margin:6px 0 0;padding-left:20px;">');
            warnings.forEach(function (w) { html.push('<li>' + escapeHtml(w) + '</li>'); });
            html.push('</ul></div>');
          }
          matchedEl.innerHTML = html.join('');
          submitBtn.textContent = 'Done. Review messages above';
          submitBtn.disabled = true;
          toast(failed.length ? 'Imported with ' + failed.length + ' tab failure(s)' : 'Imported. ' + warnings.length + ' warning(s)');
          fetchInfo().then(function (j2) { state.info = j2; writeInfoCache(j2); render(); }).catch(function () {});
          return;
        }
        close();
        toast('Imported. Programme ' + j.programme + ', ' + writes.length + ' tabs written');
        fetchInfo().then(function (j2) { state.info = j2; writeInfoCache(j2); render(); }).catch(function () {});
      }).catch(function (e) {
        submitBtn.disabled = false; submitBtn.textContent = 'Import';
        matchedEl.innerHTML =
          '<div style="margin-top:8px;padding:10px 12px;background:#FCE4DC;border:1px solid #E8B5A4;border-radius:6px;color:#5E2419;font-size:13px;line-height:1.5;">' +
            '<strong>Network error:</strong> ' + escapeHtml(e.message) +
          '</div>';
        toast('Error: ' + e.message);
      });
    });
  }

  // Format the dry-run response from importPlan into a compact summary
  // table. Authoring tabs show preserved-past vs written-future row
  // counts; non-programme tabs (Athlete Context = replace, Update Log
  // = append) show their own write summaries.
  function renderImportPreview_(j) {
    var tabs = j.tabs || [];
    var warnings = j.warnings || [];
    var rows = tabs.map(function (t) {
      var detail = '';
      if (t.mode === 'authoring') {
        detail = '<strong>' + t.writtenFuture + '</strong> future row' + (t.writtenFuture === 1 ? '' : 's') + ' from CSV' +
                 (j.preservePast ? ' + <strong>' + t.preservedPast + '</strong> past row' + (t.preservedPast === 1 ? '' : 's') + ' preserved' : ' (preserve-past off: full replace)') +
                 ' &nbsp;<span style="opacity:0.65;">(was ' + t.liveRows + ')</span>';
        if ((t.unknownColumns || []).length) {
          detail += '<br><span style="color:#8B5E1E;font-size:11px;">⚠ unknown columns will be added: ' + t.unknownColumns.map(escapeHtml).join(', ') + '</span>';
        }
      } else if (t.mode === 'replace') {
        detail = '<strong>' + (t.wordsApprox || 0) + '</strong> words (' + (t.chars || 0) + ' chars). <em>replaces current cell</em>';
      } else if (t.mode === 'append') {
        detail = '<strong>+' + t.appending + '</strong> row' + (t.appending === 1 ? '' : 's') + ' appended &nbsp;<span style="opacity:0.65;">(' + t.currentRows + ' → ' + t.resultingRows + ')</span>';
      }
      return '<tr>' +
        '<td style="padding:4px 8px;font-weight:600;white-space:nowrap;">' + escapeHtml(t.tab) + '</td>' +
        '<td style="padding:4px 8px;">' + detail + '</td>' +
        '</tr>';
    }).join('');
    var warnBlock = warnings.length
      ? '<div style="margin-top:10px;padding:8px 12px;background:#FBF1D9;border:1px solid #D9C880;border-radius:6px;color:#6B5418;font-size:12px;line-height:1.5;">' +
          '<strong>Warnings:</strong><ul style="margin:4px 0 0;padding-left:18px;">' +
            warnings.map(function (w) { return '<li>' + escapeHtml(w) + '</li>'; }).join('') +
          '</ul>' +
        '</div>'
      : '';
    // Per-week density diff, surface "LLM dropped sessions from w7-w10"
    // in a scannable bar-chart format. Each week shows live count on
    // top, csv count on bottom, with red highlight for >40% drops.
    // (Skeleton-first follow-up, 2026-06-14.)
    var perWeekBlock = '';
    var pwd = j.perWeekDiff;
    if (pwd && Object.keys(pwd).length) {
      var weekKeys = Object.keys(pwd).sort(function (a, b) {
        var na = parseInt(a.replace('w','')) || 0;
        var nb = parseInt(b.replace('w','')) || 0;
        return na - nb;
      });
      var maxCount = 0;
      weekKeys.forEach(function (k) {
        if (pwd[k].live > maxCount) maxCount = pwd[k].live;
        if (pwd[k].csv > maxCount)  maxCount = pwd[k].csv;
      });
      var bars = weekKeys.map(function (k) {
        var d = pwd[k];
        var liveW = maxCount ? Math.round(100 * d.live / maxCount) : 0;
        var csvW  = maxCount ? Math.round(100 * d.csv / maxCount) : 0;
        var critical = (d.live >= 5 && d.csv === 0) || (d.live >= 10 && d.pct <= -40);
        var pctTag = d.live === 0
          ? '<span style="color:#1E7A47;">+new</span>'
          : (d.delta === 0
              ? '<span style="opacity:0.5;">same</span>'
              : (d.delta > 0
                  ? '<span style="color:#1E7A47;">+' + d.delta + '</span>'
                  : '<span style="color:#A02828;font-weight:600;">' + d.delta + ' (' + d.pct + '%)</span>'));
        var barColour = critical ? '#A02828' : (d.delta >= 0 ? '#3A8C5A' : '#C8804A');
        return '<tr>' +
          '<td style="padding:2px 6px;font-weight:600;white-space:nowrap;font-family:Menlo,monospace;font-size:11px;">' + escapeHtml(k) + '</td>' +
          '<td style="padding:2px 6px;font-size:11px;color:#888;white-space:nowrap;">' + d.live + ' →</td>' +
          '<td style="padding:2px 6px;width:100%;">' +
            '<div style="background:#EEE;height:6px;border-radius:3px;position:relative;">' +
              '<div style="background:' + barColour + ';height:6px;border-radius:3px;width:' + csvW + '%;"></div>' +
            '</div>' +
          '</td>' +
          '<td style="padding:2px 6px;font-size:11px;white-space:nowrap;">' + d.csv + ' &nbsp;' + pctTag + '</td>' +
          '</tr>';
      }).join('');
      perWeekBlock =
        '<div style="margin-top:10px;padding:10px 12px;background:#FAFAFA;border:1px solid #D8D8D2;border-radius:6px;font-size:13px;line-height:1.5;">' +
          '<div style="font-weight:600;margin-bottom:6px;color:#1A1918;">Per-week session count (live → CSV)</div>' +
          '<table style="width:100%;border-collapse:collapse;">' + bars + '</table>' +
          '<div style="margin-top:6px;font-size:11px;opacity:0.7;">Red bars = >40% drop or to zero. Spot weeks the LLM may have under-authored before you commit.</div>' +
        '</div>';
    }
    var preserveLabel = j.preservePast
      ? 'Preserve past on (cutoff ' + escapeHtml(j.cutoff || '') + ')'
      : 'Preserve past OFF. Full replace';
    return '<div style="padding:10px 12px;background:#E8F0F8;border:1px solid #B5CEE5;border-radius:6px;color:#1E4569;font-size:13px;line-height:1.5;">' +
        '<div style="font-weight:600;margin-bottom:6px;">Preview. Nothing has been written yet. ' + preserveLabel + '.</div>' +
        '<table style="width:100%;font-size:13px;border-collapse:collapse;">' + rows + '</table>' +
        perWeekBlock +
        warnBlock +
        '<div style="margin-top:8px;font-size:12px;opacity:0.8;">Click <strong>Import</strong> below to commit, or change files / preserve-past flag and re-preview.</div>' +
      '</div>';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
  // Alias, same escape rules suffice for attribute values since
  // escapeHtml already covers `"` and `&`. Several call sites use
  // escapeAttr for attribute interpolation; the alias keeps them
  // working without churn.
  var escapeAttr = escapeHtml;

  function formatRelative(d) {
    if (!d) return 'never';
    var dt = new Date(d);
    if (isNaN(dt.getTime())) return '-';
    var s = (Date.now() - dt.getTime()) / 1000;
    if (s < 60) return 'just now';
    if (s < 3600) return Math.floor(s / 60) + ' min ago';
    if (s < 86400) return Math.floor(s / 3600) + ' h ago';
    if (s < 604800) return Math.floor(s / 86400) + ' d ago';
    return dt.toLocaleDateString();
  }

  // Server returns a `coachInfoVersion` stamp; we echo it back on the next
  // poll via `_seen=`. When unchanged the server replies with
  // `{ok:true, notModified:true}` and we serve cached state.info. Most
  // 30s polls collapse to a tiny notModified response. (#65 perf audit F8 / B)
  var _coachInfoVersion = '';
  function fetchInfo() {
    var url = ENDPOINT + '?token=' + encodeURIComponent(state.token) + '&action=coachInfo';
    if (_coachInfoVersion) url += '&_seen=' + encodeURIComponent(_coachInfoVersion);
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j.ok) throw new Error(j.error || 'auth');
        // Server short-circuit: nothing has changed since our last seen
        // version. Return the existing state.info so callers'
        // `state.info = j; writeInfoCache(j); render()` pattern remains a
        // safe no-op (render's signature gate skips when data is stable).
        if (j.notModified) {
          if (j.coachInfoVersion) _coachInfoVersion = String(j.coachInfoVersion);
          return state.info || readInfoCache() || j;
        }
        if (j.coachInfoVersion) _coachInfoVersion = String(j.coachInfoVersion);
        return j;
      });
  }

  function postAction(action, payload) {
    var body = Object.assign({ token: state.token, action: action }, payload || {});
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },  // avoid CORS preflight
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function render() {
    if (!state.token) return renderGate();
    if (state.error) return renderError();
    if (!state.info) {
      root.innerHTML = '<div class="coach-inner"><div class="meta">Loading…</div></div>';
      return;
    }
    // Modal-open guard: any open modal/overlay/form-in-progress should
    // block the re-render so background updates don't wipe what the
    // trainer is typing. Replaces the per-call-site guard that was
    // already on startCoachAutoRefresh_; covers any other path (action
    // handlers, postMessage-style triggers from athlete-page activity,
    // etc.) that could otherwise close an open Import Plan / athlete
    // edit / bug modal. State picks up the fresh data on the next
    // render once the modal is closed.
    if (document.querySelector('.athlete-edit-overlay, .coach-bug-modal')) return;
    if (state.showNewAthlete || state.showNewGroup || state.showNewTrainer ||
        state.showFromIntake || state.showIntake) return;
    var t = state.info.trainer;
    // Drive the tier-aware body classes off the loaded trainer role.
    // Cheap (string compare + classList toggle) so safe to call on
    // every render; tier rarely changes mid-session but role can
    // theoretically flip via admin action.
    setTierBodyClasses_(t && t.role);
    // Make sure the ❓ How to pill is mounted, idempotent, only
    // adds itself once. Lives on document.body so it survives
    // every render of #coach-root.
    var view = state.view;
    var html = [];

    // Sticky top nav, present on every authenticated view.
    html.push('<div class="coach-nav">');
    html.push('<div class="coach-nav-brand">TMB Plan' +
      '<span class="meta-tag">' + escapeHtml(t.role === 'admin' ? 'Admin' : 'Coach') + '</span></div>');
    html.push('<div class="coach-nav-links">' +
      '<button type="button" class="coach-nav-link' + (view === 'home' ? ' is-active' : '') + '" data-view="home">Athletes</button>' +
      '<button type="button" class="coach-nav-link' + (view === 'preferences' ? ' is-active' : '') + '" data-view="preferences">Email preferences</button>' +
      '<button type="button" class="coach-nav-link coach-nav-help" id="coach-nav-help">❓ How to</button>' +
      '<button type="button" class="coach-nav-link" id="coach-signout">Sign out</button>' +
      '</div>');
    html.push('</div>');

    html.push('<div class="coach-inner">');

    if (view === 'preferences') {
      html.push(renderPreferencesView());
    } else {
      html.push(renderHomeView());
    }

    // Bug-report footer, pinned to the bottom of every authenticated
    // coach view. Click opens the modal (built lazily). Submit POSTs
    // through dispatchTrainerAction → handleReportBugTrainerAction_.
    html.push('<div class="tmb-bug-footer coach-bug-footer">' +
      '<button type="button" class="tmb-bug-footer-btn" data-coach-bug-report>🐞 Report a bug</button>' +
      '<div class="tmb-bug-footer-meta">Spotted something off? Send us a quick note + screenshot.</div>' +
      '</div>');

    html.push('</div>');
    // Snapshot the currently-open <details data-key=…> before swapping
    // innerHTML so a render triggered by a button click (block /
    // archive / resend etc.) doesn't collapse every section back to
    // default. Restore right after the DOM is replaced.
    var detailsState = snapshotCoachDetails_();
    root.innerHTML = html.join('\n');
    restoreCoachDetails_(detailsState);
    wireUp();
  }

  // Capture { 'data-key': bool } for every <details> on the page so
  // re-renders preserve the user's open/close state. Trainer blocks,
  // section toggles, athlete email-prefs all use data-key for this.
  function snapshotCoachDetails_() {
    var st = {};
    document.querySelectorAll('details[data-key]').forEach(function (d) {
      st[d.dataset.key] = !!d.open;
    });
    return st;
  }
  function restoreCoachDetails_(st) {
    if (!st) return;
    Object.keys(st).forEach(function (k) {
      var sel = 'details[data-key="' + k.replace(/"/g, '\\"') + '"]';
      var d = document.querySelector(sel);
      if (d) d.open = !!st[k];
    });
  }

  function renderHomeView() {
    var t = state.info.trainer;
    var allMine = state.info.athletes || [];
    // Split solo athletes vs group/gym plans so they render in their
    // own dedicated sections. groupType empty / 'solo' is an athlete;
    // anything else (small_group / large_group / gym) is a group.
    var isGroupPlan = function (a) {
      var gt = String(a.groupType || 'solo').toLowerCase();
      return gt !== 'solo' && gt !== '';
    };
    var athletesMine = allMine.filter(function (a) { return !isGroupPlan(a); });
    var groupsMine   = allMine.filter(isGroupPlan);
    var activeAthletes   = athletesMine.filter(function (a) { return String(a.status || '').toLowerCase() !== 'archived'; });
    var archivedAthletes = athletesMine.filter(function (a) { return String(a.status || '').toLowerCase() === 'archived'; });
    var activeGroups     = groupsMine.filter(function (a) { return String(a.status || '').toLowerCase() !== 'archived'; });

    var metaBits = [];
    metaBits.push(activeAthletes.length + ' athlete' + (activeAthletes.length === 1 ? '' : 's'));
    if (activeGroups.length) {
      metaBits.push(activeGroups.length + ' group' + (activeGroups.length === 1 ? '' : 's'));
    }
    if (archivedAthletes.length) metaBits.push(archivedAthletes.length + ' archived');
    if (t.role === 'admin') {
      var totalActive = (state.info.allAthletes || []).filter(function (a) {
        return String(a.status || '').toLowerCase() !== 'archived';
      }).length;
      metaBits.push(totalActive + ' total in system');
      metaBits.push((state.info.allTrainers || []).length + ' trainers');
    }
    var meta = metaBits.join('  ·  ');
    // Tier badge, small chip next to the name so the trainer knows
    // which features they have. Colour-coded: admin=purple,
    // premium=green, base=grey. Drives no behaviour itself (CSS
    // gates do that); purely informational.
    var tierRole = String(t.role || '').toLowerCase();
    var tierLabel = tierRole === 'admin' ? 'ADMIN'
                  : tierRole === 'premium' ? 'PREMIUM'
                  : 'BASE';
    var tierBg    = tierRole === 'admin' ? '#7e1e9c'
                  : tierRole === 'premium' ? '#1E7A47'
                  : '#777775';
    var html = [
      '<div class="coach-hero">',
      '<h1 style="display:inline-flex;align-items:baseline;gap:10px;">' +
        escapeHtml(t.name || 'Coach') +
        '<span class="coach-tier-badge" style="display:inline-block;background:' + tierBg + ';color:#fff;font-size:10px;font-weight:700;letter-spacing:0.06em;padding:2px 8px;border-radius:999px;vertical-align:middle;">' + tierLabel + '</span>' +
      '</h1>',
      '<div class="meta">' + escapeHtml(meta) + '</div>',
      '</div>',
    ];

    // Order:
    //   1. Your athletes (solo plans)
    //   2. + New Athlete
    //   3. Your groups (small_group / gym / large_group plans)
    //   4. + New Group
    //   5. Admin overview (admins only)
    var trainerByToken = {};
    (state.info.allTrainers || []).forEach(function (tr) { trainerByToken[tr.token] = tr; });
    html.push('<details class="admin-athletes-block" data-key="your-athletes">' +
      '<summary>Your athletes <span class="meta">(' + activeAthletes.length + ')</span></summary>' +
      '<div class="admin-athletes-body">' +
        renderAdminFilters_(athletesMine, 'mine') +
        renderAdminAthletesTable_(athletesMine, trainerByToken, { showTrainer: false, tableKey: 'mine' }) +
      '</div></details>');
    html.push(renderNewAthleteSection());
    // Dedicated groups section, only shows when the trainer has any
    // group/gym plans. Collapsed by default; trainer can expand when
    // they want to manage memberships.
    if (groupsMine.length) {
      html.push('<details class="admin-athletes-block" data-key="your-groups">' +
        '<summary>Your groups & gyms <span class="meta">(' + activeGroups.length + ')</span></summary>' +
        '<div class="admin-athletes-body">' +
          renderAdminAthletesTable_(groupsMine, trainerByToken, { showTrainer: false, tableKey: 'groups' }) +
        '</div></details>');
    }
    html.push(renderNewGroupSection());

    if (t.role === 'admin' && state.info.allTrainers) {
      html.push(renderAdminOverview());
    }
    return html.join('\n');
  }

  function renderPreferencesView() {
    var html = [
      '<div class="coach-hero">',
      '<h1>Email preferences</h1>',
      '<div class="meta">Choose which notifications you and your athletes receive.</div>',
      '</div>',
    ];
    html.push(renderEmailPrefsSection());
    return html.join('\n');
  }

  function renderGate() {
    root.innerHTML =
      '<h1>Coach access</h1>' +
      '<div class="coach-gate">' +
      '<p class="meta">Paste your trainer token to continue.</p>' +
      '<input type="text" id="coach-token-input" placeholder="Trainer token" autocomplete="off">' +
      '<button id="coach-token-submit" style="padding: 10px 22px; border:0; border-radius:4px; background:#1a1918; color:#fff; font-weight:600; cursor:pointer; font-family:inherit;">Continue</button>' +
      '<button type="button" id="coach-forgot-token" class="coach-link-btn">Forgot your token?</button>' +
      '<form id="coach-recover-form" class="coach-recover-form" hidden>' +
        '<input type="email" id="coach-recover-email" placeholder="Your email" autocomplete="email" required>' +
        '<button type="submit" id="coach-recover-submit">Send token</button>' +
        '<div class="coach-recover-status" id="coach-recover-status"></div>' +
      '</form>' +
      '</div>';
    document.getElementById('coach-token-submit').addEventListener('click', signIn);
    var input = document.getElementById('coach-token-input');
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') signIn(); });
    input.focus();

    // "Forgot your token?", expands a one-field form that POSTs the
    // email to recoverTrainerToken. Server returns the same response
    // regardless of whether the email matched (no enumeration leak).
    var forgotBtn = document.getElementById('coach-forgot-token');
    var recoverForm = document.getElementById('coach-recover-form');
    var recoverStatus = document.getElementById('coach-recover-status');
    var recoverSubmit = document.getElementById('coach-recover-submit');
    var recoverEmail = document.getElementById('coach-recover-email');
    forgotBtn.addEventListener('click', function () {
      recoverForm.hidden = false;
      forgotBtn.style.display = 'none';
      setTimeout(function () { recoverEmail.focus(); }, 30);
    });
    recoverForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (recoverEmail.value || '').trim();
      if (!email) { recoverEmail.focus(); return; }
      recoverSubmit.disabled = true;
      recoverSubmit.textContent = 'Sending…';
      recoverStatus.textContent = '';
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({ action: 'recoverTrainerToken', email: email }),
      }).then(function (r) { return r.json(); }).then(function (res) {
        recoverSubmit.disabled = false;
        recoverSubmit.textContent = 'Send token';
        if (!res || !res.ok) {
          recoverStatus.dataset.kind = 'error';
          recoverStatus.textContent = 'Could not send: ' + ((res && res.error) || 'unknown') + '. Please try again.';
          return;
        }
        recoverStatus.dataset.kind = 'ok';
        recoverStatus.textContent = res.message || 'If that email matches a trainer account, we\'ve sent the token.';
      }).catch(function (err) {
        recoverSubmit.disabled = false;
        recoverSubmit.textContent = 'Send token';
        recoverStatus.dataset.kind = 'error';
        recoverStatus.textContent = 'Network error: ' + (err && err.message || 'unknown');
      });
    });
  }

  function renderError() {
    var blocked = /blocked/i.test(state.error || '');
    var headline = blocked ? 'Access suspended' : 'Coach access';
    var msg = blocked
      ? 'Your coach access has been suspended by an admin. If you think this is a mistake, get in touch with the team.'
      : state.error;
    root.innerHTML =
      '<h1>' + escapeHtml(headline) + '</h1>' +
      '<div class="coach-gate">' +
      '<p class="meta" style="color: #b34141;">' + escapeHtml(msg) + '</p>' +
      '<button id="coach-retry" style="padding: 10px 22px; border:0; border-radius:4px; background:#1a1918; color:#fff; font-weight:600; cursor:pointer; font-family:inherit;">' +
      (blocked ? 'Sign out' : 'Try again') + '</button>' +
      '</div>';
    document.getElementById('coach-retry').addEventListener('click', function () {
      state.token = ''; state.error = '';
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      render();
    });
  }

  // Append a query-string segment to a URL without breaking existing query.
  function addQuery_(url, qs) {
    if (!url) return url;
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + qs;
  }

  // Group plan creation. Mirrors the New Athlete form but takes a
  // dynamic member list (each row = name + email). Admins can flip
  // groupType to 'large_group' (broadcast / read-only); regular
  // trainers always create small_group.
  function renderNewGroupSection() {
    if (!state.showNewGroup) {
      return '<div class="coach-toolbar"><button id="coach-show-new-group">+ New Group</button><span></span></div>';
    }
    var role = (state.info && state.info.trainer && state.info.trainer.role) || 'trainer';
    var isAdmin = role === 'admin';
    var memberRows = state.newGroupMembers.map(function (m, i) {
      return '<div class="cg-member-row" data-cg-row="' + i + '">' +
        '<input class="cg-mname" type="text" placeholder="Name" value="' + escapeAttr(m.name || '') + '" autocomplete="off">' +
        '<input class="cg-memail" type="email" placeholder="email@example.com" value="' + escapeAttr(m.email || '') + '" autocomplete="off">' +
        '<button type="button" class="cg-row-remove" data-cg-remove="' + i + '" title="Remove">×</button>' +
      '</div>';
    }).join('');
    // Type selector, visible to every trainer. small_group + gym
    // are open to all; large_group is admin-only because the broadcast
    // shape needs admin moderation tools.
    var typeOptions = [
      '<option value="small_group">Small group (≤50 members, all-write)</option>',
      '<option value="gym">Gym (bookable classes per pill, 200+ members)</option>',
    ];
    if (isAdmin) {
      typeOptions.push('<option value="large_group">Large group (read-only broadcast, admin-only)</option>');
    }
    var typeSelector = '<div><label>Group type</label>' +
      '<select id="cg-type">' + typeOptions.join('') + '</select></div>';
    return '<div class="coach-form" id="coach-new-group-form">' +
      '<h3>New group plan</h3>' +
      '<div class="row">' +
        '<div><label>Group name *</label><input id="cg-name" type="text" placeholder="e.g. Tuesday CrossFit Class" autocomplete="off"></div>' +
        '<div><label>Time zone</label><input id="cg-tz" type="text" value="Europe/London"></div>' +
        typeSelector +
      '</div>' +
      '<div class="cg-members">' +
        '<div class="cg-members-header">' +
          '<label class="cg-members-label">Members</label>' +
          '<div class="cg-members-tools">' +
            '<button type="button" id="cg-bulk-toggle" class="cg-bulk-toggle">📋 Paste CSV</button>' +
            '<button type="button" id="cg-export-csv" class="cg-bulk-toggle">⬇ Download CSV</button>' +
          '</div>' +
        '</div>' +
        '<div class="cg-bulk-area" id="cg-bulk-area" hidden>' +
          '<div class="cg-bulk-help">Paste rows as <code>Name, Email</code> (one per line). Tab-separated works too. Useful when pasting straight from a spreadsheet column pair.</div>' +
          '<textarea id="cg-bulk-csv" placeholder="John Smith, john@example.com&#10;Jane Doe, jane@example.com" rows="6"></textarea>' +
          '<div class="cg-bulk-actions">' +
            '<label class="cg-bulk-replace"><input type="checkbox" id="cg-bulk-replace"> Replace existing rows</label>' +
            '<button type="button" id="cg-bulk-parse" class="cg-bulk-parse">Add to list</button>' +
          '</div>' +
        '</div>' +
        '<div class="cg-member-list" id="cg-member-list">' + memberRows + '</div>' +
        '<button type="button" id="cg-add-member" class="cg-add-member">+ Add member</button>' +
        '<div class="cg-members-help">Each member uses their own email to log in. Small groups + gym: everyone can tick / book / upload. Large groups: members are read-only.</div>' +
      '</div>' +
      '<div class="actions">' +
        '<button id="cg-submit">Create group plan</button>' +
        '<button id="cg-cancel" class="secondary" style="margin-left: 8px;">Cancel</button>' +
      '</div>' +
      '<div id="cg-result"></div>' +
    '</div>';
  }

  function renderNewAthleteSection() {
    if (!state.showNewAthlete) {
      // Toolbar layout, core actions on the left, LLM tooling on
      // the right. Every LLM element carries .tmb-llm-zone so a
      // single body-class flip (tmb-tier-premium) gates Premium-tier
      // features when the two-tier product ships (#35). Today every
      // trainer is implicitly Premium, so the body class is set
      // unconditionally at boot and these buttons all render.
      return '<div class="coach-toolbar">' +
        '<button id="coach-show-new-athlete">+ New Athlete</button>' +
        '<button id="coach-show-demo" class="secondary" title="Open a fully-populated example plan so you can explore before provisioning a real athlete">👤 Try example plan</button>' +
        '<span class="coach-toolbar-sep tmb-llm-zone" aria-hidden="true"></span>' +
        '<button id="coach-show-from-intake" class="secondary tmb-llm-zone" title="Paste a filled-in intake questionnaire. Auto-fills the New Athlete form + seeds Athlete Context">🤖 From intake</button>' +
        '<button id="coach-show-intake" class="secondary tmb-llm-zone" title="Generate an onboarding questionnaire to send to a new athlete">🤖 Intake form ▾</button>' +
        '<span></span>' +
        '</div>' +
        renderFromIntakeSection() +
        renderIntakeFormSection();
    }
    // Pre-fill values come from state.intakeParsed (set by the
    // From-Intake parser). Falls back to empty / sensible defaults so
    // the manual flow still works as before.
    var pre = state.intakeParsed || {};
    var nameVal  = pre.name || '';
    var emailVal = pre.email || '';
    var tzVal    = pre.timeZone || 'Europe/London';
    var notice = state.intakeSeed
      ? '<div class="ca-intake-notice">📥 Pre-filled from intake. The raw questionnaire will seed this athlete\'s <strong>Athlete Context</strong> tab on creation.</div>'
      : '';
    return '<div class="coach-form" id="coach-new-athlete-form">' +
      '<h3>New athlete</h3>' +
      notice +
      '<div class="row">' +
      '<div><label>Athlete name *</label><input id="ca-name" type="text" placeholder="e.g. Sarah" autocomplete="off" value="' + escapeAttr(nameVal) + '"></div>' +
      '<div><label>Athlete email *</label><input id="ca-email" type="email" required placeholder="sarah@example.com" autocomplete="off" value="' + escapeAttr(emailVal) + '"></div>' +
      '<div><label>Time zone</label><input id="ca-tz" type="text" value="' + escapeAttr(tzVal) + '"></div>' +
      '</div>' +
      '<div class="ca-learning-row">' +
        '<label class="ca-learning-toggle">' +
          '<input id="ca-learning" type="checkbox" checked>' +
          '<span>Start with a Learning block</span>' +
        '</label>' +
        '<label class="ca-learning-weeks-label">' +
          'Weeks:' +
          '<input id="ca-learning-weeks" type="number" min="1" max="12" value="4" inputmode="numeric">' +
        '</label>' +
        '<div class="ca-learning-help">Athlete logs their current training; you programme Block 2 from what they capture.</div>' +
      '</div>' +
      '<div class="actions">' +
      '<button id="ca-submit">Create plan</button>' +
      '<button id="ca-cancel" class="secondary" style="margin-left: 8px;">Cancel</button>' +
      '</div>' +
      '<div id="ca-result"></div>' +
      '</div>';
  }

  // From-Intake panel, paste the athlete's filled-in intake.md (or
  // upload it), click Parse, identity fields auto-populate the New
  // Athlete form below + the raw markdown gets stashed in state to
  // seed the Athlete Context tab on athlete creation.
  function renderFromIntakeSection() {
    if (!state.showFromIntake) return '';
    return '<div class="coach-form" id="coach-from-intake-form">' +
      '<h3>New athlete from intake</h3>' +
      '<p style="margin-top: 0; opacity: 0.85;">Paste the athlete\'s filled-in intake questionnaire below (or upload the <code>.md</code> file). The parser pulls <strong>Full name</strong> and <strong>Time zone</strong> into the New Athlete form; the rest of the intake seeds the athlete\'s <code>Athlete Context</code> tab so the LLM has it on the first pass.</p>' +
      '<div style="display: flex; gap: 10px; align-items: center; margin-bottom: 10px;">' +
        '<label class="coach-result-btn" style="cursor: pointer; padding: 8px 14px;">' +
          '📂 Upload .md file' +
          '<input id="fi-file" type="file" accept=".md,.markdown,.txt" hidden>' +
        '</label>' +
        '<span style="opacity: 0.6; font-size: 13px;">or paste below ↓</span>' +
      '</div>' +
      '<textarea id="fi-textarea" placeholder="Paste the athlete\'s filled-in intake markdown here…" rows="10" style="width: 100%; padding: 10px; font-family: inherit; font-size: 13px; border: 1px solid var(--border, #333); border-radius: 6px; box-sizing: border-box; resize: vertical;"></textarea>' +
      '<div id="fi-parse-result" style="margin-top: 10px;"></div>' +
      '<div class="actions" style="margin-top: 12px;">' +
        '<button id="fi-parse">Parse + open New Athlete</button>' +
        '<button id="fi-cancel" class="secondary" style="margin-left: 8px;">Close</button>' +
      '</div>' +
      '</div>';
  }

  // Parse a filled-in intake and extract identity fields. The
  // athlete-friendly templates use a plain `Field name: value` pattern
  // for the QUICK INFO block at the top. The old technical templates
  // used `- **Field name:** value`. This parser handles both so legacy
  // intake responses still work.
  //
  // Returns { name, email, timeZone, raw }, raw is the full body so
  // it can seed the Athlete Context tab post-provision.
  function parseIntakeMarkdown_(text) {
    var raw = String(text || '');
    var out = { name: '', email: '', timeZone: '', raw: raw };
    var FIELD_TO_OUT = {
      'full name':                 'name',
      'name':                      'name',
      'preferred name':            'name',
      'pronouns / preferred name': 'name',
      'pronouns / what you like to be called': 'name',
      'email':                     'email',
      'email address':             'email',
      'time zone':                 'timeZone',
      'timezone':                  'timeZone',
      'time zone (city or country)': 'timeZone',
    };
    var lines = raw.split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      // Strip leading bullet markers + markdown bold so both the old
      // `- **Full name:** Sarah` and new `Full name: Sarah` shapes match.
      var clean = lines[i].replace(/^[\s\-*]+/, '').replace(/\*\*/g, '');
      var m = clean.match(/^([A-Za-z][A-Za-z0-9 \/()]+?)\s*:\s*(.*)$/);
      if (!m) continue;
      var key = m[1].trim().toLowerCase();
      var target = FIELD_TO_OUT[key];
      if (!target) continue;
      var value = m[2].trim();
      // Strip a leading parenthetical hint like "(e.g. Europe/London)"
      // that the athlete didn't replace.
      value = value.replace(/^\([^)]*\)\s*/, '');
      // Skip italicised placeholder hints (legacy template format).
      if (/^\*\(.+\)\*$/.test(value)) value = '';
      // Skip empty-with-only-hint cases.
      if (!value || /^[*_]/.test(value)) continue;
      // Pronouns/preferred-name fields are weaker than Full name, only
      // populate `name` from them if Full name hasn't already filled in.
      if (target === 'name' && (key.indexOf('pronouns') >= 0 || key.indexOf('preferred name') >= 0)) {
        if (!out.name) out.name = value;
      } else if (!out[target]) {
        out[target] = value;
      }
    }
    return out;
  }

  // ── Athlete intake form generator ─────────────────────────────────────────
  // Pre-athlete onboarding tool: trainer picks a depth (Quick / Medium /
  // Detailed) and downloads a markdown questionnaire to send to the
  // athlete. The athlete's filled-in answers slot into the Initial
  // Briefing section of PLAN-LLM-PROMPT.md for fresh-plan authoring.
  function renderIntakeFormSection() {
    if (!state.showIntake) return '';
    return '<div class="coach-form" id="coach-intake-form">' +
      '<h3>Athlete intake questionnaire</h3>' +
      '<p style="margin-top: 0; opacity: 0.8;">Generates a markdown file you can email to the athlete during onboarding. Their answers paste straight into the <code>PLAN-LLM-PROMPT.md</code> Initial Briefing slot when you author the plan.</p>' +
      '<div class="row">' +
        '<label style="display:flex; gap:8px; align-items:flex-start; padding:10px; border:1px solid var(--border, #333); border-radius:6px; cursor:pointer;">' +
          '<input type="radio" name="intake-depth" value="quick" checked>' +
          '<span><strong>Quick</strong>: ~5 min, 10 questions. Bare-minimum to author a plan.</span>' +
        '</label>' +
        '<label style="display:flex; gap:8px; align-items:flex-start; padding:10px; border:1px solid var(--border, #333); border-radius:6px; cursor:pointer;">' +
          '<input type="radio" name="intake-depth" value="medium">' +
          '<span><strong>Medium</strong>: ~15 min, ~25 questions. Adds PBs, race history, recovery, nutrition.</span>' +
        '</label>' +
        '<label style="display:flex; gap:8px; align-items:flex-start; padding:10px; border:1px solid var(--border, #333); border-radius:6px; cursor:pointer;">' +
          '<input type="radio" name="intake-depth" value="detailed">' +
          '<span><strong>Detailed</strong>: ~30 min, ~50 questions. Full strength / pace / power / mobility audit.</span>' +
        '</label>' +
      '</div>' +
      '<div class="actions" style="margin-top: 12px;">' +
        '<button id="intake-download">⬇ Download questionnaire</button>' +
        '<button id="intake-cancel" class="secondary" style="margin-left: 8px;">Close</button>' +
      '</div>' +
      '</div>';
  }

  // Markdown source for the three depths. Authored inline so the
  // download is pure-frontend, no server round-trip needed.
  var INTAKE_TEMPLATES = {
    quick: [
      'Hi 👋',
      '',
      'Welcome, I\'m putting your training plan together and I need a few things from you first. This should take about 5 minutes.',
      '',
      'Just type your answers below each question. No pressure to be exact, even "I don\'t know" or "haven\'t thought about it" is genuinely useful.',
      '',
      'When you\'re done, send this back to me (reply to the email I sent it in, or save the file and email me back).',
      '',
      '────────────────────────────────────────',
      '',
      'QUICK INFO',
      'Fill these in first so I can set things up:',
      '',
      'Full name: ',
      'Email: ',
      'Time zone (city or country): ',
      '',
      '────────────────────────────────────────',
      '',
      'NOW THE REST',
      '',
      '',
      '1. What\'s the event or goal you\'re training for?',
      '(e.g. Tour du Mont Blanc fastpack, first marathon, Hyrox in spring, drop body fat + get stronger, stay sane through winter)',
      '',
      '',
      '',
      '2. When is it, or when do you want to hit it?',
      '(a specific date if you have one, otherwise a window like "April-May 2026")',
      '',
      '',
      '',
      '3. What does success look like to you?',
      '(a finish time? Just finishing strong? A new PB? Feeling fit again?)',
      '',
      '',
      '',
      '4. What has your training looked like in the last 6 months?',
      '(rough sketch is fine, what you\'ve been doing, how often, any long breaks)',
      '',
      '',
      '',
      '5. Any injuries or niggles I should plan around?',
      '(current, recent, or old stuff that flares up, be honest, this matters)',
      '',
      '',
      '',
      '6. How many days and hours per week can you realistically train?',
      '(weekdays vs weekends if different, be honest, not aspirational)',
      '',
      '',
      '',
      '7. Where do you train and what kit have you got access to?',
      '(home gym, commercial gym, CrossFit box, hills, treadmill, pool, bike, etc.)',
      '',
      '',
      '',
      '8. What kind of sessions do you love or hate?',
      '(useful so I don\'t fill your plan with stuff you\'ll dodge)',
      '',
      '',
      '',
      '9. Anything else I should know to make this work for you?',
      '(life stuff, days off, family, work patterns, anything at all)',
      '',
      '',
      '',
      '────────────────────────────────────────',
      'That\'s it. Send this back when you\'re done. Cheers!',
      ''
    ],
    medium: [
      'Hi 👋',
      '',
      'Welcome, I\'m putting your training plan together and I want to do it properly. This intake should take about 15 minutes; it pays back tenfold once we\'re training because the plan can start from real numbers, not guesses.',
      '',
      'Just type your answers below each question. Don\'t overthink it, short and honest beats long and polished. If something doesn\'t apply, just say so.',
      '',
      'Send this back when you\'re done. Reply to the email I sent it in, or save the file and email me back.',
      '',
      '────────────────────────────────────────',
      '',
      'QUICK INFO',
      'Fill these in first so I can set things up:',
      '',
      'Full name: ',
      'Email: ',
      'Time zone (city or country): ',
      'Age: ',
      'Pronouns / what you like to be called: ',
      '',
      '────────────────────────────────────────',
      '',
      'YOUR GOAL',
      '',
      '',
      '1. What\'s the main event or goal you\'re training for?',
      '(name, distance, format, get as specific as you can)',
      '',
      '',
      '',
      '2. When is it?',
      '(date if known, otherwise a window like "spring 2026")',
      '',
      '',
      '',
      '3. What does success look like to you?',
      '(finish time? Placing? Just getting to the start line healthy? PB on a lift?)',
      '',
      '',
      '',
      '4. Why this goal? What\'s driving it?',
      '(motivation matters, it tells me where you\'ll dig in and where you\'ll cut corners)',
      '',
      '',
      '',
      '5. Any smaller events or races on the way you want to use as checkpoints?',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'YOUR TRAINING HISTORY',
      '',
      '',
      '6. What have you been doing for the last 6 months?',
      '(modalities, rough volume, consistency, any extended breaks)',
      '',
      '',
      '',
      '7. Bigger picture, what\'s your training background?',
      '(years training, sports played, peak fitness moments)',
      '',
      '',
      '',
      '8. Best results or PBs to date, whichever apply.',
      '(5K, 10K, half, marathon, squat / deadlift / bench numbers, race finishes, list whatever you\'ve actually done)',
      '',
      '',
      '',
      '9. Any races or comps in the last 12 months?',
      '(name, date, result)',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'YOUR BODY + RECOVERY',
      '',
      '',
      '10. Any injuries from the last 2 years I should plan around?',
      '(active stuff, healed-but-still-sensitive, things that trigger flares)',
      '',
      '',
      '',
      '11. Sleep, typical hours + quality?',
      '',
      '',
      '',
      '12. Stress level, work / life right now?',
      '(low / moderate / high, and what\'s driving it)',
      '',
      '',
      '',
      '13. What recovery stuff do you actually do?',
      '(mobility, massage, sauna, breathwork, or "honestly, nothing")',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'FOOD',
      '',
      '',
      '14. Any dietary restrictions or strong preferences?',
      '',
      '',
      '',
      '15. How do you fuel around training?',
      '(pre, during, post, and how reliable you actually are about it)',
      '',
      '',
      '',
      '16. Any body composition target tied to this goal?',
      '(weight to hit, body comp shift, or just "fitter" / "stronger")',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'KIT + ENVIRONMENT',
      '',
      '',
      '17. Where do you train?',
      '(home, commercial gym, CrossFit box, outdoor, and where most of your hours actually happen)',
      '',
      '',
      '',
      '18. What equipment have you got access to?',
      '(barbell, KBs up to what weight, machines, hills, pool, bike, etc.)',
      '',
      '',
      '',
      '19. Do you train with a coach, partners, or a group?',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'YOUR WEEK',
      '',
      '',
      '20. How many days and hours per week can you realistically train?',
      '(weekday vs weekend breakdown if it differs, be honest)',
      '',
      '',
      '',
      '21. When in the day do you train best?',
      '(AM / PM / mixed, and any hard constraints from work or family)',
      '',
      '',
      '',
      '22. Are there days that have to stay off?',
      '(family, work, religion, sanity)',
      '',
      '',
      '',
      '23. Sessions you love? Sessions you hate?',
      '(I\'ll work with you on the hate list, but knowing it helps)',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      '24. Anything else I should know?',
      '(life stuff, history, habits, anything at all that\'ll make this plan actually work for you)',
      '',
      '',
      '',
      '────────────────────────────────────────',
      'That\'s the lot, thanks for taking the time, send it back when you\'re done.',
      ''
    ],
    detailed: [
      'Hi 👋',
      '',
      'Welcome, I\'m putting together a serious, well-targeted training plan for you, and that needs real information to start from. This intake takes around 30 minutes; it\'s the most thorough version because the first plan will be pace / weight / power-set off your actual numbers instead of best-guesses.',
      '',
      'Just type your answers below each question. Skip anything that doesn\'t apply (e.g. running paces if you don\'t run). Just type "n/a". Short and honest beats long and polished.',
      '',
      'Send this back when you\'re done. Reply to the email I sent it in, or save the file and email it back.',
      '',
      '────────────────────────────────────────',
      '',
      'QUICK INFO',
      'Fill these in first so I can set things up:',
      '',
      'Full name: ',
      'Email: ',
      'Time zone (city or country): ',
      'Age: ',
      'Sex / hormonal context: ',
      'Height: ',
      'Weight: ',
      'Pronouns / what you like to be called: ',
      '',
      '────────────────────────────────────────',
      '',
      'YOUR GOAL',
      '',
      '',
      '1. What\'s the main event or goal you\'re training for?',
      '(name, distance, format, terrain, be specific)',
      '',
      '',
      '',
      '2. When is it?',
      '',
      '',
      '',
      '3. What does success look like to you?',
      '(time, placing, just finishing, hitting a number, get specific)',
      '',
      '',
      '',
      '4. Why this goal? What\'s driving it?',
      '',
      '',
      '',
      '5. Course / event details if you have them.',
      '(elevation, surface, fueling stations, cutoffs, anything we should plan around)',
      '',
      '',
      '',
      '6. Smaller events or checkpoint races on the way?',
      '',
      '',
      '',
      '7. Longer-term goal beyond this one?',
      '(it shapes how we approach this build)',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'YOUR HISTORY',
      '',
      '',
      '8. What have you been doing for the last 6 months?',
      '(modalities, volume per week, consistency)',
      '',
      '',
      '',
      '9. Bigger picture. Your training background?',
      '(years, sports, peak fitness moments)',
      '',
      '',
      '',
      '10. Best ever results / PBs across your career?',
      '',
      '',
      '',
      '11. Race or comp history in the last 24 months?',
      '(name, date, result, how it felt)',
      '',
      '',
      '',
      '12. Has anything broken your training streak in the past?',
      '(injury, burnout, life events, patterns help me plan around them)',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'STRENGTH (skip with "don\'t lift" if it doesn\'t apply)',
      'Current working weights, not lifetime maxes.',
      '',
      '',
      '13. Back squat, best 1-rep and your current working 5-rep weight?',
      '',
      '',
      '',
      '14. Front squat, same?',
      '',
      '',
      '',
      '15. Deadlift, same?',
      '',
      '',
      '',
      '16. Bench press, same?',
      '',
      '',
      '',
      '17. Strict press, same?',
      '',
      '',
      '',
      '18. Strict pull-ups, max reps?',
      '',
      '',
      '',
      '19. Any Olympic / CrossFit-style lifts you do regularly?',
      '(snatch, clean & jerk, thruster, whichever apply, with numbers)',
      '',
      '',
      '',
      '20. The lift you most want to improve?',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'RUNNING (skip with "don\'t run" if it doesn\'t apply)',
      '',
      '',
      '21. Recent 5K time + when?',
      '',
      '',
      '',
      '22. 10K time + when?',
      '',
      '',
      '',
      '23. Half-marathon time + when?',
      '',
      '',
      '',
      '24. Marathon or ultra times + when?',
      '',
      '',
      '',
      '25. Easy pace, what does conversational running feel like for you?',
      '(rough min/km or min/mile is fine)',
      '',
      '',
      '',
      '26. Threshold pace if you know it?',
      '',
      '',
      '',
      '27. Heart-rate zones if you track them?',
      '',
      '',
      '',
      '28. What weekly mileage can you realistically sustain right now?',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'BIKE (skip with "don\'t cycle" if it doesn\'t apply)',
      '',
      '',
      '29. FTP or threshold power?',
      '',
      '',
      '',
      '30. Threshold heart rate?',
      '',
      '',
      '',
      '31. Longest recent ride?',
      '',
      '',
      '',
      '32. Weekly hours you can sustain on the bike?',
      '',
      '',
      '',
      '33. Bike type + terrain you ride?',
      '(road, gravel, MTB, indoor trainer)',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'SWIM (skip with "don\'t swim" if it doesn\'t apply)',
      '',
      '',
      '34. Recent 100m freestyle time?',
      '',
      '',
      '',
      '35. 400m freestyle?',
      '',
      '',
      '',
      '36. 1500m freestyle?',
      '',
      '',
      '',
      '37. Other strokes you swim, times by distance?',
      '',
      '',
      '',
      '38. Pool or open water preference + recent volume?',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'YOUR BODY + RECOVERY',
      '',
      '',
      '39. Resting heart rate + HRV trend if you track them?',
      '',
      '',
      '',
      '40. Sleep, typical hours + quality?',
      '',
      '',
      '',
      '41. Stress level right now? Low / moderate / high. And what\'s driving it?',
      '',
      '',
      '',
      '42. Recovery tools you actually use?',
      '(mobility, massage, sauna, ice, breathwork, or honestly nothing)',
      '',
      '',
      '',
      '43. Injuries from the last 5 years?',
      '(active, healed, what triggers them)',
      '',
      '',
      '',
      '44. Niggles you live with?',
      '(things that aren\'t injuries but you work around them)',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'MOBILITY + MOVEMENT QUALITY',
      'Short self-assessment, be honest.',
      '',
      '',
      '45. Squat depth, comfortable, restricted, or painful?',
      '',
      '',
      '',
      '46. Overhead position, full range, limited, or painful?',
      '',
      '',
      '',
      '47. Ankle mobility, fine, or restricted (which side)?',
      '',
      '',
      '',
      '48. Mid-back / thoracic rotation?',
      '',
      '',
      '',
      '49. Any movements you actively avoid? And why?',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'FOOD',
      '',
      '',
      '50. Dietary restrictions or strong preferences?',
      '',
      '',
      '',
      '51. Typical day of eating?',
      '(rough, not asking you to log everything)',
      '',
      '',
      '',
      '52. Fueling around training, pre, during, post?',
      '',
      '',
      '',
      '53. Hydration habits?',
      '',
      '',
      '',
      '54. Body composition target tied to this goal?',
      '',
      '',
      '',
      '55. Supplements you take?',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'KIT + ENVIRONMENT',
      '',
      '',
      '56. Primary training location?',
      '(home, commercial gym, CrossFit box, outdoor)',
      '',
      '',
      '',
      '57. Full equipment inventory, what\'s available?',
      '(specifics, barbell weight, KB ladder, dumbbell range, machines, ergs)',
      '',
      '',
      '',
      '58. Outdoor access?',
      '(hills, trails, track, open water, what\'s on your doorstep)',
      '',
      '',
      '',
      '59. Coaches, training partners, or group sessions?',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'YOUR WEEK',
      '',
      '',
      '60. Mon-Sun availability, hours per day and time of day?',
      '',
      '',
      '',
      '61. When in the day do you train best?',
      '',
      '',
      '',
      '62. Days that must stay off?',
      '',
      '',
      '',
      '63. Family / work commitments that shape your week?',
      '',
      '',
      '',
      '64. Sessions you love? Sessions you hate?',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      'YOUR HEAD',
      '',
      '',
      '65. What motivates you most?',
      '(numbers, peers, the event itself, identity, fear of failure, be honest)',
      '',
      '',
      '',
      '66. Any history of burnout or over-training?',
      '',
      '',
      '',
      '67. Mental cues or mantras that work for you?',
      '',
      '',
      '',
      '68. What does "training going well" actually feel like for you?',
      '',
      '',
      '',
      '────────────────────────────────────────',
      '',
      '69. Anything else I should know?',
      '(anything at all, quirks, habits, dealbreakers)',
      '',
      '',
      '',
      '────────────────────────────────────────',
      'That\'s the full set, thanks for taking the time. Send it back when you\'re done and I\'ll get the plan built.',
      ''
    ]
  };

  function downloadIntakeForm_(depth) {
    var body = (INTAKE_TEMPLATES[depth] || []).join('\n');
    if (!body) { toast('Unknown depth: ' + depth); return; }
    var date = new Date().toISOString().slice(0, 10);
    var filename = 'athlete-intake-' + depth + '-' + date + '.md';
    var blob = new Blob([body], { type: 'text/markdown;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    toast('Downloaded ' + filename);
  }

  // ── Email preferences ─────────────────────────────────────────────────────
  // Two sections inside one collapsible: "Your subscriptions" and
  // "Athlete subscriptions" (per-athlete cards). Catalog of available
  // email types comes from server-side EMAIL_TYPE_META.
  function renderEmailPrefsSection() {
    if (!state.info || !state.info.emailPrefs) {
      return '<div class="coach-empty">Email preferences aren\'t available yet, refresh the page.</div>';
    }
    var prefs = state.info.emailPrefs;
    var role = (state.info.trainer && state.info.trainer.role) || 'trainer';
    var trainerToken = state.info.trainer && state.info.trainer.token;
    var html = ['<div class="coach-email-prefs">'];

    // Self section, combine 'trainer' + 'admin' (if admin role) catalogs.
    var myTypes = (prefs.catalog.trainer || []).slice();
    if (role === 'admin') myTypes = myTypes.concat(prefs.catalog.admin || []);
    if (myTypes.length) {
      html.push('<div class="email-prefs-block">');
      html.push('<h3>Your subscriptions</h3>');
      html.push('<div class="email-prefs-list">');
      myTypes.forEach(function (t) {
        var sub = prefs.mine.hasOwnProperty(t.type) ? prefs.mine[t.type] !== false : true;
        html.push(renderEmailPrefRow_(trainerToken, t, sub));
      });
      html.push('</div></div>');
    }

    // Athletes section, for each athlete, render the athlete-targeted catalog.
    // Skip archived athletes, no point setting subscriptions for retired plans.
    var subPrefAthletes = state.info.athletes.filter(function (a) {
      return String(a.status || '').toLowerCase() !== 'archived';
    });
    if (subPrefAthletes.length && (prefs.catalog.athlete || []).length) {
      html.push('<div class="email-prefs-block">');
      html.push('<h3>Athlete subscriptions</h3>');
      html.push('<p class="meta" style="margin-bottom: 12px;">Set what each athlete receives. They can change their own preferences too.</p>');
      subPrefAthletes.forEach(function (a) {
        var aPrefs = prefs.athletes[a.token] || {};
        html.push('<details class="email-prefs-athlete" data-key="email-prefs-' + escapeHtml(a.token) + '">');
        html.push('<summary>' + escapeHtml(a.athleteName || a.planTitle || a.token) +
          (a.email ? ' <span class="meta">' + escapeHtml(a.email) + '</span>' : '') + '</summary>');
        html.push('<div class="email-prefs-list">');
        prefs.catalog.athlete.forEach(function (t) {
          var sub = aPrefs.hasOwnProperty(t.type) ? aPrefs[t.type] !== false : true;
          html.push(renderEmailPrefRow_(a.token, t, sub));
        });
        html.push('</div></details>');
      });
      html.push('</div>');
    }

    html.push('<div class="email-prefs-actions">' +
      '<button type="button" id="email-prefs-save">Save preferences</button>' +
      '<span id="email-prefs-status" class="meta"></span>' +
      '</div>');
    html.push('</div>');
    return html.join('');
  }

  function renderEmailPrefRow_(ownerToken, t, subscribed) {
    var rowKey = ownerToken + '|' + t.type;
    return '<label class="email-pref-row" data-pref-row="' + escapeHtml(rowKey) + '">' +
      '<input type="checkbox" data-pref-owner="' + escapeHtml(ownerToken) + '" data-pref-type="' + escapeHtml(t.type) + '"' +
        (subscribed ? ' checked' : '') + '>' +
      '<div class="email-pref-text">' +
        '<div class="email-pref-subject">' + escapeHtml(t.subject || t.type) + '</div>' +
        '<div class="email-pref-trigger meta">' + escapeHtml(t.trigger || '') + '</div>' +
      '</div>' +
      '</label>';
  }

  // Below this active-athlete count, the system is well within Apps
  // Script's per-execution limits. Past it, the Sunday weekly-digest
  // cron starts approaching the 6-minute runtime cap (one
  // SpreadsheetApp.openById per athlete) and the coachInfo response
  // gets large. Banner appears at >= SCALE_WARN_AT and turns louder at
  // >= SCALE_DANGER_AT so admins know it's time to chunk the digest /
  // paginate the response before things actually break.
  var SCALE_WARN_AT   = 180;
  var SCALE_DANGER_AT = 240;

  function renderAdminOverview() {
    var trainers = state.info.allTrainers || [];
    var allA     = state.info.allAthletes || [];
    var trainerByToken = {};
    trainers.forEach(function (t) { trainerByToken[t.token] = t; });
    var meToken = (state.info.trainer && state.info.trainer.token) || '';

    // Athletes count for the collapsible header, total minus archived
    // since archived sits in its own filter chip.
    var activeAthletesCount = allA.filter(function (a) {
      return String(a.status || '').toLowerCase() !== 'archived';
    }).length;

    // Order requested by the user (admin section):
    //   1. Trainers (active)
    //   2. All athletes
    //   3. Archived trainers
    var html = '<h2>Admin overview</h2>';
    html += renderScaleWarning_(activeAthletesCount);
    html += renderTrainersManagement_(trainers, allA, meToken, { activeOnly: true });
    html += '<details class="admin-athletes-block" data-key="all-athletes">' +
      '<summary>All athletes <span class="meta">(' + activeAthletesCount + ')</span></summary>' +
      '<div class="admin-athletes-body">' +
        renderAdminFilters_(allA, 'admin') +
        renderAdminAthletesTable_(allA, trainerByToken, { tableKey: 'admin' }) +
      '</div>' +
    '</details>';
    html += renderTrainersManagement_(trainers, allA, meToken, { archivedOnly: true });
    return html;
  }

  function renderScaleWarning_(count) {
    if (count < SCALE_WARN_AT) return '';
    var danger = count >= SCALE_DANGER_AT;
    var headline = danger
      ? '🛑 At scale limits (' + count + ' active athletes)'
      : '⚠️ Approaching scale limits (' + count + ' active athletes)';
    var body = danger
      ? 'You\'re past the safe range. The weekly-digest cron is likely hitting the 6-minute Apps Script runtime, some athletes may be silently skipped each Sunday. Time to chunk the digest job and consider paginating the admin overview response. Get the dev team on this now.'
      : 'You\'re within ' + (SCALE_DANGER_AT - count) + ' of the cliff. The weekly-digest cron walks every athlete sheet sequentially and starts hitting the 6-minute Apps Script runtime past ~' + SCALE_DANGER_AT + ' active athletes. Plan to chunk the digest job soon. See the deferred items in the launch audit.';
    return '<div class="scale-warning' + (danger ? ' is-danger' : '') + '">' +
      '<div class="scale-warning-head">' + escapeHtml(headline) + '</div>' +
      '<div class="scale-warning-body">' + escapeHtml(body) + '</div>' +
    '</div>';
  }

  // Search input + status filter chips above the athletes table.
  // Counts are computed across the entire roster (not the filtered set)
  // so chips show real totals even while filtered. tableKey scopes the
  // controls so admins can have two tables ("Your athletes" + "All
  // athletes") side-by-side without DOM id collisions.
  function renderAdminFilters_(allA, tableKey) {
    var counts = { active: 0, blocked: 0, archived: 0 };
    allA.forEach(function (a) {
      var s = String(a.status || 'active').toLowerCase();
      if (s === 'archived') counts.archived++;
      else if (s === 'blocked') counts.blocked++;
      else counts.active++;
    });
    var f = state.adminFilters;
    var chip = function (key, label) {
      var on = !!f[key];
      return '<button type="button" class="admin-filter-chip' + (on ? ' is-on' : '') +
        '" data-admin-filter="' + key + '" aria-pressed="' + on + '">' +
        escapeHtml(label) + ' <span class="admin-filter-count">' + counts[key] + '</span></button>';
    };
    return '<div class="admin-toolbar" data-table-key="' + escapeHtml(tableKey || 'admin') + '">' +
      '<input type="text" inputmode="search" class="admin-search" placeholder="Search athlete, trainer, plan, email…" value="' + escapeHtml(state.adminSearch) + '" autocomplete="off">' +
      '<div class="admin-filter-chips">' +
        chip('active', 'Active') +
        chip('blocked', 'Blocked') +
        chip('archived', 'Archived') +
      '</div>' +
    '</div>';
  }

  // Athletes table, sortable headers, filtered by search + chips,
  // each row carries an Open plan link + a ⋯ overflow menu with the
  // full set of actions (Edit / Copy token / Send invite / New
  // programme / Block / Archive / Restore).
  function renderAdminAthletesTable_(allA, trainerByToken, opts) {
    opts = opts || {};
    var showTrainer = opts.showTrainer !== false;
    var tableKey = opts.tableKey || 'admin';
    var filtered = filterAdminAthletes_(allA, trainerByToken);
    filtered = sortAdminAthletes_(filtered, trainerByToken);

    if (!allA.length) {
      return '<div class="coach-empty">No athletes ' + (showTrainer ? 'in the system' : 'yet') + '.</div>';
    }
    var sortIcon = function (col) {
      if (state.adminSort.column !== col) return '<span class="sort-arrow"></span>';
      return '<span class="sort-arrow is-active">' + (state.adminSort.dir === 'asc' ? '▲' : '▼') + '</span>';
    };
    var th = function (col, label) {
      return '<th data-sort="' + col + '" class="is-sortable">' + escapeHtml(label) + sortIcon(col) + '</th>';
    };
    var colCount = showTrainer ? 5 : 4;
    var html = '<div class="admin-table-wrapper" data-table-key="' + escapeHtml(tableKey) + '"><table class="admin-table"><thead><tr>' +
      th('athleteName', 'Athlete') +
      (showTrainer ? th('trainerName', 'Trainer') : '') +
      th('status', 'Status') +
      th('lastActivity', 'Last activity') +
      '<th>Actions</th>' +
    '</tr></thead><tbody>';

    if (!filtered.length) {
      html += '<tr><td colspan="' + colCount + '" class="admin-empty-row">No athletes match the current filters.</td></tr>';
    } else {
      filtered.forEach(function (a) {
        var trainer = trainerByToken[a.trainerToken] || {};
        html += renderAdminAthleteRow_(a, trainer, showTrainer, tableKey);
      });
    }
    html += '</tbody></table></div>';
    // Mobile-only "← swipe →" hint just above the table, the right-edge
    // gradient signals there's more, but the explicit hint avoids any
    // doubt on a wide table the first time you see it.
    html += '<div class="admin-table-scroll-hint">← swipe to see more →</div>';
    return html;
  }

  function filterAdminAthletes_(list, trainerByToken) {
    var f = state.adminFilters;
    var search = String(state.adminSearch || '').trim().toLowerCase();
    return list.filter(function (a) {
      var s = String(a.status || 'active').toLowerCase();
      var statusKey = s === 'blocked' ? 'blocked' : s === 'archived' ? 'archived' : 'active';
      if (!f[statusKey]) return false;
      if (search) {
        var name = (a.athleteName || '').toLowerCase();
        var trainerName = ((trainerByToken[a.trainerToken] || {}).name || '').toLowerCase();
        var email = (a.email || '').toLowerCase();
        var plan = (a.planTitle || '').toLowerCase();
        if (name.indexOf(search) === -1 && trainerName.indexOf(search) === -1 &&
            email.indexOf(search) === -1 && plan.indexOf(search) === -1) {
          return false;
        }
      }
      return true;
    });
  }

  function sortAdminAthletes_(list, trainerByToken) {
    var s = state.adminSort;
    var sign = s.dir === 'asc' ? 1 : -1;
    return list.slice().sort(function (a, b) {
      var av, bv;
      switch (s.column) {
        case 'athleteName':
          av = (a.athleteName || '').toLowerCase();
          bv = (b.athleteName || '').toLowerCase();
          break;
        case 'trainerName':
          av = ((trainerByToken[a.trainerToken] || {}).name || '').toLowerCase();
          bv = ((trainerByToken[b.trainerToken] || {}).name || '').toLowerCase();
          break;
        case 'status':
          av = String(a.status || 'active').toLowerCase();
          bv = String(b.status || 'active').toLowerCase();
          break;
        case 'lastActivity':
        default:
          av = a.lastActive ? new Date(a.lastActive).getTime() : 0;
          bv = b.lastActive ? new Date(b.lastActive).getTime() : 0;
          break;
      }
      if (av < bv) return -1 * sign;
      if (av > bv) return  1 * sign;
      return 0;
    });
  }

  function renderAdminAthleteRow_(a, trainer, showTrainer, tableKey) {
    if (showTrainer === undefined) showTrainer = true;
    if (!tableKey) tableKey = 'admin';
    var statusLower = String(a.status || 'active').toLowerCase();
    var blocked  = statusLower === 'blocked';
    var archived = statusLower === 'archived';
    var rowCls = 'admin-row' + (blocked || archived ? ' is-blocked' : '');
    var statusBits = [];
    if (statusLower !== 'active') {
      statusBits.push('<span class="badge ' + statusLower + '">' + escapeHtml(statusLower) + '</span>');
    } else {
      statusBits.push('<span class="badge active">active</span>');
    }
    if (a.email && a.emailConfirmed === false && !archived) {
      statusBits.push('<span class="badge unconfirmed" title="Email not confirmed">unconfirmed</span>');
    }

    var openCell;
    if (archived) {
      openCell = '<span class="admin-row-primary is-disabled" title="Archived athletes can\'t open their plan">-</span>';
    } else if (a.pageUrl) {
      openCell = '<a class="admin-row-primary" href="' + escapeHtml(addQuery_(a.pageUrl, 'mode=trainer')) + '" target="_blank" rel="noopener">Open plan ↗</a>';
    } else {
      openCell = '<button class="admin-row-primary" data-set-pageurl="' + escapeHtml(a.token) + '">Add page URL</button>';
    }
    // Activity surfaced as a top-level row action (was hidden in
    // the ⋯ menu), the most frequent thing a trainer wants after
    // opening the plan. Icon-style so it doesn't dominate the row.
    if (!archived) {
      openCell += '<button class="admin-row-secondary" data-athlete-insights="' + escapeHtml(a.token) +
        '" data-athlete-name="' + escapeAttr(a.athleteName || '') +
        '" title="Activity (last 7 days)">📊</button>';
    }

    // Scope the overflow key by table so the same athlete appearing in
    // both "Your athletes" and "All athletes" only opens one menu at a time.
    var overflowKey = tableKey + '|' + a.token;
    var overflowOpen = state.openOverflow === overflowKey;
    // The ⋯ trigger stays in the row; the menu itself is PORTALED to
    // document.body in wireUp_() so its position:fixed escapes any
    // ancestor containing block / overflow clip (the .admin-table-
    // wrapper's overflow-x:auto on mobile was confining the menu
    // inside the table on iOS Safari).
    var overflow = '<div class="admin-overflow-wrapper">' +
      '<button class="admin-row-overflow' + (overflowOpen ? ' is-active' : '') +
        '" data-overflow-toggle="' + escapeHtml(overflowKey) + '" aria-expanded="' + overflowOpen + '" title="More actions">⋯</button>' +
    '</div>';

    // Group-type badge, distinguishes solo plans from small/gym/large
    // group plans in the roster. Member count comes from the directory
    // Members JSON column (parseMembersJson_ on the server).
    var gt = String(a.groupType || 'solo').toLowerCase();
    var memberCount = (a.members && a.members.length) || 0;
    var typeBadge = '';
    if (gt !== 'solo') {
      var typeLabel = gt === 'gym' ? 'Gym'
                    : gt === 'large_group' ? 'Broadcast'
                    : 'Group';
      typeBadge = '<span class="badge group-type group-type-' + gt + '">' +
        typeLabel + (memberCount ? ' · ' + memberCount : '') +
      '</span>';
    }

    return '<tr class="' + rowCls + '" data-athlete-token="' + escapeHtml(a.token) + '">' +
      '<td class="col-name">' +
        '<div class="col-name-main">' + escapeHtml(a.athleteName || a.planTitle || a.token) +
          (typeBadge ? ' ' + typeBadge : '') +
        '</div>' +
        (a.planTitle ? '<div class="meta">' + escapeHtml(a.planTitle) + '</div>' : '') +
        (a.email ? '<div class="meta">' + escapeHtml(a.email) + '</div>' : '') +
      '</td>' +
      (showTrainer ? '<td class="col-trainer">' + escapeHtml(trainer.name || '-') + '</td>' : '') +
      '<td class="col-status">' + statusBits.join(' ') + '</td>' +
      '<td class="col-when meta">' + escapeHtml(formatRelative(a.lastActive)) + '</td>' +
      '<td class="col-actions">' + openCell + overflow + '</td>' +
    '</tr>';
  }

  // Popover menu shown when ⋯ on an athlete row is clicked. Includes
  // every secondary action. Edit, Copy token, Send invite, New
  // programme, Block/Unblock, Archive/Restore. Items hide when not
  // applicable (e.g. Send invite needs both email + page URL).
  function renderAdminOverflowMenu_(a) {
    var statusLower = String(a.status || 'active').toLowerCase();
    var archived = statusLower === 'archived';
    var blocked = statusLower === 'blocked';
    var token = escapeHtml(a.token);
    var name  = escapeHtml(a.athleteName || a.token);

    // Build per-section button arrays so the markup stays organised
    // and an empty section drops out cleanly. Sections: PLAN /
    // ATHLETE / LLM (tmb-llm-zone) / DANGER. Section labels +
    // dividers are visual scaffolding only, same actions as before
    // but easier to scan in a 9-item menu.
    var planItems = [];
    var athleteItems = [];
    var llmItems = [];
    var dangerItems = [];

    // PLAN
    if (!archived) {
      planItems.push('<button data-athlete-sheet="' + token + '">Open Google Sheet ↗</button>');
      planItems.push('<button data-athlete-rename="' + token + '">Rename plan</button>');
      planItems.push('<button data-athlete-import="' + token + '">Import plan</button>');
      planItems.push('<button data-athlete-undo-import="' + token + '" data-athlete-name="' + name + '" title="Restore previous programme from archive, undoes the last importPlan operation">↶ Undo last import</button>');
      planItems.push('<button data-athlete-new-programme="' + token + '">New programme</button>');
      // Force-bust the athlete's plan cache. Use after editing Google
      // Sheets directly when you don't want them to wait for the 10-min
      // TTL to see your changes. (#28)
      planItems.push('<button data-athlete-bust-cache="' + token + '">Refresh athlete\'s view</button>');
    }

    // ATHLETE
    athleteItems.push('<button data-edit-athlete="' + token + '">Edit</button>');
    athleteItems.push('<button data-copy-token="' + token + '">Copy token</button>');
    if (a.email && a.pageUrl && !archived) {
      athleteItems.push('<button data-athlete-resend="' + token + '">' +
        (a.emailConfirmed ? 'Resend invite' : 'Send invite') + '</button>');
    }
    if (String(a.groupType || '').toLowerCase() !== 'solo') {
      athleteItems.push('<button data-group-members="' + token + '">' +
        'View members (' + ((a.members && a.members.length) || 0) + ')</button>');
    }

    // LLM (Premium-tier; gated via .tmb-llm-zone on each button +
    // section divider). Same action as the drawer's "Ask LLM"
    // button, surfaces it one click higher for the common case
    // of "send the LLM the latest state of this athlete".
    if (!archived) {
      llmItems.push('<button class="tmb-llm-zone" data-athlete-ai-chat="' + token + '" data-athlete-name="' + name + '">Chat with AI</button>');
      llmItems.push('<button class="tmb-llm-zone" data-athlete-ask-llm="' + token + '" data-athlete-name="' + name + '" title="5-week window, Mode B incremental updates">Export bundle for Claude.ai</button>');
      llmItems.push('<button class="tmb-llm-zone" data-athlete-ask-llm-full="' + token + '" data-athlete-name="' + name + '" title="ALL weeks + sessions + programmed-sets, Mode A full rebuild">Export FULL plan for Claude.ai</button>');
    }

    // DANGER
    if (!archived) {
      var nextBlock = blocked ? 'active' : 'blocked';
      dangerItems.push('<button data-athlete-status="' + token + '" data-status="' + nextBlock + '">' +
        (blocked ? 'Unblock' : 'Block') + '</button>');
      dangerItems.push('<button data-athlete-status="' + token + '" data-status="archived">Archive</button>');
    } else {
      dangerItems.push('<button data-athlete-status="' + token + '" data-status="active">Restore</button>');
    }
    if (state.info && state.info.trainer && state.info.trainer.role === 'admin') {
      dangerItems.push('<button class="admin-overflow-danger" data-athlete-delete="' + token +
        '" data-athlete-name="' + name + '">Delete permanently</button>');
    }

    function section(label, btns, extraClass) {
      if (!btns.length) return '';
      var cls = 'admin-overflow-section' + (extraClass ? ' ' + extraClass : '');
      return '<div class="' + cls + '">' +
        '<div class="admin-overflow-section-label">' + label + '</div>' +
        btns.join('') +
      '</div>';
    }

    return '<div class="admin-overflow-menu" role="menu">' +
      section('PLAN',    planItems) +
      section('ATHLETE', athleteItems) +
      section('🤖 AI',   llmItems, 'tmb-llm-zone') +
      section('DANGER',  dangerItems) +
    '</div>';
  }

  // Trainers management, collapsible at the bottom of the admin
  // overview. Shows the trainer cards (block / archive / resend code)
  // separated from the athletes table above.
  function renderTrainersManagement_(trainers, allA, meToken, opts) {
    opts = opts || {};
    var byTrainer = {};
    allA.forEach(function (a) {
      if (!byTrainer[a.trainerToken]) byTrainer[a.trainerToken] = [];
      byTrainer[a.trainerToken].push(a);
    });
    var activeTrainers   = trainers.filter(function (tr) { return String(tr.status || '').toLowerCase() !== 'archived'; });
    var archivedTrainers = trainers.filter(function (tr) { return String(tr.status || '').toLowerCase() === 'archived'; });

    var html = '';
    if (!opts.archivedOnly) {
      html += '<details class="admin-trainers-block" data-key="trainers-active">' +
        '<summary>Trainers <span class="meta">(' + activeTrainers.length + ')</span></summary>' +
        '<div class="admin-trainers-body">' +
          (activeTrainers.length
            ? activeTrainers.map(function (tr) { return renderTrainerBlock_(tr, byTrainer[tr.token] || [], meToken); }).join('')
            : '<div class="coach-empty">No trainers yet.</div>') +
          renderNewTrainerSection() +
        '</div></details>';
    }
    if (!opts.activeOnly && archivedTrainers.length) {
      html += '<details class="coach-archived-block coach-archived-trainers" data-key="trainers-archived">' +
        '<summary>Archived trainers <span class="meta">(' + archivedTrainers.length + ')</span></summary>' +
        '<div class="coach-archived-body">' +
          archivedTrainers.map(function (tr) {
            return renderTrainerBlock_(tr, byTrainer[tr.token] || [], meToken);
          }).join('') +
        '</div></details>';
    }
    return html;
  }

  // Single trainer card. Reused by the active list + the Archived
  // collapsible. tr = trainer record, allA = their athletes (any status),
  // meToken = the signed-in trainer's token (so we don't show
  // self-block / self-archive controls).
  function renderTrainerBlock_(tr, allA, meToken) {
    var their     = allA.filter(function (a) { return String(a.status || '').toLowerCase() !== 'archived'; });
    var archived  = allA.filter(function (a) { return String(a.status || '').toLowerCase() === 'archived'; });
    var statusLower = String(tr.status || 'active').toLowerCase();
    var blocked      = statusLower === 'blocked';
    var trainerArchived = statusLower === 'archived';
    var isSelf = tr.token === meToken;
    var actions = '<div class="coach-trainer-actions">';
    if (!isSelf) {
      if (trainerArchived) {
        actions += '<button class="trainer-action" data-trainer-block="' + escapeHtml(tr.token) + '" data-status="active">Restore</button>';
      } else {
        actions += '<button class="trainer-action" data-trainer-block="' + escapeHtml(tr.token) + '" data-status="' + (blocked ? 'active' : 'blocked') + '">' +
          (blocked ? 'Unblock' : 'Block') +
          '</button>';
        actions += '<button class="trainer-action secondary" data-trainer-block="' + escapeHtml(tr.token) + '" data-status="archived">Archive</button>';
      }
    }
    if (tr.email && !trainerArchived) {
      actions += '<button class="trainer-action secondary" data-trainer-resend="' + escapeHtml(tr.token) + '">Resend code</button>';
    }
    // Permanent delete, admin-only, irreversible. Hidden on the row
    // for the currently-signed-in admin (you can't nuke yourself).
    if (!isSelf) {
      actions += '<button class="trainer-action danger" data-trainer-delete="' + escapeHtml(tr.token) +
        '" data-trainer-name="' + escapeHtml(tr.name || tr.token) + '">Delete</button>';
    }
    actions += '</div>';
    // Each trainer is its own <details>. The summary holds the title +
    // badges + roster count so admins can scan the trainer list at a
    // glance; opening shows the email, action buttons, and athlete
    // list. data-key keeps manual open/close state across re-renders.
    var dataKey = 'trainer-block:' + tr.token;
    return '<details class="coach-trainer-block' + ((blocked || trainerArchived) ? ' is-blocked' : '') +
      '" data-key="' + escapeHtml(dataKey) + '">' +
      '<summary class="coach-trainer-head">' +
      '<span class="title" style="font-weight:600;">' + escapeHtml(tr.name) + '</span>' +
      '<span class="role' + (tr.role === 'admin' ? ' admin' : '') + '">' + escapeHtml(tr.role) + '</span>' +
      (blocked ? '<span class="badge blocked">blocked</span>' : '') +
      (trainerArchived ? '<span class="badge archived">archived</span>' : '') +
      (tr.email && !tr.emailConfirmed ? '<span class="badge unconfirmed" title="Email not confirmed">unconfirmed</span>' : '') +
      '<span class="meta" style="margin-left:auto; font-size:12px; color:#777;">' +
        their.length + ' athlete' + (their.length === 1 ? '' : 's') +
        (archived.length ? '  ·  ' + archived.length + ' archived' : '') +
      '</span>' +
      '</summary>' +
      (tr.email ? '<div class="coach-trainer-meta">' + escapeHtml(tr.email) + '</div>' : '') +
      actions +
      (their.length ? '<div class="coach-trainer-list">' +
        their.map(function (a) {
          var statusLow = String(a.status || 'active').toLowerCase();
          var isArch = statusLow === 'archived';
          var initial = ((a.athleteName || a.planTitle || '?').trim().charAt(0) || '?').toUpperCase();
          var openHref = a.pageUrl ? addQuery_(a.pageUrl, 'mode=trainer') : '';
          return '<div class="coach-athlete-row' + (isArch ? ' is-archived' : '') + '">' +
            '<div class="ca-row-avatar" aria-hidden="true">' + escapeHtml(initial) + '</div>' +
            '<div class="ca-row-body">' +
              '<div class="ca-row-name">' + escapeHtml(a.athleteName || a.planTitle) +
                (a.email && !a.emailConfirmed ? ' <span class="badge unconfirmed" title="Email not confirmed">unconfirmed</span>' : '') +
                (isArch ? ' <span class="badge archived">archived</span>' : '') +
              '</div>' +
              (a.email ? '<div class="ca-row-meta">' + escapeHtml(a.email) + '</div>' : '') +
            '</div>' +
            '<div class="ca-row-meta-right">' + escapeHtml(formatRelative(a.lastActive)) + '</div>' +
            (openHref ? '<a class="ca-row-open" href="' + escapeHtml(openHref) + '" target="_blank" rel="noopener" title="Open plan in new tab">↗</a>' : '') +
            '</div>';
        }).join('') +
        '</div>' : '') +
      '</details>';
  }

  function renderNewTrainerSection() {
    if (!state.showNewTrainer) {
      return '<div class="coach-toolbar"><button id="coach-show-new-trainer">+ New Trainer</button><span></span></div>';
    }
    return '<div class="coach-form" id="coach-new-trainer-form">' +
      '<h3>New trainer</h3>' +
      '<div class="row">' +
      '<div><label>Name *</label><input id="ct-name" type="text" placeholder="e.g. Joe Bloggs" autocomplete="off"></div>' +
      '<div><label>Email (optional)</label><input id="ct-email" type="email" placeholder="joe@example.com"></div>' +
      '<div><label>Role</label><select id="ct-role"><option value="trainer">trainer</option><option value="admin">admin</option></select></div>' +
      '</div>' +
      '<div class="actions">' +
      '<button id="ct-submit">Create trainer</button>' +
      '<button id="ct-cancel" class="secondary" style="margin-left: 8px;">Cancel</button>' +
      '</div>' +
      '<div id="ct-result"></div>' +
      '</div>';
  }

  function wireUp() {
    // Portal the row overflow menu to document.body, escapes any
    // ancestor containing-block / overflow weirdness (the table
    // wrapper's overflow-x:auto on mobile was confining the menu
    // inside the "Your athletes" box on iOS Safari, with no internal
    // scroll). Done at the top of wireUp so the document-level
    // querySelectorAll handler attachments below find the menu's
    // buttons whether they live in .coach-root or on body.
    var staleMenu = document.querySelector('body > .admin-overflow-menu');
    if (staleMenu) staleMenu.remove();
    if (state.openOverflow != null && state.info) {
      var allRoster = (state.info.athletes || []).concat(state.info.allAthletes || []);
      var openToken = String(state.openOverflow).split('|').pop();
      var openA = allRoster.find(function (x) { return x.token === openToken; });
      if (openA) {
        var menuShell = document.createElement('div');
        menuShell.innerHTML = renderAdminOverflowMenu_(openA);
        var menuEl = menuShell.firstElementChild;
        if (menuEl) document.body.appendChild(menuEl);
      }
    }

    // Top nav, view switching + sign out.
    document.querySelectorAll('.coach-nav-link[data-view]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setView(btn.getAttribute('data-view'));
      });
    });
    var helpBtn = document.getElementById('coach-nav-help');
    if (helpBtn) helpBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (document.getElementById('tmb-tour-menu')) {
        closeTmbTourMenuIfOpen_();
      } else {
        openTmbTourMenu_();
      }
    });
    var signOut = document.getElementById('coach-signout');
    if (signOut) signOut.addEventListener('click', function (e) {
      e.preventDefault();
      state.token = ''; state.info = null;
      try { localStorage.removeItem(STORAGE_KEY); } catch (er) {}
      render();
    });

    // Bug-report footer button, opens the modal once per page load.
    document.querySelectorAll('[data-coach-bug-report]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openCoachBugModal();
      });
    });

    document.querySelectorAll('[data-copy-token]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = b.getAttribute('data-copy-token');
        if (navigator.clipboard) navigator.clipboard.writeText(t).then(function () { toast('Token copied'); });
        else toast(t);
      });
    });

    // Inline "Add page URL", quick prompt → save → re-fetch.
    document.querySelectorAll('[data-set-pageurl]').forEach(function (b) {
      b.addEventListener('click', function () {
        var token = b.getAttribute('data-set-pageurl');
        var current = (state.info.athletes.find(function (a) { return a.token === token; }) || {}).pageUrl || '';
        var url = prompt('Paste the athlete\'s training plan page URL:\n(e.g. https://assassingoods.com/pages/sarah-training)', current);
        if (url == null) return;
        url = String(url).trim();
        savePageUrl(token, url);
      });
    });

    // Edit athlete, opens an inline edit drawer with email + page URL.
    document.querySelectorAll('[data-edit-athlete]').forEach(function (b) {
      b.addEventListener('click', function () {
        var token = b.getAttribute('data-edit-athlete');
        openAthleteEditDrawer(token);
      });
    });

    var showNa = document.getElementById('coach-show-new-athlete');
    if (showNa) showNa.addEventListener('click', function () { state.showNewAthlete = true; render(); });
    var caCancel = document.getElementById('ca-cancel');
    if (caCancel) caCancel.addEventListener('click', function () {
      state.showNewAthlete = false;
      // Cancel also drops any pending intake seed so the next "+ New
      // Athlete" click starts fresh without re-pre-filling.
      state.intakeParsed = null;
      state.intakeSeed = '';
      render();
    });
    var caSubmit = document.getElementById('ca-submit');
    if (caSubmit) caSubmit.addEventListener('click', submitNewAthlete);

    // Intake form generator, toggle open, pick depth, download .md.
    var showIntake = document.getElementById('coach-show-intake');
    if (showIntake) showIntake.addEventListener('click', function () {
      state.showIntake = !state.showIntake;
      render();
    });

    // Example-plan button, reuse-or-mint a demo athlete owned by the
    // caller, open in new tab. Useful for new trainers exploring the
    // page before they provision their first real athlete.
    var showDemo = document.getElementById('coach-show-demo');
    if (showDemo) showDemo.addEventListener('click', function () {
      var orig = showDemo.textContent;
      showDemo.disabled = true; showDemo.textContent = 'Opening…';

      // Open the modal IMMEDIATELY in a "provisioning" state. That
      // way the trainer can't miss it (full-screen dimmed backdrop)
      // and gets continuous feedback while the POST is in flight.
      // The modal mutates in place when the POST resolves, into a
      // success state with a big Open button, or an error state
      // with a Retry button. No silent failures possible.
      var modal = showDemoProvisioningModal_();

      postAction('provisionDemo', {})
        .then(function (j) {
          showDemo.disabled = false; showDemo.textContent = orig;
          if (!j.ok) {
            mutateDemoModalToError_(modal, j.error || 'Unknown server error');
            return;
          }
          var url = j.athlete && j.athlete.pageUrl;
          if (!url) {
            mutateDemoModalToError_(modal, 'Demo created but no URL returned');
            return;
          }
          var trainerUrl = addQuery_(url, 'mode=trainer');
          mutateDemoModalToSuccess_(modal, trainerUrl, !!j.reused);
          if (!j.reused) {
            fetchInfo().then(function (j2) { state.info = j2; writeInfoCache(j2); render(); }).catch(function () {});
          }
        })
        .catch(function (e) {
          showDemo.disabled = false; showDemo.textContent = orig;
          var msg = (e && e.message) || 'Network error';
          mutateDemoModalToError_(modal,
            msg + '. The demo may still be provisioning server-side, ' +
            'wait 60 seconds and click Example plan again. The lock will ' +
            'find the in-progress one instead of starting a new build.');
        });
    });

    // Open a centred provisioning modal. Returns the overlay element
    // so the click-handler can mutate its content in place when the
    // POST resolves.
    function showDemoProvisioningModal_() {
      var existing = document.getElementById('coach-demo-ready-modal');
      if (existing) existing.remove();
      var overlay = document.createElement('div');
      overlay.id = 'coach-demo-ready-modal';
      // Same external-CSS-override pattern that hit the Activity
      // drawer yesterday: inline cssText 'display:flex' gets
      // overridden by a display:none !important rule elsewhere on
      // the live store. setProperty with 'important' beats it.
      overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:99999;align-items:center;justify-content:center;padding:24px;';
      overlay.style.setProperty('display', 'flex', 'important');
      var card = document.createElement('div');
      card.id = 'coach-demo-card';
      // Light theme to match the coach page palette (was dark).
      card.style.cssText = 'background:#FFFFFF;color:#1A1918;border-radius:14px;box-shadow:0 20px 50px rgba(0,0,0,0.25);padding:30px;max-width:480px;width:100%;text-align:center;font-family:inherit;';
      card.innerHTML =
        '<div style="width:42px;height:42px;border:3px solid #E5E2D9;border-top-color:#1A1918;border-radius:50%;margin:0 auto 18px;animation:tmbSpin 1s linear infinite;"></div>' +
        '<div style="font-size:20px;font-weight:600;margin:0 0 8px;">Provisioning your demo plan…</div>' +
        '<div style="font-size:14px;color:#777775;margin:0 0 4px;line-height:1.5;">This takes 30-60 seconds. We\'re cloning the template sheet and seeding three weeks of example sessions.</div>' +
        '<div style="font-size:13px;color:#9a9a92;margin-top:10px;">Stay on this page; the button below appears when it\'s ready.</div>';
      // Inject the spin keyframes once.
      if (!document.getElementById('tmb-spin-style')) {
        var st = document.createElement('style');
        st.id = 'tmb-spin-style';
        st.textContent = '@keyframes tmbSpin{to{transform:rotate(360deg);}}';
        document.head.appendChild(st);
      }
      overlay.appendChild(card);
      document.body.appendChild(overlay);
      // Don't allow dismiss while provisioning, closing mid-flight is
      // confusing (the demo would still get created, with no link).
      // After mutateDemoModalToSuccess_ / Error_, dismiss handlers wire up.
      return overlay;
    }

    function mutateDemoModalToSuccess_(overlay, url, reused) {
      var card = overlay.querySelector('#coach-demo-card');
      if (!card) return;
      var title = reused ? '👤 Your demo plan is ready' : '✓ Demo plan created';
      var sub   = reused
        ? 'You already had a demo, opening that one so we don\'t pile up duplicates.'
        : 'Fully populated example plan with three weeks of varied sessions, photos, sets, and notes. Edit it freely.';
      card.innerHTML =
        '<div style="font-size:20px;font-weight:600;margin:0 0 8px;color:#1A1918;">' + escapeHtml(title) + '</div>' +
        '<div style="font-size:14px;color:#777775;margin:0 0 22px;line-height:1.5;">' + escapeHtml(sub) + '</div>' +
        '<a id="coach-demo-open-link" href="' + escapeAttr(url) + '" target="_blank" rel="noopener" style="display:inline-block;background:#1E7A47;color:#fff;padding:14px 28px;border-radius:10px;text-decoration:none;font-weight:600;font-size:15px;">Open demo plan ↗</a>' +
        '<div style="margin-top:14px;"><button type="button" data-demo-close style="background:transparent;border:0;color:#777775;font-size:13px;cursor:pointer;text-decoration:underline;">Close</button></div>';
      wireDemoModalDismiss_(overlay);
      card.querySelector('#coach-demo-open-link').addEventListener('click', function () {
        setTimeout(function () { closeDemoModal_(overlay); }, 100);
      });
    }

    function mutateDemoModalToError_(overlay, errorMsg) {
      var card = overlay.querySelector('#coach-demo-card');
      if (!card) return;
      card.innerHTML =
        '<div style="font-size:20px;font-weight:600;margin:0 0 8px;color:#c74638;">Couldn\'t provision the demo</div>' +
        '<div style="font-size:14px;color:#5E2419;margin:0 0 22px;line-height:1.5;text-align:left;background:#FCE4DC;border:1px solid #E8B5A4;padding:12px 14px;border-radius:8px;">' + escapeHtml(String(errorMsg)) + '</div>' +
        '<button type="button" id="coach-demo-retry" style="background:#1E7A47;color:#fff;padding:12px 22px;border-radius:10px;border:0;font-weight:600;font-size:14px;cursor:pointer;">Retry</button>' +
        '<div style="margin-top:14px;"><button type="button" data-demo-close style="background:transparent;border:0;color:#777775;font-size:13px;cursor:pointer;text-decoration:underline;">Close</button></div>';
      wireDemoModalDismiss_(overlay);
      card.querySelector('#coach-demo-retry').addEventListener('click', function () {
        closeDemoModal_(overlay);
        // Re-fire the original click handler by simulating a click on
        // the toolbar button. Same code path, same lock, same fast-
        // reuse path.
        var btn = document.getElementById('coach-show-demo');
        if (btn) btn.click();
      });
    }

    function closeDemoModal_(overlay) {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }

    function wireDemoModalDismiss_(overlay) {
      function onEsc(e) {
        if (e.key === 'Escape') { closeDemoModal_(overlay); document.removeEventListener('keydown', onEsc); }
      }
      document.addEventListener('keydown', onEsc);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) closeDemoModal_(overlay); });
      overlay.querySelectorAll('[data-demo-close]').forEach(function (b) {
        b.addEventListener('click', function () { closeDemoModal_(overlay); });
      });
    }

    // Build the placeholder `data:` URL for the demo-prep tab. Kept
    // as a separate function so the HTML literal lives away from the
    // main click-handler flow, and so we never put raw HTML
    // (especially `<\/body><\/html>`) into a string concat the parser
    // could misread. Escaped tags (`<\/x>`) are JS-equivalent to the
    // unescaped form but keep the script's HTML parser-state clean.
    function buildDemoPlaceholderDataUrl_() {
      var parts = [
        '<!doctype html>',
        '<html><head><meta charset="utf-8">',
        '<title>Preparing your demo plan…</title>',
        '<style>',
        'html,body{margin:0;height:100%;background:#0f1115;color:#e6e6e0;',
        'font-family:-apple-system,system-ui,sans-serif;',
        'display:flex;align-items:center;justify-content:center;text-align:center;}',
        '.box{max-width:420px;padding:40px;}',
        '.spin{width:36px;height:36px;border:3px solid #333;',
        'border-top-color:#fff;border-radius:50%;margin:0 auto 18px;',
        'animation:s 1s linear infinite;}',
        '@keyframes s{to{transform:rotate(360deg);}}',
        'h1{font-size:18px;margin:0 0 8px;}',
        'p{margin:0;color:#9a9a92;font-size:14px;line-height:1.5;}',
        '<\/style>',
        '<\/head><body><div class="box"><div class="spin"><\/div>',
        '<h1>Preparing your demo plan…<\/h1>',
        '<p>This usually takes 30-60 seconds. The page will refresh ',
        'automatically when it\'s ready.<\/p><\/div><\/body><\/html>'
      ];
      return 'data:text/html;charset=utf-8,' + encodeURIComponent(parts.join(''));
    }

    // "Demo ready. Open" pill that always shows after a successful
    // provisionDemo. The Open button is a real <a> click so browsers
    // treat it as a fresh user gesture (no popup-block). Dismiss × or
    // auto-fades after 30 s.
    function showOpenDemoPill_(url, reused) {
      var existing = document.getElementById('coach-open-demo-pill');
      if (existing) existing.remove();
      var pill = document.createElement('div');
      pill.id = 'coach-open-demo-pill';
      pill.style.cssText = 'position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:#1E7A47;color:#fff;padding:14px 20px;border-radius:10px;box-shadow:0 6px 20px rgba(0,0,0,0.25);z-index:9999;font-size:14px;display:flex;gap:14px;align-items:center;max-width:90vw;';
      var label = reused ? '👤 Your demo is ready' : '✓ Demo plan provisioned';
      pill.innerHTML =
        '<span style="font-weight:500;">' + escapeHtml(label) + '</span>' +
        '<a href="' + escapeAttr(url) + '" target="_blank" rel="noopener" style="background:#fff;color:#1E7A47;padding:8px 16px;border-radius:6px;text-decoration:none;font-weight:600;font-size:14px;">Open ↗</a>' +
        '<button type="button" style="background:transparent;border:0;color:#fff;font-size:20px;cursor:pointer;padding:0 4px;line-height:1;" aria-label="Dismiss">×</button>';
      document.body.appendChild(pill);
      pill.querySelector('button').addEventListener('click', function () { pill.remove(); });
      // Auto-dismiss after 30 s, long enough for the trainer to notice + click.
      setTimeout(function () { if (pill.parentNode) pill.remove(); }, 30000);
    }

    // From-Intake, paste filled-in intake, parse, pre-fill New Athlete.
    var showFromIntake = document.getElementById('coach-show-from-intake');
    if (showFromIntake) showFromIntake.addEventListener('click', function () {
      state.showFromIntake = !state.showFromIntake;
      // Close the other intake panel if open so they don't stack.
      if (state.showFromIntake) state.showIntake = false;
      render();
    });
    var fiCancel = document.getElementById('fi-cancel');
    if (fiCancel) fiCancel.addEventListener('click', function () {
      state.showFromIntake = false;
      render();
    });
    var fiFile = document.getElementById('fi-file');
    if (fiFile) fiFile.addEventListener('change', function () {
      var f = fiFile.files && fiFile.files[0];
      if (!f) return;
      var reader = new FileReader();
      reader.onload = function () {
        var ta = document.getElementById('fi-textarea');
        if (ta) ta.value = String(reader.result || '');
      };
      reader.onerror = function () { toast('Could not read file'); };
      reader.readAsText(f);
    });
    var fiParse = document.getElementById('fi-parse');
    if (fiParse) fiParse.addEventListener('click', function () {
      var ta = document.getElementById('fi-textarea');
      var text = ta ? String(ta.value || '').trim() : '';
      var resultEl = document.getElementById('fi-parse-result');
      if (!text) {
        if (resultEl) resultEl.innerHTML = '<div style="padding:8px 12px;background:#FCE4DC;border:1px solid #E8B5A4;border-radius:6px;color:#5E2419;font-size:12px;">Nothing to parse, paste an intake or upload a file first.</div>';
        return;
      }
      var parsed = parseIntakeMarkdown_(text);
      if (!parsed.name) {
        if (resultEl) resultEl.innerHTML = '<div style="padding:8px 12px;background:#FBF1D9;border:1px solid #D9C880;border-radius:6px;color:#6B5418;font-size:12px;">Couldn\'t find a <strong>Full name</strong> field in the intake. Either fix the markdown or fill the Name in manually after opening the form.</div>';
      }
      state.intakeParsed = { name: parsed.name, timeZone: parsed.timeZone };
      state.intakeSeed   = parsed.raw;
      state.showFromIntake = false;
      state.showNewAthlete = true;
      render();
    });
    var intakeCancel = document.getElementById('intake-cancel');
    if (intakeCancel) intakeCancel.addEventListener('click', function () {
      state.showIntake = false;
      render();
    });
    var intakeDownload = document.getElementById('intake-download');
    if (intakeDownload) intakeDownload.addEventListener('click', function () {
      var picked = document.querySelector('input[name="intake-depth"]:checked');
      downloadIntakeForm_(picked ? picked.value : 'quick');
    });

    // New Group: toggle, cancel, submit, +Add member, remove member.
    var showNg = document.getElementById('coach-show-new-group');
    if (showNg) showNg.addEventListener('click', function () { state.showNewGroup = true; render(); });
    var cgCancel = document.getElementById('cg-cancel');
    if (cgCancel) cgCancel.addEventListener('click', function () { state.showNewGroup = false; render(); });
    var cgSubmit = document.getElementById('cg-submit');
    if (cgSubmit) cgSubmit.addEventListener('click', submitNewGroup);
    var cgAddMember = document.getElementById('cg-add-member');
    if (cgAddMember) cgAddMember.addEventListener('click', function () {
      // Snapshot current row values into state before re-render so
      // partially-typed entries survive the +Add tick.
      syncNewGroupMembersFromDom_();
      state.newGroupMembers.push({ name: '', email: '' });
      render();
    });
    document.querySelectorAll('[data-cg-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        syncNewGroupMembersFromDom_();
        var idx = parseInt(btn.getAttribute('data-cg-remove'), 10);
        if (idx >= 0 && state.newGroupMembers.length > 1) {
          state.newGroupMembers.splice(idx, 1);
          render();
        } else if (state.newGroupMembers.length === 1) {
          // Don't let them remove the last row, just blank it.
          state.newGroupMembers = [{ name: '', email: '' }];
          render();
        }
      });
    });

    // Bulk CSV paste toggle, reveal the textarea + parse button.
    var bulkToggle = document.getElementById('cg-bulk-toggle');
    if (bulkToggle) bulkToggle.addEventListener('click', function () {
      var area = document.getElementById('cg-bulk-area');
      if (!area) return;
      area.hidden = !area.hidden;
      if (!area.hidden) {
        var ta = document.getElementById('cg-bulk-csv');
        if (ta) ta.focus();
      }
    });
    var bulkParse = document.getElementById('cg-bulk-parse');
    if (bulkParse) bulkParse.addEventListener('click', parseBulkCsv_);
    var exportCsv = document.getElementById('cg-export-csv');
    if (exportCsv) exportCsv.addEventListener('click', exportGroupMembersCsv_);

    var showNt = document.getElementById('coach-show-new-trainer');
    if (showNt) showNt.addEventListener('click', function () { state.showNewTrainer = true; render(); });
    var ctCancel = document.getElementById('ct-cancel');
    if (ctCancel) ctCancel.addEventListener('click', function () { state.showNewTrainer = false; render(); });
    var ctSubmit = document.getElementById('ct-submit');
    if (ctSubmit) ctSubmit.addEventListener('click', submitNewTrainer);
    var prefsSave = document.getElementById('email-prefs-save');
    if (prefsSave) prefsSave.addEventListener('click', submitEmailPrefs);

    // Admin: Block / Unblock / Archive / Restore trainer. Optimistic,
    // updates state + cascades locally before the POST. Revert on error.
    document.querySelectorAll('[data-trainer-block]').forEach(function (b) {
      b.addEventListener('click', function () {
        var trainerToken = b.getAttribute('data-trainer-block');
        var nextStatus = b.getAttribute('data-status');
        var copy = TRAINER_STATUS_COPY[nextStatus] || TRAINER_STATUS_COPY.active;
        if (!confirm(copy.confirm)) return;

        // Snapshot for rollback.
        var snapshot = {
          trainerStatus: null,
          cascaded: [],   // [{ list: 'athletes'|'allAthletes', idx, prevStatus }]
        };

        // Flip trainer status locally.
        var trIdx = -1;
        if (state.info.allTrainers) {
          trIdx = state.info.allTrainers.findIndex(function (x) { return x.token === trainerToken; });
          if (trIdx >= 0) {
            snapshot.trainerStatus = state.info.allTrainers[trIdx].status;
            state.info.allTrainers[trIdx].status = nextStatus;
          }
        }
        // Cascade-archive locally (server does the same, this just keeps
        // the UI in sync without waiting on a re-fetch).
        var cascadedCount = 0;
        if (nextStatus === 'archived') {
          ['athletes', 'allAthletes'].forEach(function (listKey) {
            var list = state.info[listKey];
            if (!list) return;
            list.forEach(function (a, i) {
              if (a.trainerToken !== trainerToken) return;
              var s = String(a.status || '').toLowerCase();
              if (s === 'archived') return;
              snapshot.cascaded.push({ list: listKey, idx: i, prevStatus: a.status });
              a.status = 'archived';
              if (listKey === 'athletes') cascadedCount++;  // don't double-count
            });
          });
        }
        state.openOverflow = null;
        writeInfoCache(state.info);
        render();
        var msg = copy.toast;
        if (nextStatus === 'archived' && cascadedCount) {
          msg += ', also archived ' + cascadedCount + ' athlete' + (cascadedCount === 1 ? '' : 's');
        }
        toast(msg);

        postAction('setTrainerStatus', { trainerToken: trainerToken, status: nextStatus })
          .then(function (j) {
            if (!j.ok) {
              // Revert everything.
              if (trIdx >= 0 && snapshot.trainerStatus != null) {
                state.info.allTrainers[trIdx].status = snapshot.trainerStatus;
              }
              snapshot.cascaded.forEach(function (c) {
                state.info[c.list][c.idx].status = c.prevStatus;
              });
              writeInfoCache(state.info);
              render();
              toast('Failed: ' + (j.error || 'unknown'));
            }
            // Server may have archived athletes the client didn't know about
            // (e.g. mid-session creates). If counts diverge, a quiet refresh
            // pulls canonical state without blocking the UI.
            if (j.ok && nextStatus === 'archived' &&
                typeof j.athletesArchived === 'number' &&
                j.athletesArchived !== cascadedCount) {
              fetchInfo().then(function (j2) { state.info = j2; writeInfoCache(j2); render(); }).catch(function () {});
            }
          })
          .catch(function (e) {
            if (trIdx >= 0 && snapshot.trainerStatus != null) {
              state.info.allTrainers[trIdx].status = snapshot.trainerStatus;
            }
            snapshot.cascaded.forEach(function (c) {
              state.info[c.list][c.idx].status = c.prevStatus;
            });
            writeInfoCache(state.info);
            render();
            toast('Network error: ' + e.message);
          });
      });
    });

    // Admin: Resend trainer welcome email.
    document.querySelectorAll('[data-trainer-resend]').forEach(function (b) {
      b.addEventListener('click', function () {
        var trainerToken = b.getAttribute('data-trainer-resend');
        b.disabled = true; b.textContent = 'Sending…';
        postAction('resendTrainerWelcome', { trainerToken: trainerToken })
          .then(function (j) {
            b.disabled = false; b.textContent = 'Resend code';
            if (!j.ok) { toast('Failed: ' + (j.error || 'unknown')); return; }
            toast('Welcome email re-sent');
          })
          .catch(function (e) {
            b.disabled = false; b.textContent = 'Resend code';
            toast('Network error: ' + e.message);
          });
      });
    });

    // Admin: Permanently delete a trainer. Two-step confirm, first
    // confirm() to read the warning, second prompt() requires the
    // trainer's name to be typed. Server cascade-trashes the trainer's
    // athletes + sheets too.
    document.querySelectorAll('[data-trainer-delete]').forEach(function (b) {
      b.addEventListener('click', function () {
        var trainerToken = b.getAttribute('data-trainer-delete');
        var trainerName  = b.getAttribute('data-trainer-name') || trainerToken;
        if (!confirm(
          'PERMANENTLY DELETE trainer "' + trainerName + '"?\n\n' +
          'This trashes the trainer + every one of their athletes\' plan sheets.\n' +
          'It cannot be undone (Drive trash is recoverable for 30 days, then gone).\n\n' +
          'Click OK to continue to a final confirmation.'
        )) return;
        var typed = prompt(
          'Type the trainer\'s name to confirm:\n\n' + trainerName
        );
        if (typed == null) return;
        if (String(typed).trim() !== String(trainerName).trim()) {
          toast('Name didn\'t match, delete cancelled.');
          return;
        }
        b.disabled = true;
        var orig = b.textContent;
        b.textContent = 'Deleting…';
        postAction('deleteTrainer', { trainerToken: trainerToken })
          .then(function (j) {
            if (!j.ok) {
              b.disabled = false; b.textContent = orig;
              toast('Failed: ' + (j.error || 'unknown'));
              return;
            }
            toast('Trainer deleted (' + (j.athletesTrashed || 0) + ' athletes trashed)');
            // Force a fresh fetch, the local cache no longer matches.
            state.info = null;
            fetchInfo().then(function (j2) {
              state.info = j2; writeInfoCache(j2); render();
            }).catch(function () {});
          })
          .catch(function (e) {
            b.disabled = false; b.textContent = orig;
            toast('Network error: ' + e.message);
          });
      });
    });

    // Admin: Permanently delete an athlete. Two-step confirm.
    document.querySelectorAll('[data-athlete-delete]').forEach(function (b) {
      b.addEventListener('click', function () {
        var athleteToken = b.getAttribute('data-athlete-delete');
        var athleteName  = b.getAttribute('data-athlete-name') || athleteToken;
        if (!confirm(
          'PERMANENTLY DELETE athlete "' + athleteName + '"?\n\n' +
          'This trashes the plan sheet + every photo / video they\'ve uploaded.\n' +
          'It cannot be undone (Drive trash is recoverable for 30 days, then gone).\n\n' +
          'Click OK to continue to a final confirmation.'
        )) return;
        var typed = prompt(
          'Type the athlete\'s name to confirm:\n\n' + athleteName
        );
        if (typed == null) return;
        if (String(typed).trim() !== String(athleteName).trim()) {
          toast('Name didn\'t match, delete cancelled.');
          return;
        }
        state.openOverflow = null;
        b.disabled = true;
        b.textContent = 'Deleting…';
        postAction('deleteAthletePermanent', { athleteToken: athleteToken })
          .then(function (j) {
            if (!j.ok) {
              b.disabled = false; b.textContent = 'Delete permanently';
              toast('Failed: ' + (j.error || 'unknown'));
              return;
            }
            toast('Athlete "' + athleteName + '" deleted');
            state.info = null;
            fetchInfo().then(function (j2) {
              state.info = j2; writeInfoCache(j2); render();
            }).catch(function () {});
          })
          .catch(function (e) {
            b.disabled = false; b.textContent = 'Delete permanently';
            toast('Network error: ' + e.message);
          });
      });
    });

    // View members of a group/gym plan. Opens an inline drawer
    // listing every member's name + email + per-member booking count
    // (gym plans). No server round-trip, uses PLAN.members + the
    // existing coachInfo response. Read-only for now; member-edit
    // (add/remove) will land here next.
    document.querySelectorAll('[data-group-members]').forEach(function (b) {
      b.addEventListener('click', function () {
        var token = b.getAttribute('data-group-members');
        closeOpenOverflowMenu_();
        openGroupMembersDrawer_(token);
      });
    });

    // Send / Resend athlete invite. Server checks email + pageUrl + perms.
    document.querySelectorAll('[data-athlete-resend]').forEach(function (b) {
      b.addEventListener('click', function () {
        var athleteToken = b.getAttribute('data-athlete-resend');
        var orig = b.textContent;
        b.disabled = true; b.textContent = 'Sending…';
        postAction('resendAthleteWelcome', { athleteToken: athleteToken })
          .then(function (j) {
            b.disabled = false; b.textContent = orig;
            if (!j.ok) { toast('Failed: ' + (j.error || 'unknown')); return; }
            toast('Invite sent');
          })
          .catch(function (e) {
            b.disabled = false; b.textContent = orig;
            toast('Network error: ' + e.message);
          });
      });
    });

    // 📊 Activity click handling is now done via a single delegated
    // listener attached once at IIFE boot (see bottom of file). Per-
    // button binding here was racing with the 30s background poll's
    // re-renders, the button would disappear between mousedown and
    // click on some passes, dropping the click silently. Delegation
    // on document.body survives any re-render.

    // "Refresh athlete's view", bust the athlete's plan cache so they
    // see a fresh read of the Google Sheet on their next page load,
    // without waiting for the 10-min cache TTL. Used after the trainer
    // edited the sheet directly. (#28)
    document.querySelectorAll('[data-athlete-bust-cache]').forEach(function (b) {
      b.addEventListener('click', function () {
        var athleteToken = b.getAttribute('data-athlete-bust-cache');
        var orig = b.textContent;
        b.disabled = true; b.textContent = 'Refreshing…';
        state.openOverflow = null;
        postAction('bustAthleteCache', { athleteToken: athleteToken })
          .then(function (j) {
            b.disabled = false; b.textContent = orig;
            if (!j.ok) { toast('Refresh failed: ' + (j.error || 'unknown')); return; }
            toast('Cache cleared, athlete will see fresh data on next load');
          })
          .catch(function (e) {
            b.disabled = false; b.textContent = orig;
            toast('Network error: ' + e.message);
          });
      });
    });

    // "Open Google Sheet ↗", opens the athlete's sheet in a new tab.
    // Trainer uses File → Download in Sheets if they want CSV/Excel,
    // or just edits live.
    document.querySelectorAll('[data-athlete-sheet]').forEach(function (b) {
      b.addEventListener('click', function () {
        var athleteToken = b.getAttribute('data-athlete-sheet');
        var orig = b.textContent;
        b.disabled = true; b.textContent = 'Opening…';
        state.openOverflow = null;
        postAction('sheetLink', { athleteToken: athleteToken })
          .then(function (j) {
            b.disabled = false; b.textContent = orig;
            if (!j.ok || !j.sheetUrl) { toast('Open failed: ' + (j.error || 'no URL')); return; }
            window.open(j.sheetUrl, '_blank', 'noopener');
          })
          .catch(function (e) {
            b.disabled = false; b.textContent = orig;
            toast('Network error: ' + e.message);
          });
      });
    });

    // Rename plan, prompt for the new title, then POST renamePlan
    // which updates both the Directory's Athletes row and the Settings
    // tab on the athlete sheet. Native prompt is fine here, modal
    // text input, no live timer to keep ticking. On success refresh
    // coachInfo so the row name + plan title meta line both update.
    document.querySelectorAll('[data-athlete-rename]').forEach(function (b) {
      b.addEventListener('click', function () {
        var athleteToken = b.getAttribute('data-athlete-rename');
        state.openOverflow = null;
        var current = '';
        try {
          var a = (state.info.athletes || []).concat(state.info.allAthletes || [])
            .find(function (x) { return x.token === athleteToken; });
          current = (a && a.planTitle) || '';
        } catch (_e) {}
        var next = prompt('Rename plan to:', current);
        if (next == null) return;       // user cancelled
        next = String(next).trim();
        if (!next) { toast('Plan title can\'t be empty'); return; }
        if (next === current) return;   // no change
        var orig = b.textContent;
        b.disabled = true; b.textContent = 'Renaming…';
        postAction('renamePlan', { athleteToken: athleteToken, planTitle: next })
          .then(function (j) {
            b.disabled = false; b.textContent = orig;
            if (!j || !j.ok) { toast('Rename failed: ' + ((j && j.error) || 'unknown')); return; }
            toast('Renamed to ' + j.planTitle);
            fetchInfo().then(function (j2) { state.info = j2; writeInfoCache(j2); render(); }).catch(function () {});
          })
          .catch(function (e) {
            b.disabled = false; b.textContent = orig;
            toast('Network error: ' + e.message);
          });
      });
    });

    // Import plan, file picker accepts multiple CSVs (one per tab).
    // Filename → tab name mapping is best-effort: matches the suffix
    // before .csv against PLAN_TABS, ignoring case + non-alphanumerics.
    document.querySelectorAll('[data-athlete-import]').forEach(function (b) {
      b.addEventListener('click', function () {
        var athleteToken = b.getAttribute('data-athlete-import');
        var ath = state.info.athletes.find(function (x) { return x.token === athleteToken; }) || {};
        var name = ath.athleteName || 'this athlete';
        state.openOverflow = null;
        openImportPlanModal_(athleteToken, name);
      });
    });

    // Undo last import, calls server's `undoLastImport` which copies
    // the most-recent archive (Programme N-1) tabs back into the live
    // tabs. Use when a botched import wrote wrong data. (Audit H7.)
    document.querySelectorAll('[data-athlete-undo-import]').forEach(function (b) {
      b.addEventListener('click', function () {
        var athleteToken = b.getAttribute('data-athlete-undo-import');
        var name = b.getAttribute('data-athlete-name') || 'this athlete';
        state.openOverflow = null;
        if (!confirm('Undo the most recent import for ' + name + '?\n\n' +
            'This restores their Import / Weeks / Block Overview / Day Notes / Roadmap / Checkpoints / Injury Management / Categories tabs from the previous programme archive.\n\n' +
            'Use when you just imported the wrong data. The current (broken) state will be lost, undoing the undo means re-importing.')) {
          return;
        }
        toast('Restoring previous programme…');
        postAction('undoLastImport', { athleteToken: athleteToken }).then(function (j) {
          if (!j || !j.ok) { toast('Undo failed: ' + ((j && j.error) || 'unknown')); return; }
          toast('Restored, refresh the plan page to verify');
          fetchInfo().then(function (j2) { state.info = j2; writeInfoCache(j2); render(); }).catch(function () {});
        }).catch(function (e) {
          toast('Undo error: ' + (e && e.message || 'network'));
        });
      });
    });

    document.querySelectorAll('[data-athlete-new-programme]').forEach(function (b) {
      b.addEventListener('click', function () {
        var athleteToken = b.getAttribute('data-athlete-new-programme');
        var ath = state.info.athletes.find(function (x) { return x.token === athleteToken; }) || {};
        var name = ath.athleteName || 'this athlete';
        if (!confirm('Start a new programme for ' + name + '?\n\n' +
            'Their current sessions, weeks, blocks, day notes, roadmap, ' +
            'checkpoints, tick history and per-set logs will be archived ' +
            '(hidden tabs in the spreadsheet, recoverable any time).\n\n' +
            'Their PBs, Injury Management, photo history and Drive folders ' +
            'stay in place. The athlete keeps the same token, page URL ' +
            'and email.\n\n' +
            'Ready to wipe the active plan and start fresh?')) return;
        var orig = b.textContent;
        b.disabled = true; b.textContent = 'Archiving…';
        postAction('startNewProgramme', { athleteToken: athleteToken })
          .then(function (j) {
            b.disabled = false; b.textContent = orig;
            if (!j.ok) { toast('Failed: ' + (j.error || 'unknown')); return; }
            toast('Programme ' + j.programme + ' started, sheet cleared, history archived');
          })
          .catch(function (e) {
            b.disabled = false; b.textContent = orig;
            toast('Network error: ' + e.message);
          });
      });
    });

    // Block / Unblock / Archive / Restore athlete. Optimistic, update
    // local state + re-render IMMEDIATELY, then fire the POST. If the
    // server rejects, revert to the previous status and toast the error.
    //
    // In-flight guard: rapid double-clicks (the optimistic re-render
    // makes it visually look like nothing has happened mid-network,
    // so users sometimes click twice) would fire two POSTs against
    // the same token. The server handler is idempotent so impact is
    // small, but skipping the duplicate cuts network noise and
    // prevents any edge race between the second POST's response
    // landing after the first revert.
    if (!window.__tmbInFlightStatusFlip_) window.__tmbInFlightStatusFlip_ = {};
    var inFlight = window.__tmbInFlightStatusFlip_;
    document.querySelectorAll('[data-athlete-status]').forEach(function (b) {
      b.addEventListener('click', function () {
        var athleteToken = b.getAttribute('data-athlete-status');
        if (inFlight[athleteToken]) return;
        var nextStatus = b.getAttribute('data-status');
        var copy = ATHLETE_STATUS_COPY[nextStatus] || ATHLETE_STATUS_COPY.active;
        if (!confirm(copy.confirm)) return;
        inFlight[athleteToken] = true;

        var prevStatusByList = { athletes: null, allAthletes: null };
        var idx = state.info.athletes.findIndex(function (x) { return x.token === athleteToken; });
        if (idx >= 0) {
          prevStatusByList.athletes = state.info.athletes[idx].status;
          state.info.athletes[idx].status = nextStatus;
        }
        var aidx = -1;
        if (state.info.allAthletes) {
          aidx = state.info.allAthletes.findIndex(function (x) { return x.token === athleteToken; });
          if (aidx >= 0) {
            prevStatusByList.allAthletes = state.info.allAthletes[aidx].status;
            state.info.allAthletes[aidx].status = nextStatus;
          }
        }
        state.openOverflow = null;
        writeInfoCache(state.info);
        render();
        toast(copy.toast);

        postAction('setAthleteStatus', { athleteToken: athleteToken, status: nextStatus })
          .then(function (j) {
            delete inFlight[athleteToken];
            if (!j.ok) {
              // Revert.
              if (idx >= 0 && prevStatusByList.athletes != null) {
                state.info.athletes[idx].status = prevStatusByList.athletes;
              }
              if (aidx >= 0 && prevStatusByList.allAthletes != null) {
                state.info.allAthletes[aidx].status = prevStatusByList.allAthletes;
              }
              writeInfoCache(state.info);
              render();
              toast('Failed: ' + (j.error || 'unknown'));
            }
          })
          .catch(function (e) {
            delete inFlight[athleteToken];
            if (idx >= 0 && prevStatusByList.athletes != null) {
              state.info.athletes[idx].status = prevStatusByList.athletes;
            }
            if (aidx >= 0 && prevStatusByList.allAthletes != null) {
              state.info.allAthletes[aidx].status = prevStatusByList.allAthletes;
            }
            writeInfoCache(state.info);
            render();
            toast('Network error: ' + e.message);
          });
      });
    });

    wireAdminTable_();
  }

  // Toggle the right-edge fade + "swipe" hint based on whether the
  // user has scrolled to the end of the horizontal range. Both the
  // hint and gradient hide when the wrapper has .is-end. Re-wired on
  // every render() because the wrapper element gets recreated.
  function wireAdminTableScrollHint_() {
    document.querySelectorAll('.admin-table-wrapper').forEach(function (wrap) {
      var update = function () {
        var atEnd = wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 4;
        wrap.classList.toggle('is-end', atEnd);
      };
      update();
      wrap.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    });
  }

  // Wire the dashboard-table-specific controls: search input, filter
  // chips, sortable column headers, ⋯ overflow menus. Re-wired on
  // Partial-render only the .admin-table-wrapper elements without
  // touching the surrounding DOM. Called from the search-input
  // handler (typing in the search box hits this; chips / sort /
  // status flips still fall through to full render()). Each
  // wrapper carries its data-table-key, we use that to derive
  // the right source list off state.info and feed it back into
  // renderAdminAthletesTable_. Then re-run wireAdminTable_ to
  // re-bind the click handlers on the replaced rows (delegation
  // handles 📊 / ⋯ / Open plan via document-level listeners; this
  // mostly rebinds sort-header clicks + per-row inline buttons).
  function refreshAdminTables_() {
    if (!state.info) return;
    var trainerByToken = {};
    (state.info.allTrainers || []).forEach(function (tr) { trainerByToken[tr.token] = tr; });

    // Mirror the data split that render() uses (lines 759-763).
    var allMine = state.info.athletes || [];
    var athletesMine = allMine.filter(function (a) { return !isGroupPlan(a); });
    var groupsMine   = allMine.filter(isGroupPlan);
    var allAdmin     = state.info.allAthletes || [];

    var sources = {
      'mine':   { data: athletesMine, opts: { showTrainer: false, tableKey: 'mine' } },
      'groups': { data: groupsMine,   opts: { showTrainer: false, tableKey: 'groups' } },
      'admin':  { data: allAdmin,     opts: { tableKey: 'admin' } },
    };

    document.querySelectorAll('.admin-table-wrapper').forEach(function (wrap) {
      var key = wrap.getAttribute('data-table-key') || 'mine';
      var src = sources[key];
      if (!src) return;
      var freshHtml = renderAdminAthletesTable_(src.data, trainerByToken, src.opts);
      // Replace just this wrapper (outerHTML keeps siblings intact).
      wrap.outerHTML = freshHtml;
    });

    // Re-bind row-level click handlers + sort headers for the new
    // wrapper(s). idempotent: existing listeners on un-touched
    // elements (toolbars, etc.) stay; old listeners on replaced
    // wrappers are GC'd with the old nodes.
    wireAdminTable_();
  }

  // every render() because the elements get torn down and recreated.
  function wireAdminTable_() {
    wireAdminTableScrollHint_();
    // Multiple search boxes (one per table), typing in either updates
    // the shared state.adminSearch and partial-renders the table
    // wrappers instead of doing a full page render. Massive win at
    // 200+ rows where a full render is ~600 ms and the search felt
    // janky. The toolbar (including the search input) is NOT
    // replaced, so input focus + caret position survive without
    // any focus-restore dance.
    document.querySelectorAll('.admin-toolbar').forEach(function (toolbar) {
      var input = toolbar.querySelector('.admin-search');
      if (!input) return;
      input.addEventListener('input', function (e) {
        state.adminSearch = e.target.value;
        if (adminSearchDebounce_) clearTimeout(adminSearchDebounce_);
        adminSearchDebounce_ = setTimeout(refreshAdminTables_, 120);
      });
    });
    document.querySelectorAll('[data-admin-filter]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var key = chip.getAttribute('data-admin-filter');
        state.adminFilters[key] = !state.adminFilters[key];
        // Always keep at least one status chip on, otherwise the table
        // looks empty for no obvious reason.
        var anyOn = ['active','blocked','archived'].some(function (k) { return state.adminFilters[k]; });
        if (!anyOn) state.adminFilters[key] = true;
        render();
      });
    });
    document.querySelectorAll('.admin-table th[data-sort]').forEach(function (th) {
      th.addEventListener('click', function () {
        var col = th.getAttribute('data-sort');
        if (state.adminSort.column === col) {
          state.adminSort.dir = state.adminSort.dir === 'asc' ? 'desc' : 'asc';
        } else {
          state.adminSort.column = col;
          // Names sort A→Z by default; activity sorts most-recent first.
          state.adminSort.dir = (col === 'lastActivity') ? 'desc' : 'asc';
        }
        render();
      });
    });
    document.querySelectorAll('[data-overflow-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        // Value is "<tableKey>|<athleteToken>" so the same athlete in
        // two tables doesn't open both menus at once.
        var overflowKey = btn.getAttribute('data-overflow-toggle');
        state.openOverflow = state.openOverflow === overflowKey ? null : overflowKey;
        render();
      });
    });
    // Anchor the floating overflow menu (position: fixed) against the
    // trigger button it belongs to. Done after render so the menu
    // exists in the DOM. Re-runs on resize / scroll to follow the
    // trigger if the user pans the page.
    positionOverflowMenu_();
  }

  function positionOverflowMenu_() {
    if (state.openOverflow == null) return;
    var trigger = document.querySelector('[data-overflow-toggle="' + state.openOverflow + '"]');
    var menu = document.querySelector('.admin-overflow-menu');
    if (!trigger || !menu) return;
    var rect = trigger.getBoundingClientRect();
    var menuRect = menu.getBoundingClientRect();
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    // Default: open downward + right-aligned to trigger.
    var top = rect.bottom + 4;
    var right = vw - rect.right;
    // Flip upward if there's not enough room below.
    if (top + menuRect.height > vh - 8 && rect.top - 4 - menuRect.height > 8) {
      top = rect.top - 4 - menuRect.height;
    }
    // Clamp to viewport.
    top = Math.max(8, Math.min(top, vh - menuRect.height - 8));
    right = Math.max(8, Math.min(right, vw - menuRect.width - 8));
    menu.style.top = top + 'px';
    menu.style.right = right + 'px';
    menu.style.left = '';
  }
  window.addEventListener('resize', positionOverflowMenu_);
  // Close on window scroll, standard dropdown UX. Repositioning the
  // menu as the page scrolls left the menu "floating" detached from
  // its trigger when the user scrolled the table away; closing
  // instead matches every other native dropdown.
  window.addEventListener('scroll', function () {
    if (state.openOverflow == null) return;
    state.openOverflow = null;
    if (state.info) render();
  }, { passive: true });
  var adminSearchDebounce_ = null;

  // Document-level click + Esc handler, closes any open overflow menu
  // when the user clicks outside it. Attached once at IIFE init.
  document.addEventListener('click', function (e) {
    if (state.openOverflow == null) return;
    if (e.target.closest('.admin-overflow-menu')) return;   // clicked inside a menu, let action fire
    if (e.target.closest('[data-overflow-toggle]')) return; // toggle handler manages its own state
    if (e.target.closest('.athlete-edit-overlay, .coach-bug-modal')) return; // modal is on top, don't render-wipe it
    state.openOverflow = null;
    if (state.info) render();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.openOverflow != null) {
      state.openOverflow = null;
      if (state.info) render();
    }
  });
  // UX strings keyed by the new status. Same shape for trainers + athletes
  // so the click handlers stay symmetrical between the admin overview and
  // the athlete cards.
  var TRAINER_STATUS_COPY = {
    blocked:  {
      confirm: 'Block this trainer? They\'ll lose coach-page access immediately. Their athletes stay in place. They can\'t sign in to manage them until you unblock.',
      busy:    'Blocking…',
      toast:   'Trainer blocked',
    },
    archived: {
      confirm: 'Archive this trainer?\n\nThey\'ll lose coach-page access AND every active/blocked athlete they own will be archived too (so orphaned plans don\'t keep firing emails).\n\nAlready-archived athletes stay archived. All data is preserved, restore individually any time.',
      busy:    'Archiving…',
      toast:   'Trainer archived',
    },
    active:   {
      confirm: 'Restore this trainer? They\'ll regain coach-page access immediately and move back to the active list.',
      busy:    'Restoring…',
      toast:   'Trainer restored',
    },
  };
  var ATHLETE_STATUS_COPY = {
    blocked:  {
      confirm: 'Block this athlete? They\'ll lose access to their plan immediately. Their data is preserved, unblock to restore.',
      busy:    'Blocking…',
      toast:   'Athlete blocked',
    },
    archived: {
      confirm: 'Archive this athlete? They\'ll lose plan access and move to the Archived section. Their data is preserved, restore any time to bring them back.',
      busy:    'Archiving…',
      toast:   'Athlete archived',
    },
    active:   {
      confirm: 'Restore this athlete? They\'ll regain plan access immediately and move back to the active list.',
      busy:    'Restoring…',
      toast:   'Athlete restored',
    },
  };

  function submitEmailPrefs() {
    var btn = document.getElementById('email-prefs-save');
    var status = document.getElementById('email-prefs-status');
    if (status) status.textContent = '';
    var prefs = [];
    document.querySelectorAll('input[data-pref-owner][data-pref-type]').forEach(function (cb) {
      prefs.push({
        ownerToken: cb.getAttribute('data-pref-owner'),
        type: cb.getAttribute('data-pref-type'),
        subscribed: cb.checked,
      });
    });
    // Update local state immediately so future renders reflect the new
    // settings without a re-fetch.
    if (state.info && state.info.emailPrefs) {
      var trainerToken = state.info.trainer && state.info.trainer.token;
      prefs.forEach(function (p) {
        if (p.ownerToken === trainerToken) {
          state.info.emailPrefs.mine[p.type] = p.subscribed;
        } else {
          if (!state.info.emailPrefs.athletes[p.ownerToken]) state.info.emailPrefs.athletes[p.ownerToken] = {};
          state.info.emailPrefs.athletes[p.ownerToken][p.type] = p.subscribed;
        }
      });
      writeInfoCache(state.info);
    }
    btn.disabled = true; btn.textContent = 'Saving…';
    postAction('setEmailPreferences', { prefs: prefs })
      .then(function (j) {
        btn.disabled = false; btn.textContent = 'Save preferences';
        if (!j.ok) {
          toast('Save failed: ' + (j.error || 'unknown'));
          return;
        }
        if (status) {
          status.textContent = 'Saved ✓';
          setTimeout(function () { if (status) status.textContent = ''; }, 3000);
        }
      })
      .catch(function (e) {
        btn.disabled = false; btn.textContent = 'Save preferences';
        toast('Network error: ' + e.message);
      });
  }

  function savePageUrl(token, url) {
    // Optimistic update, set the URL locally + re-render instantly,
    // then POST in the background. Failure path reverts.
    var idx = state.info.athletes.findIndex(function (a) { return a.token === token; });
    var prev = idx >= 0 ? state.info.athletes[idx].pageUrl : '';
    if (idx >= 0) state.info.athletes[idx].pageUrl = url;
    render();
    writeInfoCache(state.info);
    postAction('updateAthlete', { athleteToken: token, fields: { 'Page URL': url } })
      .then(function (j) {
        if (!j.ok) {
          if (idx >= 0) state.info.athletes[idx].pageUrl = prev;
          render();
          writeInfoCache(state.info);
          toast('Save failed: ' + (j.error || 'unknown'));
          return;
        }
        toast('Page URL saved');
      })
      .catch(function (e) {
        if (idx >= 0) state.info.athletes[idx].pageUrl = prev;
        render();
        toast('Network error: ' + e.message);
      });
  }

  // Group / gym plan members drawer, list every member's name +
  // email, with the option to copy the list. Read-only for now;
  // gym plans self-register members on first booking so the list
  // grows automatically as people join. Bookings count placeholder
  // for a future enrichment.
  function openGroupMembersDrawer_(token) {
    var a = (state.info.athletes || []).concat(state.info.allAthletes || [])
      .find(function (x) { return x.token === token; });
    if (!a) { toast('Plan not found'); return; }
    var gt = String(a.groupType || '').toLowerCase();
    var typeLabel = gt === 'gym' ? 'Gym'
                  : gt === 'large_group' ? 'Broadcast group'
                  : 'Group';
    var overlay = document.createElement('div');
    overlay.className = 'group-members-overlay';
    document.body.appendChild(overlay);
    var close = function () { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); };

    // Look up the current members list freshly each render so add/remove
    // mutations reflect immediately after refreshInfo_() resolves.
    function currentMembers_() {
      var fresh = (state.info.athletes || []).concat(state.info.allAthletes || [])
        .find(function (x) { return x.token === token; });
      return ((fresh && fresh.members) || []).slice().sort(function (x, y) {
        var xn = (x.name || x.email || '').toLowerCase();
        var yn = (y.name || y.email || '').toLowerCase();
        return xn < yn ? -1 : xn > yn ? 1 : 0;
      });
    }
    function refreshInfo_() {
      return fetchInfo().then(function (j2) {
        state.info = j2; writeInfoCache(j2); render(); renderModal_();
      }).catch(function () {});
    }

    function renderModal_() {
      var members = currentMembers_();
      var rows = members.length
        ? '<table class="group-members-table"><thead><tr><th>Name</th><th>Email</th><th>Joined</th><th></th></tr></thead><tbody>' +
          members.map(function (m) {
            var emailAttr = escapeAttr(String(m.email || ''));
            return '<tr>' +
              '<td>' + escapeHtml(m.name || '-') + '</td>' +
              '<td>' + escapeHtml(m.email || '') + '</td>' +
              '<td>' + (m.emailConfirmed ? '✓' : '<span class="meta">pending</span>') + '</td>' +
              '<td><button type="button" class="group-members-remove" data-email="' + emailAttr + '" aria-label="Remove">×</button></td>' +
            '</tr>';
          }).join('') +
          '</tbody></table>'
        : '<div class="coach-empty">No members yet. ' +
          (gt === 'gym' ? 'Anyone who books a class self-registers automatically.' :
            'Add members via the form below.') +
          '</div>';
      // Add-member form: name (optional) + email (required), or paste
      // one-per-line "Name <email>" / bare emails for bulk add. Gym
      // plans self-register via class booking, no add form needed.
      var addForm = gt === 'gym' ? '' :
        '<form class="group-members-add">' +
          '<div class="group-members-add-row">' +
            '<input type="text" name="name" placeholder="Name (optional)" autocomplete="off">' +
            '<input type="email" name="email" placeholder="Email" autocomplete="off" required>' +
            '<button type="submit" class="primary">+ Add member</button>' +
          '</div>' +
          '<details class="group-members-bulk"><summary>Or paste a list</summary>' +
            '<textarea name="bulk" rows="4" placeholder="One per line, &quot;Sarah Greaves &lt;sarah@example.com&gt;&quot; or just sarah@example.com"></textarea>' +
            '<button type="button" class="group-members-bulk-add">Add bulk</button>' +
          '</details>' +
        '</form>';
      overlay.innerHTML =
        '<div class="group-members-modal">' +
          '<div class="group-members-header">' +
            '<div class="group-members-title">' + escapeHtml(a.athleteName || a.planTitle || 'Group plan') + '</div>' +
            '<div class="group-members-sub">' + typeLabel + ' · ' + members.length + ' member' + (members.length === 1 ? '' : 's') + '</div>' +
            '<button type="button" class="group-members-close" aria-label="Close">×</button>' +
          '</div>' +
          '<div class="group-members-body">' + rows + '</div>' +
          addForm +
          '<div class="group-members-actions">' +
            (members.length ? '<button type="button" class="group-members-copy">Copy CSV</button>' : '') +
          '</div>' +
        '</div>';
      // Wire close + copy + remove + add.
      overlay.querySelector('.group-members-close').addEventListener('click', close);
      var copyBtn = overlay.querySelector('.group-members-copy');
      if (copyBtn) copyBtn.addEventListener('click', function () {
        var csv = 'Name,Email\n' + members.map(function (m) {
          var n = String(m.name || '').replace(/"/g, '""');
          var e = String(m.email || '').replace(/"/g, '""');
          return '"' + n + '","' + e + '"';
        }).join('\n');
        if (navigator.clipboard) navigator.clipboard.writeText(csv).then(function () { toast('CSV copied'); });
        else toast('Copy not supported in this browser');
      });
      Array.prototype.forEach.call(overlay.querySelectorAll('.group-members-remove'), function (btn) {
        btn.addEventListener('click', function () {
          var email = btn.getAttribute('data-email') || '';
          if (!email) return;
          if (!confirm('Remove ' + email + ' from this group?\n\nTheir tick / note history stays on the plan sheet as an audit trail. They can be re-added later with the same email and their data will be preserved.')) return;
          btn.disabled = true; btn.textContent = '…';
          postAction('removeGroupMember', { athleteToken: token, email: email })
            .then(function (r) {
              if (r && r.ok) { toast('Member removed'); refreshInfo_(); }
              else { toast('Remove failed: ' + ((r && r.error) || 'unknown')); btn.disabled = false; btn.textContent = '×'; }
            })
            .catch(function () { toast('Remove failed'); btn.disabled = false; btn.textContent = '×'; });
        });
      });
      var form = overlay.querySelector('.group-members-add');
      if (form) {
        form.addEventListener('submit', function (ev) {
          ev.preventDefault();
          var nameEl = form.querySelector('[name="name"]');
          var emailEl = form.querySelector('[name="email"]');
          var name = (nameEl.value || '').trim();
          var email = (emailEl.value || '').trim();
          if (!email) { emailEl.focus(); return; }
          var btn = form.querySelector('button[type="submit"]');
          btn.disabled = true; btn.textContent = 'Adding…';
          postAction('addGroupMembers', { athleteToken: token, members: [{ name: name, email: email }] })
            .then(function (r) {
              if (r && r.ok) {
                var added = (r.added || []).length;
                toast(added ? ('Added ' + added + ' member' + (added === 1 ? '' : 's')) : 'Already a member');
                refreshInfo_();
              } else { toast('Add failed: ' + ((r && r.error) || 'unknown')); }
            })
            .catch(function () { toast('Add failed'); })
            .then(function () { btn.disabled = false; btn.textContent = '+ Add member'; });
        });
        var bulkBtn = form.querySelector('.group-members-bulk-add');
        if (bulkBtn) bulkBtn.addEventListener('click', function () {
          var ta = form.querySelector('[name="bulk"]');
          var lines = (ta.value || '').split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
          var bulk = lines.map(function (line) {
            var m = line.match(/^([^<]+?)\s*<([^>]+)>\s*$/);
            if (m) return { name: m[1].trim(), email: m[2].trim() };
            if (line.indexOf('@') > 0) return { name: '', email: line };
            return null;
          }).filter(Boolean);
          if (!bulk.length) { toast('No valid emails found'); return; }
          bulkBtn.disabled = true; bulkBtn.textContent = 'Adding…';
          postAction('addGroupMembers', { athleteToken: token, members: bulk })
            .then(function (r) {
              if (r && r.ok) {
                toast('Added ' + ((r.added || []).length) + ' · skipped ' + ((r.skipped || []).length));
                refreshInfo_();
              } else { toast('Add failed: ' + ((r && r.error) || 'unknown')); }
            })
            .catch(function () { toast('Add failed'); })
            .then(function () { bulkBtn.disabled = false; bulkBtn.textContent = 'Add bulk'; });
        });
      }
    }

    overlay.addEventListener('click', function (ev) { if (ev.target === overlay) close(); });
    renderModal_();
  }

  // Coach Insights drawer. Activity-only first slice. Opens with a
  // loading spinner, fires the athleteActivity action, then renders
  // the per-athlete summary (notes, photos, videos, PBs, lastActive,
  // sessions-done count). Per the #71 design, future slices (Reply,
  // Plan context, Metrics) live in the same scaffold under their own
  // sub-sections.
  function openCoachInsightsDrawer_(athleteToken, athleteName) {
    closeOpenOverflowMenu_();
    // Defensive cleanup, kill any stale full-screen overlays that
    // might still be in the DOM from previous interactions. The demo
    // modal (#coach-demo-ready-modal, z-index 99999) has been buggy
    // and could be sitting invisible-but-click-blocking over the
    // dashboard, which is why the 📊 button "stopped working" for
    // some trainers. Same defensive sweep on any old activity drawer.
    killStaleOverlays_();
    var overlay = document.createElement('div');
    overlay.id = 'coach-insights-overlay';
    overlay.className = 'athlete-edit-overlay';
    // Overlay lives on document.body, outside the .coach-root scope
    // where the CSS custom-properties (--card, --heading, --note,
    // --border, --page, --meta) are defined. Without those vars the
    // drawer's background was transparent and the dashboard bled
    // through. Hardcode the colour scheme with conservative fallbacks
    // here so the drawer always paints solid regardless of where it's
    // appended.
    overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,0.45);align-items:center;justify-content:center;padding:20px;';
    overlay.style.setProperty('display', 'flex', 'important');
    // Light theme to match the coach page palette: cream page,
    // white cards, warm borders, near-black text. Same swatches as
    // .coach-root (--page #F7F6F2, --card #FFF, --heading #1A1918,
    // etc.) hardcoded here because the drawer lives on document.body
    // outside .coach-root's CSS-var scope.
    overlay.innerHTML =
      '<div class="athlete-edit-drawer ci-drawer" style="background:#FFFFFF;color:#1A1918;border-radius:12px;padding:0;width:100%;max-width:min(980px, 96vw);max-height:92vh;flex-direction:column;box-shadow:0 20px 50px rgba(0,0,0,0.25);overflow:hidden;">' +
      '<div class="ci-header" style="padding:18px 22px 12px;border-bottom:1px solid #E5E2D9;flex:0 0 auto;background:#FFFFFF;">' +
        '<div style="font-size:11px;color:#777775;font-family:DM Mono,monospace;letter-spacing:0.04em;text-transform:uppercase;">Activity · last 7 days</div>' +
        '<h3 style="margin:4px 0 0;font-size:18px;color:#1A1918;">' + escapeHtml(athleteName) + '</h3>' +
      '</div>' +
      '<div id="ci-body" style="flex:1 1 auto;overflow-y:auto;padding:14px 22px;background:#F7F6F2;">' +
        '<div style="text-align:center;padding:40px 20px;color:#777775;">' +
          '<div class="tmb-plan-spinner" aria-hidden="true" style="margin: 0 auto 12px;"></div>' +
          'Loading the last 7 days of activity…' +
        '</div>' +
      '</div>' +
      '<div class="athlete-edit-actions" style="padding:12px 22px;border-top:1px solid #E5E2D9;flex:0 0 auto;background:#FFFFFF;display:flex;justify-content:flex-end;">' +
        '<button class="secondary" id="ci-close" style="padding:8px 16px;border-radius:6px;border:1px solid #D6D2C7;background:#FFFFFF;color:#1A1918;cursor:pointer;font:inherit;font-size:13px;">Close</button>' +
      '</div>' +
      '</div>';
    // Append to document.body. NOT coach-root, because render()
    // replaces coach-root's innerHTML on every poll / state change.
    // The 30s coachInfo poll was wiping the drawer roughly the moment
    // it opened ("button opens and closes straight away"). Body is
    // outside the render scope, so the overlay survives any number
    // of background re-renders.
    document.body.appendChild(overlay);
    // Force display:flex on the inner drawer too, same external-CSS
    // override risk as the outer overlay.
    var drawer = overlay.querySelector('.ci-drawer');
    if (drawer) drawer.style.setProperty('display', 'flex', 'important');
    function close() { overlay.remove(); }
    overlay.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target === overlay) close();
    });
    overlay.querySelector('#ci-close').addEventListener('click', close);

    // Drawer-side activity cache. Re-opening the same athlete's drawer
    // (very common, close, reply, reopen to check) used to pay the
    // full ~2-3s round-trip every time. Now we serve a <60s-old entry
    // instantly and fire a background refresh that swaps in fresh data
    // when it lands. (#65 perf audit F8 / F)
    if (!state.activityCache) state.activityCache = {};
    var cachedEntry = state.activityCache[athleteToken];
    var cacheAgeMs = cachedEntry ? (Date.now() - cachedEntry.at) : Infinity;
    var CACHE_TTL_MS = 60 * 1000;
    // Cache-hit fast path: render the HTML body from the cached
    // response so the drawer shows data within ~50ms. Event wiring
    // (kudos buttons, reply forms, mark-seen, etc.) is NOT applied
    // here, the fresh postAction below arrives in 1-2s and does a
    // full rebuild that re-wires everything. Brief window of
    // non-interactive buttons is acceptable in exchange for perceived
    // instant load; most trainers spend the first 1-2s reading, not
    // clicking.
    if (cachedEntry && cacheAgeMs < CACHE_TTL_MS) {
      var bodyEl = overlay.querySelector('#ci-body');
      if (bodyEl) {
        bodyEl.innerHTML = renderCoachInsightsActivity_(cachedEntry.data);
        loadCoachThumbs_(bodyEl, athleteToken);
      }
    }

    postAction('athleteActivity', { athleteToken: athleteToken, days: 7 })
      .then(function (j) {
        if (j && j.ok) {
          state.activityCache[athleteToken] = { at: Date.now(), data: j };
        }
        var body = overlay.querySelector('#ci-body');
        if (!body) return;
        if (!j.ok) {
          // If we already rendered from cache, keep that on screen rather
          // than wiping it with an error, the cached view is still
          // useful even if the refresh failed.
          if (cachedEntry && cacheAgeMs < CACHE_TTL_MS) return;
          body.innerHTML = '<div style="padding:14px;background:#FCE4DC;border:1px solid #E8B5A4;border-radius:6px;color:#5E2419;">Failed to load: ' + escapeHtml(j.error || 'unknown') + '</div>';
          return;
        }
        body.innerHTML = renderCoachInsightsActivity_(j);
        // Wire the Messages compose + mark-read flow (#33 Phase C).
        // Mark-read fires immediately so the badge clears on next
        // open even if the trainer doesn't reply this session.
        bindCoachInsightsMessages_(body, athleteToken, j.unreadFromAthlete || 0);
        // Wire the media loader for photos AND video thumbs. Uses the
        // athlete's own token (proxy is athlete-scoped) so falls back
        // through the same /exec batched-thumb pipeline the athlete
        // page uses, same cache, same fallback chain.
        loadCoachThumbs_(body, athleteToken);
        // Wire per-day Mark seen / Mark unseen toggle buttons. Seen
        // = no NEW pill, day collapsed. Unseen = bumps seen-record
        // back so day re-flags any activity newer than the original
        // timestamps. Server flips both directions via the same
        // markActivitySeen action with an `unseen` flag.
        overlay.querySelectorAll('.ci-mark-day-seen').forEach(function (btn) {
          btn.addEventListener('click', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();   // don't toggle the <details>
            var dayKey = btn.getAttribute('data-day-key');
            if (!dayKey) return;
            var isSeen = btn.getAttribute('data-seen') === '1';
            var originalLabel = btn.textContent;
            btn.disabled = true; btn.textContent = '…';
            postAction('markActivitySeen', { athleteToken: athleteToken, dayKey: dayKey, unseen: isSeen ? true : false })
              .then(function (r) {
                if (!r.ok) { toast('Failed: ' + (r.error || 'unknown'), 'error'); btn.disabled = false; btn.textContent = originalLabel; return; }
                var det = btn.closest('details.ci-day');
                if (isSeen) {
                  // Unmark: flip button to "Mark seen", keep day open.
                  btn.setAttribute('data-seen', '0');
                  btn.textContent = 'Mark seen';
                  btn.disabled = false;
                } else {
                  // Mark seen: clear NEW pills, collapse, flip button
                  // to "Mark unseen" (no longer removed, stays for undo).
                  if (det) {
                    det.querySelectorAll('.ci-new-pill').forEach(function (el) { el.remove(); });
                    det.open = false;
                  }
                  btn.setAttribute('data-seen', '1');
                  btn.textContent = 'Mark unseen';
                  btn.disabled = false;
                }
              })
              .catch(function (e) {
                btn.disabled = false; btn.textContent = originalLabel;
                toast('Network error: ' + (e && e.message || 'unknown'), 'error');
              });
          });
        });

        // Delegated click for video tiles → open the streaming
        // lightbox (Worker proxy, with Drive /preview iframe fallback).
        body.addEventListener('click', function (ev) {
          var vt = ev.target.closest('[data-ci-video]');
          if (!vt || !body.contains(vt)) return;
          ev.preventDefault();
          openCoachVideoLightbox_(vt.getAttribute('data-ci-video'));
        });

        // "Mark all as seen", collect every still-unseen day in the
        // drawer + flip them in one round-trip (server accepts a
        // dayKeys array). Then clear NEW pills + collapse days + flip
        // the per-day buttons + clear the header "N new" pill.
        var markAllBtn = overlay.querySelector('#ci-mark-all-seen');
        if (markAllBtn) {
          markAllBtn.addEventListener('click', function () {
            var unseenBtns = Array.prototype.slice.call(
              overlay.querySelectorAll('.ci-mark-day-seen[data-seen="0"]'));
            var dayKeys = unseenBtns.map(function (b) { return b.getAttribute('data-day-key'); }).filter(Boolean);
            if (!dayKeys.length) { toast('Nothing new to mark'); return; }
            markAllBtn.disabled = true; markAllBtn.textContent = 'Marking…';
            postAction('markActivitySeen', { athleteToken: athleteToken, dayKeys: dayKeys })
              .then(function (r) {
                if (!r.ok) { toast('Failed: ' + (r.error || 'unknown'), 'error'); markAllBtn.disabled = false; markAllBtn.textContent = 'Mark all as seen'; return; }
                unseenBtns.forEach(function (b) {
                  var det = b.closest('details.ci-day');
                  if (det) {
                    det.querySelectorAll('.ci-new-pill').forEach(function (el) { el.remove(); });
                    det.open = false;
                  }
                  b.setAttribute('data-seen', '1');
                  b.textContent = 'Mark unseen';
                });
                // Clear the header summary "N new" pill too.
                overlay.querySelectorAll('.ci-summary .ci-new-pill').forEach(function (el) {
                  var wrap = el.closest('div'); if (wrap) wrap.remove(); else el.remove();
                });
                markAllBtn.style.display = 'none';
                toast('All caught up');
              })
              .catch(function (e) {
                markAllBtn.disabled = false; markAllBtn.textContent = 'Mark all as seen';
                toast('Network error: ' + (e && e.message || 'unknown'), 'error');
              });
          });
        }

        // Emoji kudos picker, clicking any emoji POSTs kudosNote with
        // that emoji in the body. Server records the emoji in the
        // Subject column + sends a themed email + fires Klaviyo event
        // with the emoji prop. Button visually inflates briefly to
        // confirm the send + then resets. (#49 picker, 2026-06-17.)
        overlay.querySelectorAll('.ci-kudos-btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            var emoji = btn.getAttribute('data-emoji') || '👏';
            btn.disabled = true;
            var origText = btn.textContent;
            btn.style.background = 'rgba(30,122,71,0.10)';
            btn.style.borderColor = 'rgba(30,122,71,0.35)';
            btn.style.transform = 'scale(1.12)';
            postAction('kudosNote', {
              athleteToken: athleteToken,
              emoji: emoji,
              sessionContext: {
                sessionId:   btn.getAttribute('data-session-id'),
                sessionName: btn.getAttribute('data-session-name'),
                scheduled:   btn.getAttribute('data-scheduled'),
              },
            })
              .then(function (r) {
                if (!r.ok) {
                  btn.disabled = false;
                  btn.style.background = '';
                  btn.style.borderColor = '';
                  btn.style.transform = '';
                  toast('Kudos failed: ' + (r.error || 'unknown'), 'error');
                  return;
                }
                // Brief "✓" overlay swap, then reset so the trainer
                // can send another reaction without re-opening.
                btn.textContent = '✓';
                setTimeout(function () {
                  btn.textContent = origText;
                  btn.disabled = false;
                  btn.style.background = '';
                  btn.style.borderColor = '';
                  btn.style.transform = '';
                }, 1500);
              })
              .catch(function (e) {
                btn.textContent = origText;
                btn.disabled = false;
                btn.style.background = '';
                btn.style.borderColor = '';
                btn.style.transform = '';
                toast('Network error: ' + (e && e.message || 'unknown'), 'error');
              });
          });
        });

        // Wire per-session Reply forms, submit emails the athlete
        // via the `replyToAthlete` server action, with session
        // context pulled from the form's data-* attributes. Inline
        // status text replaces the button label so the trainer
        // sees feedback without losing the textarea content.
        overlay.querySelectorAll('.ci-reply-form').forEach(function (form) {
          form.addEventListener('submit', function (ev) {
            ev.preventDefault();
            var textarea = form.querySelector('.ci-reply-text');
            var sendBtn  = form.querySelector('.ci-reply-send');
            var status   = form.querySelector('.ci-reply-status');
            var message = (textarea && textarea.value || '').trim();
            if (!message) {
              if (status) { status.textContent = 'Write something first.'; status.style.color = '#c74638'; }
              return;
            }
            var sessionContext = {
              sessionName: form.getAttribute('data-session-name') || '',
              scheduled:   form.getAttribute('data-scheduled')    || '',
              note:        form.getAttribute('data-note')         || '',
            };
            sendBtn.disabled = true; sendBtn.textContent = 'Sending…';
            if (status) { status.textContent = ''; status.style.color = '#777775'; }
            postAction('replyToAthlete', {
              athleteToken:   athleteToken,
              message:        message,
              sessionContext: sessionContext,
            }).then(function (r) {
              if (!r.ok) {
                sendBtn.disabled = false; sendBtn.textContent = 'Send reply';
                if (status) { status.textContent = 'Failed: ' + (r.error || 'unknown'); status.style.color = '#c74638'; }
                return;
              }
              // Success: optimistically prepend the just-sent reply
              // into the inline thread so the trainer sees it
              // immediately (instead of waiting for the next
              // drawer-render to refresh from the server).
              var det = form.closest('details.ci-reply');
              if (det) {
                var thread = det.querySelector('.ci-reply-thread');
                if (!thread) {
                  thread = document.createElement('div');
                  thread.className = 'ci-reply-thread';
                  thread.style.cssText = 'margin-bottom:10px;max-height:200px;overflow-y:auto;display:flex;flex-direction:column;gap:6px;';
                  form.parentNode.insertBefore(thread, form);
                }
                var bubble = document.createElement('div');
                bubble.style.cssText = 'padding:8px 10px;background:rgba(30,122,71,0.06);border-left:3px solid #1E7A47;border-radius:0 4px 4px 0;font-size:12px;line-height:1.5;color:#1A1918;';
                bubble.innerHTML =
                  '<div style="font-size:10px;color:#777775;margin-bottom:4px;">You · just now</div>' +
                  '<div style="white-space:pre-wrap;"></div>';
                bubble.querySelector('div + div').textContent = message;
                thread.appendChild(bubble);
                thread.scrollTop = thread.scrollHeight;
              }
              textarea.value = '';
              sendBtn.disabled = false; sendBtn.textContent = 'Send reply';
              if (status) { status.textContent = '✓ Sent'; status.style.color = '#1E7A47'; }
              setTimeout(function () { if (status) status.textContent = ''; }, 2500);
            }).catch(function (e) {
              sendBtn.disabled = false; sendBtn.textContent = 'Send reply';
              if (status) { status.textContent = 'Network error: ' + ((e && e.message) || 'unknown'); status.style.color = '#c74638'; }
            });
          });
        });

        // (Ask LLM button moved to the row's ⋯ overflow menu,
        // single source of truth, less duplication in the drawer.)
      })
      .catch(function (e) {
        var body = overlay.querySelector('#ci-body');
        if (body) body.innerHTML = '<div style="padding:14px;background:#FCE4DC;border:1px solid #E8B5A4;border-radius:6px;color:#5E2419;">Network error: ' + escapeHtml((e && e.message) || 'unknown') + '</div>';
      });
  }

  // Open the Ask-LLM modal IMMEDIATELY in a "building" state, then
  // swap to the full bundle on response. Saves the trainer from a
  // long pause where nothing visible happens (the server bundle
  // takes 5–30s depending on plan size + cache state). Returns
  // the overlay element so the caller can mutate it later.
  function openAskLlmLoadingModal_(athleteName, isFull) {
    var existing = document.getElementById('coach-ask-llm-modal');
    if (existing) existing.remove();
    var overlay = document.createElement('div');
    overlay.id = 'coach-ask-llm-modal';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,0.55);align-items:center;justify-content:center;padding:20px;';
    overlay.style.setProperty('display', 'flex', 'important');
    var fullSuffix = isFull ? ' (full plan, every week)' : '';
    var fullHint   = isFull ? ' Full plan can take a bit longer on big plans.' : '';
    overlay.innerHTML =
      '<div id="ask-llm-card" style="background:#FFFFFF;color:#1A1918;border-radius:12px;padding:0;width:100%;max-width:min(900px, 96vw);max-height:92vh;flex-direction:column;box-shadow:0 20px 50px rgba(0,0,0,0.25);overflow:hidden;display:flex;">' +
        '<div style="padding:40px 30px;text-align:center;">' +
          '<div style="width:42px;height:42px;border:3px solid #E5E2D9;border-top-color:#1A1918;border-radius:50%;margin:0 auto 18px;animation:tmbSpin 1s linear infinite;"></div>' +
          '<div style="font-size:18px;font-weight:600;margin:0 0 8px;color:#1A1918;">Getting ' + escapeHtml(athleteName) + '\'s plan ready for the AI' + fullSuffix + '…</div>' +
          '<div style="font-size:13px;color:#777775;line-height:1.5;max-width:420px;margin:0 auto;">We\'re gathering the plan, recent activity, and notes. Takes 5 to 30 seconds.' + fullHint + '</div>' +
        '</div>' +
      '</div>';
    // Inject spin keyframes once (the demo modal already does this,
    // but be defensive in case Ask LLM is the first overlay opened).
    if (!document.getElementById('tmb-spin-style')) {
      var st = document.createElement('style');
      st.id = 'tmb-spin-style';
      st.textContent = '@keyframes tmbSpin{to{transform:rotate(360deg);}}';
      document.head.appendChild(st);
    }
    document.body.appendChild(overlay);
    // Esc closes from the loading state too, trainer might want to
    // abandon if it's taking longer than expected.
    overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.remove(); });
    return overlay;
  }

  // Swap the loading-state card content for the bundle-ready
  // state: primary CTA is the zip download (drag → LLM project),
  // secondary is the single-file markdown copy for trainers who
  // prefer the paste-into-chat shortcut.
  function mutateAskLlmModalToBundle_(overlay, payload, athleteName, todayDate) {
    var card = overlay.querySelector('#ask-llm-card');
    if (!card) return;
    var zipB64 = payload.zipB64 || '';
    var zipName = payload.zipFilename || ((athleteName || 'athlete').replace(/\s+/g, '_').toLowerCase() + '-llm-bundle-' + todayDate + '.zip');
    card.style.maxHeight = '92vh';
    card.innerHTML =
      '<div style="padding:18px 22px 12px;border-bottom:1px solid #E5E2D9;background:#FFFFFF;">' +
        '<div style="font-size:11px;color:#777775;font-family:DM Mono,monospace;letter-spacing:0.04em;text-transform:uppercase;">Ask AI for update · ' + escapeHtml(todayDate) + '</div>' +
        '<h3 style="margin:4px 0 0;font-size:18px;color:#1A1918;">' + escapeHtml(athleteName) + '</h3>' +
      '</div>' +
      '<div style="flex:1 1 auto;overflow-y:auto;padding:18px 22px;background:#F7F6F2;">' +
        '<button type="button" id="ask-llm-download-zip" style="display:flex;align-items:center;justify-content:center;gap:10px;width:100%;padding:18px 20px;border-radius:10px;border:0;background:#1E7A47;color:#fff;font:inherit;font-size:15px;font-weight:700;cursor:pointer;box-shadow:0 6px 16px rgba(30,122,71,0.18);">' +
          '⬇ Download bundle files (' + zipName + ')' +
        '</button>' +
        '<div style="margin-top:18px;padding:14px 16px;background:#FFFFFF;border:1px solid #E5E2D9;border-radius:8px;color:#1A1918;font-size:13px;line-height:1.6;">' +
          '<ol style="margin:0;padding-left:20px;">' +
            '<li>Download the files.</li>' +
            '<li>Upload them to ChatGPT or Claude.</li>' +
            '<li>Do what the AI tells you.</li>' +
          '</ol>' +
        '</div>' +
      '</div>' +
      '<div style="padding:12px 22px;border-top:1px solid #E5E2D9;background:#FFFFFF;display:flex;gap:10px;justify-content:flex-end;">' +
        '<button type="button" id="ask-llm-close" style="padding:8px 16px;border-radius:6px;border:1px solid #D6D2C7;background:#FFFFFF;color:#1A1918;cursor:pointer;font:inherit;font-size:13px;">Close</button>' +
      '</div>';
    function close() { overlay.remove(); }
    overlay.querySelector('#ask-llm-close').addEventListener('click', close);
    overlay.querySelector('#ask-llm-download-zip').addEventListener('click', function () {
      // Decode the base64 zip into a Blob and trigger a download.
      try {
        var bin = atob(zipB64);
        var bytes = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
        var blob = new Blob([bytes], { type: 'application/zip' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url; a.download = zipName;
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
        var b = overlay.querySelector('#ask-llm-download-zip');
        b.textContent = '✓ Downloaded · ' + zipName;
        setTimeout(function () { b.textContent = '⬇ Download bundle files (' + zipName + ')'; }, 2500);
      } catch (e) {
        toast('Download failed: ' + (e.message || 'unknown'), 'error');
      }
    });
  }

  // Swap the loading-state card content for an error message + a
  // Retry button (rebuilds via askLlmBundle action) and a Close.
  function mutateAskLlmModalToError_(overlay, athleteToken, athleteName, errorMsg) {
    var card = overlay.querySelector('#ask-llm-card');
    if (!card) return;
    card.innerHTML =
      '<div style="padding:30px 30px;text-align:center;">' +
        '<div style="font-size:18px;font-weight:600;margin:0 0 8px;color:#c74638;">Couldn\'t build the bundle</div>' +
        '<div style="font-size:14px;color:#5E2419;margin:0 auto 20px;line-height:1.5;text-align:left;background:#FCE4DC;border:1px solid #E8B5A4;padding:12px 14px;border-radius:8px;max-width:520px;">' + escapeHtml(String(errorMsg)) + '</div>' +
        '<div style="display:flex;gap:10px;justify-content:center;">' +
          '<button type="button" id="ask-llm-close" style="padding:10px 18px;border-radius:8px;border:1px solid #D6D2C7;background:#FFFFFF;color:#1A1918;cursor:pointer;font:inherit;font-size:14px;">Close</button>' +
          '<button type="button" id="ask-llm-retry" style="padding:10px 18px;border-radius:8px;border:0;background:#1E7A47;color:#fff;cursor:pointer;font:inherit;font-size:14px;font-weight:600;">Retry</button>' +
        '</div>' +
      '</div>';
    overlay.querySelector('#ask-llm-close').addEventListener('click', function () { overlay.remove(); });
    overlay.querySelector('#ask-llm-retry').addEventListener('click', function () {
      overlay.remove();
      requestAskLlmBundle_(athleteToken, athleteName);
    });
  }

  // Single entry point, opens the loading modal, fires the POST,
  // mutates the modal to bundle or error on response. Both the
  // drawer's "Ask LLM" button and the overflow's "Ask LLM for
  // update" item call this so the UX is identical.
  function requestAskLlmBundle_(athleteToken, athleteName, opts) {
    opts = opts || {};
    var overlay = openAskLlmLoadingModal_(athleteName, opts.full);
    var payload = { athleteToken: athleteToken, clientBuild: window.__tmbCoachBuild || 'unknown' };
    if (opts.full) payload.full = true;
    postAction('askLlmBundle', payload)
      .then(function (j) {
        if (!j || !j.ok) {
          mutateAskLlmModalToError_(overlay, athleteToken, athleteName, (j && j.error) || 'Unknown server error');
          return;
        }
        mutateAskLlmModalToBundle_(overlay, j, j.athleteName || athleteName, j.todayDate || '');
      })
      .catch(function (e) {
        mutateAskLlmModalToError_(overlay, athleteToken, athleteName,
          ((e && e.message) || 'Network error') + '. The bundle build can take 30+ seconds on cold cache, wait a moment and retry.');
      });
  }

  // Remove any orphan full-screen overlays from earlier interactions
  // (broken demo modal, half-closed activity drawer, fallback open
  // pill, etc.). Click-blocking ghosts at high z-index are the most
  // common "I can't click anything" report. Safe to call any time,
  // each selector only targets coach-page-owned overlays.
  function killStaleOverlays_() {
    var SELECTORS = [
      '#coach-insights-overlay',
      '#coach-demo-ready-modal',
      '#coach-open-demo-pill',
      '#coach-fallback-open',
    ];
    SELECTORS.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) el.remove();
    });
  }
  // (Esc kill switch + delegated 📊 click handler moved to top of IIFE
  // - both install before any later code can throw and prevent boot.)

  // Sweep stale overlays on boot so a hard refresh always lands on a
  // clean dashboard. Belt-and-braces, also runs at top of each drawer
  // open, but a half-broken DOM at boot wouldn't get cleaned otherwise.
  setTimeout(function () { try { killStaleOverlays_(); } catch (_e) {} }, 0);

  // ── Coach-side media loader ──────────────────────────────────────────
  // Mirror of the athlete page's loadGalleryTile pattern, condensed.
  // Tries the localStorage cache first → direct Drive thumbnail (fast
  // path for public files) → falls back to a single batched /exec
  // POST that returns base64 data URLs (slow but reliable). Caches
  // results under the same `tmb_media_cache_v1` key so re-opening
  // the drawer is instant, and so the athlete + coach pages share
  // one warm cache for the same photos.
  var COACH_MEDIA_CACHE_KEY = 'tmb_media_cache_v1';
  var COACH_MEDIA_CACHE_MAX = 5 * 1024 * 1024;
  function coachMediaCacheRead_() {
    try {
      var raw = localStorage.getItem(COACH_MEDIA_CACHE_KEY);
      return raw ? JSON.parse(raw) : { entries: {}, order: [], bytes: 0 };
    } catch (e) { return { entries: {}, order: [], bytes: 0 }; }
  }
  function coachMediaCacheWrite_(c) {
    try { localStorage.setItem(COACH_MEDIA_CACHE_KEY, JSON.stringify(c)); } catch (e) {}
  }
  function coachMediaCacheGet_(fid) {
    var c = coachMediaCacheRead_(); return c.entries[fid] || null;
  }
  function coachMediaCacheSet_(fid, dataUrl) {
    if (!dataUrl) return;
    var c = coachMediaCacheRead_();
    if (c.entries[fid]) {
      // Refresh LRU position by moving to end.
      c.order = c.order.filter(function (k) { return k !== fid; });
    } else {
      c.bytes = (c.bytes || 0) + dataUrl.length;
    }
    c.entries[fid] = dataUrl; c.order.push(fid);
    while ((c.bytes > COACH_MEDIA_CACHE_MAX) && c.order.length > 1) {
      var ev = c.order.shift();
      if (c.entries[ev]) { c.bytes -= c.entries[ev].length; delete c.entries[ev]; }
    }
    coachMediaCacheWrite_(c);
  }
  // 1x1 transparent gif, used as the <img> initial src so the
  // browser doesn't flash a broken-image icon before the real
  // thumbnail loads.
  var COACH_TRANSPARENT_1PX = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  // Coach-side video lightbox. Streams the video through the Cloudflare
  // Worker download proxy (service-account Drive auth, works without
  // the trainer having any Drive permission on the file), with a Drive
  // /preview iframe fallback when the Worker isn't configured or the
  // native element errors. Mirrors the athlete page's chain, minus the
  // /exec base64 proxy (that's athlete-token-scoped; the coach has a
  // trainer token).
  //
  // Since B343 each video plays from a signed link for that one file,
  // which the athleteActivity response carries (videoUrls, valid 6 hours
  // from videoUrlsExpireAt). It used to be a shared token from coach info
  // that opened ANY file the Worker can read. Links are kept until 10
  // minutes before they expire; reopening the drawer fetches fresh ones.
  // The store hangs off this (hoisted) function, not a top-level var, so
  // it exists even if setup code above it ever threw.
  function coachVideoLinks_() {   // fileId -> { url, exp } (exp in unix seconds)
    return coachVideoLinks_.store || (coachVideoLinks_.store = {});
  }
  function rememberCoachVideoLinks_(d) {
    try {
      var urls = d && d.videoUrls;
      var exp = Number(d && d.videoUrlsExpireAt) || 0;
      if (!urls || typeof urls !== 'object' || !exp) return;
      var store = coachVideoLinks_();
      Object.keys(urls).forEach(function (fid) {
        if (urls[fid]) store[fid] = { url: String(urls[fid]), exp: exp };
      });
    } catch (_e) {}
  }
  function coachWorkerVideoUrl_(fileId) {
    var hit = coachVideoLinks_()[fileId];
    if (hit && hit.exp - 600 > Date.now() / 1000) return hit.url;
    // Changeover only: the old shared-token URL while a cached coach
    // info still carries it. The Worker stops accepting it once the
    // change is complete, and the iframe fallback below takes over.
    var info = state.info || {};
    var u = String(info.workerUrl || '').trim();
    var t = String(info.workerToken || '').trim();
    if (!u || !t) return null;
    return u.replace(/\/+$/, '') + '/download?id=' + encodeURIComponent(fileId) +
      '&token=' + encodeURIComponent(t);
  }
  function openCoachVideoLightbox_(fileId) {
    if (!fileId) return;
    var ov = document.createElement('div');
    ov.className = 'ci-video-lightbox';
    ov.style.cssText = 'position:fixed;inset:0;z-index:100000;background:rgba(0,0,0,0.85);display:flex;align-items:center;justify-content:center;padding:24px;';
    ov.innerHTML =
      '<button type="button" aria-label="Close" style="position:absolute;top:16px;right:18px;width:38px;height:38px;border-radius:8px;border:0;background:rgba(255,255,255,0.15);color:#fff;font-size:22px;cursor:pointer;">×</button>' +
      '<div data-lb-media style="width:100%;max-width:900px;max-height:86vh;display:flex;align-items:center;justify-content:center;color:#fff;font-size:14px;">Loading video…</div>';
    document.body.appendChild(ov);
    var media = ov.querySelector('[data-lb-media]');
    function close_() { try { document.removeEventListener('keydown', onKey_); } catch (_e) {} if (ov.parentNode) ov.parentNode.removeChild(ov); }
    function onKey_(e) { if (e.key === 'Escape') close_(); }
    ov.querySelector('button').addEventListener('click', close_);
    ov.addEventListener('click', function (e) { if (e.target === ov) close_(); });
    document.addEventListener('keydown', onKey_);

    function showIframe_() {
      // Drive /preview embeds Drive's own player iframe, works when
      // the trainer IS a Workspace user with access to the file. Last
      // resort when the Worker isn't configured.
      media.innerHTML = '<iframe src="https://drive.google.com/file/d/' +
        encodeURIComponent(fileId) + '/preview" allow="autoplay" ' +
        'style="width:900px;max-width:100%;height:70vh;border:0;border-radius:8px;background:#000;"></iframe>';
    }

    var workerSrc = coachWorkerVideoUrl_(fileId);
    if (!workerSrc) { showIframe_(); return; }
    var video = document.createElement('video');
    video.controls = true; video.autoplay = true; video.playsInline = true; video.preload = 'auto';
    video.style.cssText = 'width:900px;max-width:100%;max-height:86vh;border-radius:8px;background:#000;';
    var settled = false;
    function ok_() { if (settled) return; settled = true; media.innerHTML = ''; media.appendChild(video); }
    function bad_() { if (settled) return; settled = true; try { video.src = ''; } catch (_e) {} showIframe_(); }
    video.addEventListener('loadedmetadata', ok_);
    video.addEventListener('canplay', ok_);
    video.addEventListener('error', bad_);
    setTimeout(function () { bad_(); }, 6000);
    video.src = workerSrc;
  }

  function loadCoachThumbs_(root, athleteToken) {
    if (!root) return;
    var imgs = root.querySelectorAll('[data-ci-thumb]');
    // Two pending buckets keyed by kind (photo vs video). The /exec
    // proxy uses a different param for each ('photos' vs 'videoThumbs')
    // and the video bucket may return PENDING (video frame still
    // generating on the athlete-page server side), both branches
    // mirror the athlete page's flushBatchThumbs_.
    var pending = { photo: [], video: [] };
    imgs.forEach(function (img) {
      var fid = img.getAttribute('data-ci-thumb');
      if (!fid) return;
      var kind = img.getAttribute('data-ci-thumb-kind') === 'video' ? 'video' : 'photo';
      var cached = coachMediaCacheGet_(fid);
      if (cached) { img.src = cached; return; }
      // Direct Drive thumbnail first, works instantly for public files
      // (works for both image AND video file IDs; Drive auto-generates
      // a frame-thumbnail for video files). On a 1x1 placeholder
      // (Workspace-blocked file), fall back to the kind-specific /exec
      // proxy below.
      var directUrl = 'https://drive.google.com/thumbnail?id=' + encodeURIComponent(fid) + '&sz=w400';
      var attempted = false;
      img.onload = function () {
        if (attempted) return; attempted = true;
        if (img.naturalWidth <= 1 && img.naturalHeight <= 1) {
          img.src = COACH_TRANSPARENT_1PX;
          pending[kind].push({ img: img, fid: fid });
          flushIfReady_();
        } else {
          coachMediaCacheSet_(fid, directUrl);
        }
      };
      img.onerror = function () {
        if (attempted) return; attempted = true;
        img.src = COACH_TRANSPARENT_1PX;
        pending[kind].push({ img: img, fid: fid });
        flushIfReady_();
      };
      img.src = directUrl;
    });

    // Coalesce direct-thumb failures into one /exec call per kind.
    // ~80 ms window matches the athlete-page pattern.
    var flushTimer = null;
    function flushIfReady_() {
      if (flushTimer) return;
      flushTimer = setTimeout(function () {
        flushTimer = null;
        ['photo', 'video'].forEach(function (kind) {
          if (!pending[kind].length) return;
          var batch = pending[kind].slice(); pending[kind] = [];
          var ids = batch.map(function (p) { return p.fid; })
                         .filter(function (v, i, a) { return a.indexOf(v) === i; });
          var param = (kind === 'photo') ? 'photos' : 'videoThumbs';
          var url = ENDPOINT + '?token=' + encodeURIComponent(athleteToken) +
                    '&' + param + '=' + encodeURIComponent(ids.join(','));
          fetch(url).then(function (r) { return r.text(); }).then(function (txt) {
            var map = null;
            try { map = JSON.parse(txt); } catch (e) {}
            if (!map || typeof map !== 'object' || Array.isArray(map)) return;
            batch.forEach(function (p) {
              var val = map[p.fid];
              if (val && String(val).indexOf('data:') === 0) {
                p.img.src = val;
                coachMediaCacheSet_(p.fid, val);
              } else if (val === 'PENDING' && kind === 'video') {
                // Video thumbnail still generating on the athlete-page
                // server. Retry once after ~10s, usually long enough
                // for the first-frame extraction to finish.
                setTimeout(function () {
                  var retry = 'https://drive.google.com/thumbnail?id=' + encodeURIComponent(p.fid) + '&sz=w400';
                  p.img.src = retry;
                }, 10000);
              }
            });
          }).catch(function () { /* silent, direct thumbnails were the only attempt */ });
        });
      }, 80);
    }
  }

  // Day-name lookup so "wed" renders as "Wednesday", used as a
  // fallback for sessions with no resolved scheduled date.
  var CI_DAY_LABEL = { mon: 'Monday', tue: 'Tuesday', wed: 'Wednesday',
                       thu: 'Thursday', fri: 'Friday', sat: 'Saturday', sun: 'Sunday' };
  var CI_WEEKDAY = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  // Day name DERIVED from the session's scheduled ISO date, more
  // truthful than the Import.Day label, which depends on the trainer's
  // Weeks-tab Start Date and can drift from real calendar weekdays
  // (e.g. Import says "mon" but the Weeks tab started the week on a
  // Sunday → the session actually falls on Sunday, not Monday).
  function dayNameFromIsoDate_(isoDate) {
    if (!isoDate) return '';
    // Anchor at noon UTC so timezone drift can't push the date across
    // a day boundary.
    var d = new Date(isoDate + 'T12:00:00Z');
    if (isNaN(d.getTime())) return '';
    return CI_WEEKDAY[d.getUTCDay()];
  }

  // Status → colour band used for the left-edge stripe + status chip
  // on each session card. Mirrors the trainer's mental model from
  // the in-person coaching workflow:
  //   done    = green   (ticked completed)
  //   today   = grey    (scheduled today, athlete may still do it)
  //   missed  = red     (scheduled in the past, not done)
  //   planned = blue    (future-scheduled, or unscheduled activity)
  var CI_STATUS = {
    done:    { color: '#1E7A47', tint: 'rgba(30,122,71,0.10)',  label: 'DONE',    icon: '✓' },
    today:   { color: '#7a7a72', tint: 'rgba(122,122,114,0.10)', label: 'TODAY',   icon: '○' },
    missed:  { color: '#c74638', tint: 'rgba(199,70,56,0.10)',   label: 'MISSED',  icon: '✕' },
    planned: { color: '#2A6BD6', tint: 'rgba(42,107,214,0.10)',  label: 'PLANNED', icon: '○' },
  };

  // Render the Activity sub-section's contents. Group every session
  // by day (latest day first); each day collapses into a <details>;
  // each session is a two-column card (Prescribed | Notes + media).
  // Bind the Messages compose form + fire mark-read on drawer open
  // (the trainer has the drawer in front of them, so we treat that
  // as having "seen" the inbound messages even if they don't reply).
  // Fire-and-forget, failures don't block the drawer or compose.
  function bindCoachInsightsMessages_(body, athleteToken, unreadCount) {
    if (unreadCount > 0) {
      postAction('markMessagesReadByTrainer', { athleteToken: athleteToken })
        .then(function (r) {
          if (r && r.ok) {
            // Clear unread badge + dots in the drawer optimistically.
            var badge = body.querySelector('details[data-ci-msgs] > summary span[style*="background:#c8102e"]');
            if (badge) badge.remove();
            body.querySelectorAll('.ci-msg-unread-dot').forEach(function (d) { d.remove(); });
          }
        })
        .catch(function () { /* best-effort */ });
    }

    var form = body.querySelector('[data-ci-msgs-compose]');
    if (!form || form.__ciBound) return;
    form.__ciBound = true;
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var input = form.querySelector('[data-ci-msgs-input]');
      var send  = form.querySelector('[data-ci-msgs-send]');
      var text  = (input && input.value || '').trim();
      if (!text) return;
      if (text.length > 5000) {
        toast('Message too long (max 5000 chars)', 'error');
        return;
      }
      send.disabled = true; send.textContent = 'Sending…';
      postAction('sendMessageToAthlete', { athleteToken: athleteToken, message: text })
        .then(function (j) {
          send.disabled = false; send.textContent = 'Send';
          if (!j.ok) { toast('Send failed: ' + (j.error || 'unknown'), 'error'); return; }
          // Optimistic append, local thread updates immediately;
          // next drawer open / 30s coachInfo poll reconciles with
          // the canonical server copy.
          var thread = body.querySelector('[data-ci-msgs-thread]');
          if (thread) {
            var trainerName = (window.coachState && window.coachState.info && window.coachState.info.trainer && window.coachState.info.trainer.name) || 'You';
            var nowRel = 'just now';
            var bubble = document.createElement('div');
            bubble.style.cssText = 'display:flex;flex-direction:column;align-items:flex-end;max-width:80%;margin-left:auto;';
            bubble.innerHTML =
              '<div style="font-size:11px;color:#888886;margin-bottom:3px;font-family:DM Mono,monospace;letter-spacing:0.03em;text-transform:uppercase;">' +
                escapeHtml(trainerName) + ' · ' + nowRel +
              '</div>' +
              '<div style="padding:8px 12px;border-radius:8px;background:rgba(200, 16, 46,0.06);border:1px solid rgba(200, 16, 46,0.25);font-size:13px;line-height:1.4;color:#1A1918;word-wrap:break-word;">' +
                escapeHtml(text).replace(/\n/g, '<br>') +
              '</div>';
            thread.appendChild(bubble);
            thread.scrollTop = thread.scrollHeight;
          } else {
            // No thread div (was the empty state), drop the empty
            // placeholder so the new bubble can show.
            var empty = body.querySelector('.ci-msgs-empty');
            if (empty) empty.remove();
          }
          input.value = '';
          toast('Message sent', 'success');
        })
        .catch(function (e) {
          send.disabled = false; send.textContent = 'Send';
          toast('Network error: ' + (e && e.message || 'unknown'), 'error');
        });
    });
  }

  // Messages section for the Coach Insights drawer (#33 Phase C).
  // Renders the trainer↔athlete thread + a compose box. The compose
  // submit + mark-read-on-open behaviour is wired in
  // bindCoachInsightsMessages_ after the drawer body lands.
  function renderCoachInsightsMessages_(msgs, unread) {
    var listHtml = '';
    if (!msgs.length) {
      listHtml = '<div class="ci-msgs-empty" style="padding:18px 12px;text-align:center;color:#888886;font-size:13px;background:#F7F6F2;border:1px dashed #D6D2C7;border-radius:8px;">' +
                   'No messages yet. Send the first one below. The athlete sees it in their plan page Messages tab + gets an email.' +
                 '</div>';
    } else {
      var rows = msgs.map(function (m) {
        var isAthlete = m.from === 'athlete';
        var label = isAthlete ? 'Athlete' : (m.trainer || 'You');
        var when  = formatRelative(m.ts);
        var align = isAthlete ? 'flex-start' : 'flex-end';
        var bg    = isAthlete ? '#FFFFFF' : 'rgba(200, 16, 46,0.06)';
        var brd   = isAthlete ? '#E5E2D9' : 'rgba(200, 16, 46,0.25)';
        var unreadDot = (isAthlete && m.readByTrainer !== true)
          ? '<span class="ci-msg-unread-dot" title="Unread" style="display:inline-block;width:6px;height:6px;border-radius:50%;background:#c8102e;margin-right:6px;vertical-align:1px;"></span>'
          : '';
        var ctx = m.sessionName
          ? '<div style="font-size:11px;color:#888886;margin-bottom:4px;padding-bottom:4px;border-bottom:1px solid ' + brd + ';">Re: ' + escapeHtml(m.sessionName) + (m.scheduled ? '-' + escapeHtml(m.scheduled) : '') + '</div>'
          : '';
        return '<div style="display:flex;flex-direction:column;align-items:' + align + ';max-width:80%;' + (isAthlete ? '' : 'margin-left:auto;') + '">' +
                 '<div style="font-size:11px;color:#888886;margin-bottom:3px;font-family:DM Mono,monospace;letter-spacing:0.03em;text-transform:uppercase;">' +
                   unreadDot + escapeHtml(label) + ' · ' + escapeHtml(when) +
                 '</div>' +
                 '<div style="padding:8px 12px;border-radius:8px;background:' + bg + ';border:1px solid ' + brd + ';font-size:13px;line-height:1.4;color:#1A1918;word-wrap:break-word;">' +
                   ctx +
                   escapeHtml(m.body || m.subject || '').replace(/\n/g, '<br>') +
                 '</div>' +
               '</div>';
      }).join('');
      listHtml = '<div class="ci-msgs-thread" data-ci-msgs-thread style="display:flex;flex-direction:column;gap:10px;max-height:280px;overflow-y:auto;padding:8px 4px;">' + rows + '</div>';
    }
    var unreadBadge = unread > 0
      ? '<span style="background:#c8102e;color:#fff;font-size:11px;font-weight:700;padding:2px 8px;border-radius:999px;margin-left:6px;">' + (unread > 9 ? '9+' : unread) + ' new</span>'
      : '';
    return (
      '<details class="ci-msgs" data-ci-msgs ' + (unread > 0 ? 'open' : '') + ' style="margin:14px 0 18px;border:1px solid #E5E2D9;border-radius:8px;background:#FFFFFF;overflow:hidden;">' +
        '<summary style="cursor:pointer;padding:10px 14px;font-size:13px;font-weight:600;color:#1A1918;background:#F7F6F2;border-bottom:1px solid #E5E2D9;display:flex;align-items:center;gap:6px;list-style:none;">' +
          '💬 Messages' + unreadBadge +
          '<span style="margin-left:auto;font-size:11px;color:#777775;font-weight:400;">' + msgs.length + ' total</span>' +
        '</summary>' +
        '<div style="padding:12px 14px;">' +
          listHtml +
          '<form class="ci-msgs-compose" data-ci-msgs-compose style="margin-top:10px;display:flex;flex-direction:column;gap:8px;">' +
            '<textarea data-ci-msgs-input rows="2" maxlength="5000" placeholder="Send a message to the athlete…" style="width:100%;padding:10px;font:inherit;font-size:13px;line-height:1.45;border:1px solid #E5E2D9;border-radius:6px;background:#F7F6F2;color:#1A1918;resize:vertical;"></textarea>' +
            '<div style="display:flex;justify-content:space-between;align-items:center;gap:8px;font-size:11px;color:#888886;">' +
              '<span>Athlete gets an email + sees this in their plan.</span>' +
              '<button type="submit" data-ci-msgs-send style="appearance:none;background:#c8102e;color:#fff;font:inherit;font-size:12px;font-weight:600;padding:7px 18px;border:none;border-radius:6px;cursor:pointer;letter-spacing:0.03em;text-transform:uppercase;">Send</button>' +
            '</div>' +
          '</form>' +
        '</div>' +
      '</details>'
    );
  }

  function renderCoachInsightsActivity_(d) {
    // Keep the signed video links this response carries (B343), so a
    // tap on a video tile can play it. Covers the cached and fresh renders.
    rememberCoachVideoLinks_(d);
    // ── Build per-day buckets from the unified sessions array ────
    // Server returns one entry per (sessionId, person), both
    // sessions-with-activity AND planned-in-window sessions. We
    // group by the session's scheduled day-of-week so the day
    // header reflects when the work was due, not when the note
    // landed.
    var lastSeenByDay = d.lastSeenByDay || {};
    function isNewSession_(s) {
      // Key off the SAME bucket date the renderer uses below,
      // scheduled when known and not in the future, else activity
      // date. Keeps Mark-day-seen behaviour aligned with the row
      // the trainer is actually looking at.
      var activityDay = s.latestTs ? String(s.latestTs).slice(0, 10) : '';
      var sched = s.scheduled || '';
      var today = d.todayDate || '';
      var dayKey;
      if (!sched) dayKey = activityDay;
      else if (today && sched > today && activityDay) dayKey = activityDay;
      else dayKey = sched;
      var seen = lastSeenByDay[dayKey] || '';
      return !!(s.latestTs && s.latestTs > seen);
    }
    var byDay = {};   // dayKey (yyyy-mm-dd) → { dayKey, dayName, sessions: [] }
    var todayIso = d.todayDate || '';
    (d.sessions || []).forEach(function (s) {
      s.isNew = isNewSession_(s);
      // Bucket by SCHEDULED date by default, the trainer thinks
      // in plan terms ("did Mol do her Saturday session?"), so a
      // Saturday session ticked late on Sunday morning still
      // belongs in Saturday's row. Only fall back to activity
      // date when scheduled is in the FUTURE (athlete did it
      // early), without that fallback the session would show
      // as a phantom future row.
      var activityDay = s.latestTs ? String(s.latestTs).slice(0, 10) : '';
      var sched = s.scheduled || '';
      var dayKey;
      if (!sched) {
        dayKey = activityDay || '_unknown';
      } else if (todayIso && sched > todayIso && activityDay) {
        dayKey = activityDay;  // early-done future session → activity day
      } else {
        dayKey = sched;
      }
      // Day label = the calendar day-of-week for the bucket date.
      var calendar = dayNameFromIsoDate_(dayKey);
      var dayName = calendar || '-';
      if (!byDay[dayKey]) byDay[dayKey] = {
        dayKey: dayKey, dayName: dayName, dayMismatch: '', sessions: [],
      };
      byDay[dayKey].sessions.push(s);
    });
    // Always surface today as a row even when no sessions landed
    // there, trainer immediately sees "today is empty / rest day"
    // rather than wondering if the day is missing because of a date
    // bug. todayDate comes from the server (computed in athlete tz).
    var todayKey = d.todayDate || '';
    if (todayKey && !byDay[todayKey]) {
      byDay[todayKey] = {
        dayKey: todayKey,
        dayName: dayNameFromIsoDate_(todayKey) || 'Today',
        dayMismatch: '',
        sessions: [],
        isEmpty: true,
      };
    }
    var orderedDays = Object.keys(byDay).sort(function (a, b) {
      // Latest day at top, _unknown sorts last.
      if (a === '_unknown') return 1;
      if (b === '_unknown') return -1;
      return b.localeCompare(a);
    });
    var newSessionsCount = (d.sessions || []).filter(function (s) { return s.isNew; }).length;
    // Kudos in window, sum across sessions. Shows the trainer how much
    // positive feedback they've sent the athlete in the last 7 days.
    var kudosTotal = (d.sessions || []).reduce(function (sum, s) {
      return sum + (Number(s.kudos) || 0);
    }, 0);

    // ── Header summary strip ──────────────────────────────────────
    var lastAct = d.lastActive ? formatRelative(d.lastActive) : 'never';
    var pbCount = (d.pbs || []).length;
    var planned = (d.sessionsPlanned == null) ? null : d.sessionsPlanned;
    var missed  = (d.sessionsMissed  == null) ? 0     : d.sessionsMissed;
    var doneOfPlanned = planned == null ? String(d.sessionsDone) : (d.sessionsDone + ' / ' + planned);
    var html = [];
    html.push(
      '<div class="ci-summary" style="display:flex;gap:18px;flex-wrap:wrap;align-items:baseline;padding:0 0 14px;border-bottom:1px solid #E5E2D9;font-size:13px;color:#555;">' +
        '<div><strong style="color:#1E7A47;font-size:20px;">' + escapeHtml(doneOfPlanned) + '</strong> done</div>' +
        (missed ? '<div><strong style="color:#c74638;font-size:20px;">' + missed + '</strong> missed</div>' : '') +
        '<div><strong style="color:#1A1918;font-size:20px;">' + pbCount + '</strong> PB' + (pbCount === 1 ? '' : 's') + '</div>' +
        (kudosTotal ? '<div title="Kudos you\'ve sent this athlete in the last 7 days"><strong style="color:#A86200;font-size:20px;">' + kudosTotal + '</strong> 👏</div>' : '') +
        (newSessionsCount ? '<div><span class="ci-new-pill" style="background:#2A6BD6;color:#fff;font-size:11px;padding:2px 8px;border-radius:999px;font-weight:600;">' + newSessionsCount + ' new</span></div>' : '') +
        '<div style="margin-left:auto;display:flex;align-items:center;gap:12px;">' +
          (newSessionsCount ? '<button type="button" id="ci-mark-all-seen" style="font:inherit;font-size:12px;font-weight:600;padding:5px 12px;border:1px solid #D6D2C7;border-radius:6px;background:#FFFFFF;color:#1A1918;cursor:pointer;">Mark all as seen</button>' : '') +
          '<span>Last active <strong style="color:#1A1918;">' + escapeHtml(lastAct) + '</strong></span>' +
        '</div>' +
      '</div>'
    );

    // ── Messages section (#33 Phase C) ────────────────────────────
    // Two-way trainer↔athlete thread, surfaced inside the drawer so
    // the trainer can triage + reply without leaving the coach page.
    // Same data the athlete-page Messages tab reads, written via the
    // same Coach Replies tab (Direction='trainer' on reply, 'athlete'
    // on inbound). Mark-as-read fires when the drawer opens.
    var msgs = Array.isArray(d.messages) ? d.messages : [];
    var unread = Number(d.unreadFromAthlete) || 0;
    html.push(renderCoachInsightsMessages_(msgs, unread));

    // ── Day groups ───────────────────────────────────────────────
    if (orderedDays.length) {
      orderedDays.forEach(function (dayKey) {
        var bucket = byDay[dayKey];
        // Sort sessions within the day by slot (AM before PM before
        // All day) then by category, falling back to latestTs.
        var slotOrder = { 'AM': 0, 'PM': 1, 'All day': 2, 'Focus': 3, 'Optional': 4, 'Bonus': 5 };
        bucket.sessions.sort(function (a, b) {
          var sa = slotOrder[a.slot] == null ? 99 : slotOrder[a.slot];
          var sb = slotOrder[b.slot] == null ? 99 : slotOrder[b.slot];
          if (sa !== sb) return sa - sb;
          return String(a.category).localeCompare(String(b.category));
        });
        var anyNew = bucket.sessions.some(function (s) { return s.isNew; });
        // Day stays open if any session is new, OR if this day has
        // no seen-record yet (first-time view).
        var hasSeenForDay = !!lastSeenByDay[dayKey];
        var openAttr = (!hasSeenForDay || anyNew) ? ' open' : '';
        var newCount = bucket.sessions.filter(function (s) { return s.isNew; }).length;
        var doneInDay = bucket.sessions.filter(function (s) { return s.status === 'done'; }).length;
        var missedInDay = bucket.sessions.filter(function (s) { return s.status === 'missed'; }).length;
        var prettyDate = dayKey !== '_unknown' && dayKey ? ' · ' + escapeHtml(dayKey) : '';
        var isToday = dayKey === d.todayDate;
        var sessionsCountLabel = bucket.sessions.length
          ? bucket.sessions.length + ' session' + (bucket.sessions.length === 1 ? '' : 's')
          : (isToday ? 'no sessions yet today' : 'no sessions');
        var todayBadge = isToday ? '<span style="background:#2A6BD6;color:#fff;font-size:10px;padding:1px 7px;border-radius:999px;font-weight:600;letter-spacing:0.04em;">TODAY</span>' : '';
        html.push('<details class="ci-day" data-day-key="' + escapeAttr(dayKey) + '"' + openAttr + ' style="margin-top:14px;">');
        html.push(
          '<summary style="cursor:pointer;list-style:none;font-size:14px;font-weight:600;color:#1A1918;padding:10px 12px;display:flex;align-items:center;gap:10px;background:#FFFFFF;border:1px solid #E5E2D9;border-radius:8px;">' +
            '<span class="ci-disclosure" aria-hidden="true" style="display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:5px;background:rgba(0,0,0,0.06);color:#1A1918;"></span>' +
            '<span>' + escapeHtml(bucket.dayName) + prettyDate + escapeHtml(bucket.dayMismatch || '') + '</span>' +
            todayBadge +
            '<span style="color:#777775;font-weight:400;font-size:11px;">' + sessionsCountLabel + '</span>' +
            (doneInDay ? '<span style="color:#1E7A47;font-weight:600;font-size:11px;">' + doneInDay + ' done</span>' : '') +
            (missedInDay ? '<span style="color:#c74638;font-weight:600;font-size:11px;">' + missedInDay + ' missed</span>' : '') +
            (newCount ? '<span class="ci-new-pill" style="background:#2A6BD6;color:#fff;font-size:10px;padding:1px 7px;border-radius:999px;font-weight:600;">' + newCount + ' NEW</span>' : '') +
            // Mark seen / unseen toggle, visible on every day so a
            // trainer can flip a previously-seen day back to NEW if
            // they want to revisit. Label switches based on current
            // state. Always rendered margin-left:auto so it docks
            // right whether the NEW pill is present or not.
            '<button type="button" class="ci-mark-day-seen" data-day-key="' + escapeAttr(dayKey) + '" data-seen="' + (hasSeenForDay && !newCount ? '1' : '0') + '" style="margin-left:auto;background:transparent;border:1px solid #D6D2C7;color:#555;font-size:11px;padding:3px 10px;border-radius:5px;cursor:pointer;">' +
              (hasSeenForDay && !newCount ? 'Mark unseen' : 'Mark seen') +
            '</button>' +
          '</summary>'
        );
        html.push('<div style="padding:10px 0 0;">');
        if (bucket.sessions.length) {
          bucket.sessions.forEach(function (s) { html.push(renderCiSessionCard_(s)); });
        } else {
          html.push(
            '<div style="padding:14px 16px;background:#FFFFFF;border:1px dashed #E5E2D9;border-radius:8px;color:#777775;font-size:13px;font-style:italic;text-align:center;">' +
              (isToday ? 'No sessions scheduled for today.' : 'No sessions on this day.') +
            '</div>'
          );
        }
        html.push('</div>');
        html.push('</details>');
      });
    }

    // ── Metrics, adherence + volume sparklines + injuries. Last
    // 12 weeks of historical data so the trainer can spot trend
    // shifts at a glance. Always rendered (even with zero data)
    // because the section labels themselves communicate what's
    // being tracked.
    var metrics = d.metrics || { weeklyAdherence: [], weeklyVolume: [], injuries: { active: 0, healed: 0, list: [] } };
    var hasMetrics = (metrics.weeklyAdherence && metrics.weeklyAdherence.length) ||
                     (metrics.weeklyVolume    && metrics.weeklyVolume.length)    ||
                     (metrics.injuries && metrics.injuries.active);
    if (hasMetrics) {
      html.push('<div class="ci-metrics" style="margin-top:24px;border-top:1px solid #E5E2D9;padding-top:14px;">');
      html.push('<div style="font-size:11px;font-weight:600;color:#555;letter-spacing:0.04em;text-transform:uppercase;margin-bottom:10px;">Metrics</div>');

      // Adherence, per-week ▁-▇ sparkline + headline % for the
      // window. Each block char maps to one week's done/planned
      // ratio (0..1). Tooltip carries the per-week breakdown so
      // a trainer hovering over the bars can see the raw numbers.
      var adh = metrics.weeklyAdherence || [];
      if (adh.length) {
        var totalDone = 0, totalPlan = 0;
        adh.forEach(function (w) { totalDone += (w.done || 0); totalPlan += (w.planned || 0); });
        var pct = totalPlan ? Math.round((totalDone / totalPlan) * 100) : 0;
        var spark = adh.map(function (w) {
          var r = w.planned ? Math.min(1, (w.done || 0) / w.planned) : 0;
          // 8-step block scale (U+2581 ▁ → U+2588 █). Empty weeks
          // render as a dot so the gap is visible without spiking.
          if (!w.planned) return '·';
          var idx = Math.min(7, Math.max(0, Math.round(r * 7)));
          return ['▁','▂','▃','▄','▅','▆','▇','█'][idx];
        }).join('');
        var tip = adh.map(function (w) { return w.weekStart + ': ' + (w.done || 0) + '/' + (w.planned || 0); }).join('\n');
        html.push(
          '<div style="display:flex;align-items:center;gap:12px;padding:10px 14px;background:#FFFFFF;border:1px solid #E5E2D9;border-radius:8px;margin-bottom:8px;font-size:13px;color:#1A1918;">' +
            '<div style="min-width:140px;"><strong style="font-size:18px;">' + pct + '%</strong> <span style="color:#777775;font-size:12px;">adherence · ' + adh.length + 'w</span></div>' +
            '<div title="' + escapeAttr(tip) + '" style="font:14px/1 ui-monospace,Menlo,monospace;letter-spacing:1px;color:#1E7A47;">' + spark + '</div>' +
            '<div style="margin-left:auto;font-size:11px;color:#777775;">' + totalDone + '/' + totalPlan + ' total</div>' +
          '</div>'
        );
      }

      // Volume, same sparkline shape, normalised against the max
      // week in the window so a fluctuating block still renders
      // visibly. Headline = total minutes + weekly average.
      var vol = metrics.weeklyVolume || [];
      if (vol.length) {
        var totalMin = 0, maxMin = 0;
        vol.forEach(function (w) { var m = w.totalMin || 0; totalMin += m; if (m > maxMin) maxMin = m; });
        var avg = vol.length ? Math.round(totalMin / vol.length) : 0;
        var volSpark = vol.map(function (w) {
          var m = w.totalMin || 0;
          if (!m) return '·';
          var r = maxMin ? Math.min(1, m / maxMin) : 0;
          var idx = Math.min(7, Math.max(0, Math.round(r * 7)));
          return ['▁','▂','▃','▄','▅','▆','▇','█'][idx];
        }).join('');
        var volTip = vol.map(function (w) { return w.weekStart + ': ' + (w.totalMin || 0) + ' min'; }).join('\n');
        html.push(
          '<div style="display:flex;align-items:center;gap:12px;padding:10px 14px;background:#FFFFFF;border:1px solid #E5E2D9;border-radius:8px;margin-bottom:8px;font-size:13px;color:#1A1918;">' +
            '<div style="min-width:140px;"><strong style="font-size:18px;">' + avg + '</strong> <span style="color:#777775;font-size:12px;">min/wk avg · ' + vol.length + 'w</span></div>' +
            '<div title="' + escapeAttr(volTip) + '" style="font:14px/1 ui-monospace,Menlo,monospace;letter-spacing:1px;color:#2A6BD6;">' + volSpark + '</div>' +
            '<div style="margin-left:auto;font-size:11px;color:#777775;">' + totalMin + ' min total</div>' +
          '</div>'
        );
      }

      // Injuries, active count + inline list. Hidden when zero;
      // trainer doesn't need to see "0 active injuries" on every
      // athlete (it's the silent default).
      var inj = metrics.injuries || { active: 0, list: [] };
      if (inj.active) {
        html.push(
          '<div style="padding:10px 14px;background:rgba(199,70,56,0.06);border:1px solid rgba(199,70,56,0.25);border-radius:8px;font-size:13px;color:#1A1918;">' +
            '<div style="font-weight:600;color:#c74638;margin-bottom:6px;">⚠ ' + inj.active + ' active injur' + (inj.active === 1 ? 'y' : 'ies') + '</div>' +
            (inj.list || []).map(function (i) {
              return '<div style="font-size:12px;margin-top:4px;">• <strong>' + escapeHtml(i.injury || '') + '</strong>' +
                (i.notes ? ', <span style="color:#555;">' + escapeHtml(i.notes) + '</span>' : '') +
              '</div>';
            }).join('') +
          '</div>'
        );
      }

      html.push('</div>');
    }

    // ── Plan context. Athlete Context summary + Update Log thread.
    // Both live on the athlete sheet but trainers rarely open Sheets
    // to read them. Surface here so they're a click away. Sits
    // between activity and PBs because it's contextual (what the
    // LLM/trainer have observed and changed) not metric.
    var hasContext = (d.athleteContext && d.athleteContext.trim()) || (d.updateLog && d.updateLog.length);
    // Always show the Plan context header so the "Ask LLM" button
    // is reachable even on a fresh athlete with no log entries
    // (that's exactly when the first LLM pass is useful).
    // .tmb-llm-zone gates the whole section for Standard-tier
    // trainers via the body:not(.tmb-tier-premium) CSS rule.
    html.push('<div class="ci-plan-context tmb-llm-zone" style="margin-top:24px;border-top:1px solid #E5E2D9;padding-top:14px;">');
    html.push(
      '<div style="font-size:11px;font-weight:600;color:#555;letter-spacing:0.04em;text-transform:uppercase;margin-bottom:10px;">Plan context · AI</div>'
    );
    if (!hasContext) {
      html.push(
        '<div style="padding:14px 16px;background:#FFFFFF;border:1px dashed #E5E2D9;border-radius:8px;color:#777775;font-size:12px;font-style:italic;">' +
          'No AI context yet. Use <strong>⋯ → 🤖 AI → Ask AI for update</strong> next to the athlete to start a first pass.' +
        '</div>'
      );
    }
    if (hasContext) {

      // Athlete Context, single free-text cell, expanded by default
      // since it's the digest of the LLM's mental model of this athlete
      // (current goals, constraints, recent observations). One short
      // read makes the rest of the drawer make sense.
      if (d.athleteContext && d.athleteContext.trim()) {
        html.push(
          '<details class="ci-context" open style="margin-bottom:14px;background:#FFFFFF;border:1px solid #E5E2D9;border-radius:8px;">' +
            '<summary style="cursor:pointer;list-style:none;padding:10px 14px;font-size:13px;font-weight:600;color:#1A1918;display:flex;align-items:center;gap:8px;">' +
              '<span class="ci-disclosure" style="display:inline-block;width:16px;">▸</span> 🧠 Athlete context' +
              '<span style="margin-left:auto;font-weight:400;font-size:11px;color:#777775;">' + d.athleteContext.split(/\s+/).filter(Boolean).length + ' words</span>' +
            '</summary>' +
            '<div style="padding:0 14px 12px;font-size:13px;line-height:1.55;color:#1A1918;white-space:pre-wrap;">' +
              renderInlineMarkdown_(d.athleteContext) +
            '</div>' +
          '</details>'
        );
      }

      // Update Log, newest-first. Each entry's Detail collapsed by
      // default so a 50-entry log doesn't dominate the drawer; the
      // Date / Author / Type / Subject line is always visible.
      if (d.updateLog && d.updateLog.length) {
        var sorted = d.updateLog.slice().sort(function (a, b) {
          // Lexicographic on YYYY-MM-DD is also chronological.
          return (b.date || '').localeCompare(a.date || '');
        });
        var typeColours = {
          'Observation': '#2A6BD6',
          'Change':      '#1E7A47',
          'Question':    '#a06b1a',
          'Decision':    '#7e1e9c',
        };
        html.push(
          '<details class="ci-updatelog" open style="background:#FFFFFF;border:1px solid #E5E2D9;border-radius:8px;">' +
            '<summary style="cursor:pointer;list-style:none;padding:10px 14px;font-size:13px;font-weight:600;color:#1A1918;display:flex;align-items:center;gap:8px;">' +
              '<span class="ci-disclosure" style="display:inline-block;width:16px;">▸</span> 📝 Update log' +
              '<span style="margin-left:auto;font-weight:400;font-size:11px;color:#777775;">' + sorted.length + ' entr' + (sorted.length === 1 ? 'y' : 'ies') + '</span>' +
            '</summary>' +
            '<div style="padding:0 14px 12px;display:flex;flex-direction:column;gap:8px;">' +
              sorted.map(function (e) {
                var typeColour = typeColours[e.type] || '#555';
                var detailBlock = e.detail
                  ? '<details style="margin-top:4px;"><summary style="cursor:pointer;list-style:none;font-size:11px;color:#777775;user-select:none;">▸ Detail</summary><div style="margin-top:6px;padding:8px 10px;background:rgba(0,0,0,0.03);border-radius:4px;font-size:12px;line-height:1.5;color:#1A1918;white-space:pre-wrap;">' + escapeHtml(e.detail) + '</div></details>'
                  : '';
                var whyBlock = e.why
                  ? '<div style="margin-top:4px;font-size:11px;color:#777775;font-style:italic;line-height:1.4;">Why: ' + escapeHtml(e.why) + '</div>'
                  : '';
                return '<div style="padding:8px 10px;background:rgba(0,0,0,0.02);border-left:3px solid ' + typeColour + ';border-radius:0 4px 4px 0;">' +
                  '<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;">' +
                    '<span style="font-size:10px;font-weight:700;letter-spacing:0.04em;text-transform:uppercase;color:' + typeColour + ';">' + escapeHtml(e.type || 'Note') + '</span>' +
                    '<span style="font-size:11px;color:#777775;">' + escapeHtml(e.date || '') + (e.author ? ' · ' + escapeHtml(e.author) : '') + '</span>' +
                  '</div>' +
                  (e.subject ? '<div style="font-size:13px;font-weight:600;color:#1A1918;margin-top:4px;">' + escapeHtml(e.subject) + '</div>' : '') +
                  detailBlock +
                  whyBlock +
                '</div>';
              }).join('') +
            '</div>' +
          '</details>'
        );
      }
    }
    html.push('</div>');   // close .ci-plan-context

    // ── PBs (separate block at the bottom) ────────────────────────
    var pbs = d.pbs || [];
    if (pbs.length) {
      var pbRows = pbs.map(function (p) {
        return '<div style="display:flex;justify-content:space-between;align-items:baseline;gap:10px;padding:8px 12px;background:rgba(30,122,71,0.08);border:1px solid rgba(30,122,71,0.25);border-radius:6px;margin-bottom:6px;font-size:13px;">' +
          '<div><span style="color:var(--note);">' + escapeHtml(p.discipline) + '</span> · <strong style="color:var(--heading);">' + escapeHtml(p.metric) + '</strong></div>' +
          '<div><strong style="color:#5fb37b;">' + escapeHtml(String(p.value)) + ' ' + escapeHtml(p.unit) + '</strong> · <span style="color:var(--note);font-size:11px;">' + escapeHtml(p.date) + '</span></div>' +
        '</div>';
      }).join('');
      html.push(
        '<div style="margin-top:18px;">' +
          '<div style="font-size:13px;font-weight:600;color:var(--heading);margin-bottom:8px;">🏆 PBs this week</div>' +
          pbRows +
        '</div>'
      );
    }

    if (!orderedDays.length && !pbs.length && d.sessionsDone === 0) {
      html.push(
        '<div style="padding:40px 20px;text-align:center;color:var(--note);">' +
          'No activity in the last 7 days.<br>' +
          '<span style="font-size:12px;">Check back once the athlete logs some sessions.</span>' +
        '</div>'
      );
    }

    return html.join('');
  }

  // One session card. Two-column layout on desktop: PRESCRIBED on the
  // left (what was planned, category, name, slot, planned minutes),
  // NOTES + media on the right (what the athlete actually did). The
  // left edge of the card is a thick status stripe coloured by
  // CI_STATUS (green=done / red=missed / grey=today / blue=planned).
  // On narrow screens the columns stack so each takes full width.
  function renderCiSessionCard_(s) {
    var st = CI_STATUS[s.status] || CI_STATUS.planned;
    var slug = (s.category || '').toLowerCase().replace(/[^a-z0-9]+/g, '-') || 'other';

    // Prescribed column, what should have happened
    var leftBits = [];
    leftBits.push('<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;">');
    leftBits.push(
      '<span class="ci-status-chip" style="display:inline-flex;align-items:center;gap:4px;padding:2px 8px;border-radius:999px;font-size:10px;font-weight:700;letter-spacing:0.06em;background:' + st.color + ';color:#fff;">' +
        st.icon + ' ' + st.label +
      '</span>'
    );
    leftBits.push(
      '<span class="ci-cat ci-cat-' + escapeAttr(slug) + '" style="display:inline-block;padding:2px 8px;border-radius:999px;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:0.04em;background:rgba(0,0,0,0.06);color:#555;">' +
        escapeHtml(s.category || 'Other') +
      '</span>'
    );
    if (s.isNew) {
      leftBits.push('<span class="ci-new-pill" style="background:#2A6BD6;color:#fff;font-size:10px;padding:1px 7px;border-radius:999px;font-weight:600;">NEW</span>');
    }
    var replyCount = (s.replies && s.replies.length) || 0;
    if (replyCount) {
      leftBits.push('<span class="ci-replied-pill" title="You\'ve replied to this session" style="background:rgba(30,122,71,0.12);color:#1E7A47;font-size:10px;padding:1px 7px;border-radius:999px;font-weight:700;">✓ REPLIED · ' + replyCount + '</span>');
    }
    var kudosCount = Number(s.kudos || 0);
    if (kudosCount > 0) {
      leftBits.push('<span class="ci-kudos-pill" title="You\'ve sent kudos for this session" style="background:rgba(214,138,32,0.14);color:#A86200;font-size:10px;padding:1px 7px;border-radius:999px;font-weight:700;">👏 KUDOS' + (kudosCount > 1 ? ' · ' + kudosCount : '') + '</span>');
    }
    leftBits.push('</div>');
    // Empty-Name fallback, fall back to a descriptive label rather
    // than the awkward "(session)" placeholder so plans where the
    // trainer left some Import.Name cells blank still read clearly.
    var displayName = s.name && s.name.trim();
    if (!displayName) {
      var bits = [];
      if (s.category) bits.push(s.category);
      if (s.slot) bits.push(s.slot);
      displayName = bits.length ? bits.join(' · ') + ' session' : 'Unnamed session';
    }
    leftBits.push('<div style="font-weight:600;color:#1A1918;font-size:14px;margin-top:6px;">' + escapeHtml(displayName) + '</div>');
    var metaParts = [];
    if (s.slot) metaParts.push(s.slot);
    if (s.plannedMin) metaParts.push(s.plannedMin + ' min planned');
    if (s.person) metaParts.push(escapeHtml(s.person));
    leftBits.push('<div style="font-size:11px;color:#777775;margin-top:4px;">' + metaParts.join(' · ') + '</div>');

    // Activity column, what actually happened
    var rightBits = [];
    if (s.actualMin !== '' && s.actualMin != null) {
      rightBits.push('<div style="font-size:12px;color:#777775;margin-bottom:4px;">Logged: <strong style="color:#1A1918;">' + escapeHtml(String(s.actualMin)) + ' min</strong>' + (s.latestTs ? ' · ' + escapeHtml(formatRelative(s.latestTs)) : '') + '</div>');
    } else if (s.latestTs) {
      rightBits.push('<div style="font-size:11px;color:#777775;margin-bottom:4px;">' + escapeHtml(formatRelative(s.latestTs)) + '</div>');
    }
    if (s.note) {
      rightBits.push(
        '<div style="padding:8px 10px;background:rgba(0,0,0,0.04);border-left:3px solid ' + st.color + ';border-radius:0 4px 4px 0;white-space:pre-wrap;color:#1A1918;font-size:13px;line-height:1.5;margin-bottom:6px;">' +
          escapeHtml(s.note) +
        '</div>'
      );
    }
    if (s.photos && s.photos.length) {
      rightBits.push('<div style="display:grid;grid-template-columns:repeat(auto-fill, minmax(64px, 1fr));gap:4px;margin-bottom:6px;">' +
        s.photos.map(function (p) {
          return '<img data-ci-thumb="' + escapeAttr(p.fileId) + '" style="width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:4px;background:#E5E2D9;" alt="">';
        }).join('') +
      '</div>');
    }
    if (s.videos && s.videos.length) {
      // Video tiles, same thumbnail grid shape as photos, with a play
      // overlay so the trainer can tell them apart at a glance. Click
      // opens an in-page lightbox that STREAMS the video through the
      // Cloudflare Worker proxy (service-account Drive auth). NOT a
      // Drive /view link, which showed "can't play, download" for
      // private Workspace videos the trainer has no Drive permission
      // on. Falls back to a Drive /preview iframe when the Worker
      // isn't configured. Thumbnails still come from loadCoachThumbs_.
      rightBits.push('<div style="display:grid;grid-template-columns:repeat(auto-fill, minmax(80px, 1fr));gap:4px;">' +
        s.videos.map(function (v) {
          return '<a href="#" data-ci-video="' + escapeAttr(v.fileId) + '" role="button" aria-label="Play video" style="position:relative;display:block;aspect-ratio:1/1;background:#E5E2D9;border-radius:4px;overflow:hidden;text-decoration:none;cursor:pointer;">' +
            '<img data-ci-thumb="' + escapeAttr(v.fileId) + '" data-ci-thumb-kind="video" style="width:100%;height:100%;object-fit:cover;display:block;" alt="">' +
            '<span style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:linear-gradient(180deg, rgba(0,0,0,0) 30%, rgba(0,0,0,0.45) 100%);color:#fff;font-size:22px;text-shadow:0 1px 4px rgba(0,0,0,0.6);">▶</span>' +
          '</a>';
        }).join('') +
      '</div>');
    }
    // Empty-activity placeholder so the right column doesn't collapse
    // and the trainer can see at a glance "nothing logged yet".
    if (!rightBits.length) {
      var placeholderTxt =
        s.status === 'done'   ? '(no notes, ticked done)' :
        s.status === 'missed' ? '(no notes, skipped)' :
        s.status === 'today'  ? '(scheduled for today)' :
                                '(planned, no activity yet)';
      rightBits.push('<div style="font-size:12px;color:#777775;font-style:italic;opacity:0.7;">' + placeholderTxt + '</div>');
    }

    // "View workout" disclosure, collapsed by default; expands to
    // show the Description cell from the Import row (the LLM-authored
    // markdown brief). Saves the trainer from having to open the
    // athlete's plan page just to remind themselves what was
    // prescribed. Plain text/markdown rendered with bold + bullets
    // preserved; full markdown engine would be overkill here.
    var workoutBlock = '';
    if (s.description && s.description.trim()) {
      workoutBlock =
        '<details class="ci-workout" style="margin-top:10px;border-top:1px dashed #D6D2C7;padding-top:8px;">' +
          '<summary style="cursor:pointer;list-style:none;font-size:11px;font-weight:600;color:#555;letter-spacing:0.04em;text-transform:uppercase;user-select:none;">' +
            '<span style="display:inline-block;width:16px;">▸</span> View workout' +
          '</summary>' +
          '<div style="margin-top:8px;padding:10px 12px;background:rgba(255,255,255,0.6);border:1px solid #E5E2D9;border-radius:6px;font-size:13px;line-height:1.55;color:#1A1918;white-space:pre-wrap;">' +
            renderInlineMarkdown_(s.description) +
          '</div>' +
        '</details>';
    }

    // Reply block, collapsed by default. Click "Reply" → expands a
    // textarea + Send button. Submits via the `replyToAthlete`
    // server action which emails the athlete with the session
    // context pre-quoted. Per-session reply so the trainer can
    // respond to a specific note inline. data-* attributes carry
    // the session metadata the click handler needs (the form is
    // delegated, not bound here, survives re-renders).
    var replyLabel = replyCount
      ? '✉️ ' + replyCount + ' repl' + (replyCount === 1 ? 'y' : 'ies') + ' · send another'
      : '✉️ Reply to athlete';
    var priorReplies = '';
    if (replyCount) {
      // Render the oldest → newest thread inside a scrollable
      // container so a long history doesn't push the textarea
      // off-screen. Each row is timestamp + trainer + message,
      // with the trainer's name muted and the message body in
      // the same speech-bubble style as the athlete's note.
      priorReplies = '<div class="ci-reply-thread" style="margin-bottom:10px;max-height:200px;overflow-y:auto;display:flex;flex-direction:column;gap:6px;">' +
        s.replies.map(function (r) {
          return '<div style="padding:8px 10px;background:rgba(30,122,71,0.06);border-left:3px solid #1E7A47;border-radius:0 4px 4px 0;font-size:12px;line-height:1.5;color:#1A1918;">' +
            '<div style="font-size:10px;color:#777775;margin-bottom:4px;">' +
              escapeHtml(r.trainer || 'Trainer') + ' · ' + escapeHtml(formatRelative(r.ts)) +
            '</div>' +
            '<div style="white-space:pre-wrap;">' + escapeHtml(r.message || '') + '</div>' +
          '</div>';
        }).join('') +
      '</div>';
    }
    // Emoji-picker kudos row, six specific reactions instead of the
    // old binary "👏 Kudos" button. Each emoji clickable; server
    // records the emoji choice in the Coach Replies Subject column
    // and the athlete page renders the actual reaction in the modal
    // banner + pill badge. (#49, 2026-06-17.)
    // Disabled briefly after send to avoid accidental double-tap;
    // server still allows multi-react (multiple distinct kudos rows).
    var KUDOS_EMOJIS = ['👏', '🔥', '💪', '⭐', '✅', '🎯'];
    var kudosTitles = {
      '👏': 'Kudos, great work',
      '🔥': 'On fire',
      '💪': 'Strong session',
      '⭐': 'Standout',
      '✅': 'Solid completion',
      '🎯': 'Hit the target',
    };
    var kudosBlock =
      '<div class="ci-kudos-row" style="margin-top:10px;display:flex;justify-content:flex-end;align-items:center;gap:6px;flex-wrap:wrap;">' +
        '<span style="font-size:11px;color:#777775;font-weight:600;letter-spacing:0.04em;text-transform:uppercase;margin-right:4px;">React</span>' +
        KUDOS_EMOJIS.map(function (e) {
          return '<button type="button" class="ci-kudos-btn"' +
            ' data-emoji="' + escapeAttr(e) + '"' +
            ' data-session-id="' + escapeAttr(s.sessionId) + '"' +
            ' data-session-name="' + escapeAttr(s.sessionName || displayName) + '"' +
            ' data-scheduled="' + escapeAttr(s.scheduled || '') + '"' +
            ' title="' + escapeAttr(kudosTitles[e]) + '"' +
            ' aria-label="Send ' + escapeAttr(kudosTitles[e]) + '"' +
            ' style="background:#FFFFFF;border:1px solid #E5E2D9;border-radius:999px;width:34px;height:34px;font-size:18px;line-height:1;padding:0;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;transition:background 0.15s,border-color 0.15s,transform 0.1s;">' +
            e + '</button>';
        }).join('') +
      '</div>';
    var replyBlock =
      '<details class="ci-reply" style="margin-top:10px;border-top:1px dashed #D6D2C7;padding-top:8px;">' +
        '<summary style="cursor:pointer;list-style:none;font-size:11px;font-weight:600;color:#555;letter-spacing:0.04em;text-transform:uppercase;user-select:none;">' +
          '<span style="display:inline-block;width:16px;">▸</span> ' + escapeHtml(replyLabel) +
        '</summary>' +
        '<div style="margin-top:8px;">' +
          priorReplies +
          '<form class="ci-reply-form" style="display:flex;flex-direction:column;gap:8px;"' +
            ' data-session-id="' + escapeAttr(s.sessionId) + '"' +
            ' data-session-name="' + escapeAttr(s.sessionName || displayName) + '"' +
            ' data-scheduled="' + escapeAttr(s.scheduled || '') + '"' +
            ' data-note="' + escapeAttr(s.note || '') + '">' +
            '<textarea class="ci-reply-text" rows="3" placeholder="Write a short reply. The athlete will get it as an email." required maxlength="5000" style="width:100%;box-sizing:border-box;padding:8px 10px;border:1px solid #D6D2C7;border-radius:6px;font:inherit;font-size:13px;line-height:1.5;color:#1A1918;background:#FFFFFF;resize:vertical;"></textarea>' +
            '<div style="display:flex;gap:8px;align-items:center;justify-content:flex-end;">' +
              '<span class="ci-reply-status" style="font-size:11px;color:#777775;margin-right:auto;"></span>' +
              '<button type="submit" class="ci-reply-send" style="background:#1E7A47;color:#fff;padding:6px 14px;border-radius:6px;border:0;font:inherit;font-size:12px;font-weight:600;cursor:pointer;">Send reply</button>' +
            '</div>' +
          '</form>' +
        '</div>' +
      '</details>';

    return (
      '<div class="ci-session" style="background:#FFFFFF;border:1px solid #E5E2D9;border-left:4px solid ' + st.color + ';border-radius:8px;padding:12px 14px;margin-bottom:8px;background:' + st.tint + ';">' +
        '<div class="ci-session-grid" style="display:grid;grid-template-columns:minmax(0, 1fr) minmax(0, 1.4fr);gap:14px;align-items:start;">' +
          '<div>' + leftBits.join('') + '</div>' +
          '<div>' + rightBits.join('') + '</div>' +
        '</div>' +
        workoutBlock +
        kudosBlock +
        replyBlock +
      '</div>'
    );
  }

  // Minimal markdown shim for the View-workout block, enough for
  // the **Section:** body / - bullet shape the LLM authors. Anything
  // fancier would warrant a real parser; this is intentionally tiny.
  function renderInlineMarkdown_(text) {
    var safe = escapeHtml(String(text || ''));
    // Bold: **x** → <strong>x</strong>. Greedy disabled with [^*]+.
    safe = safe.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    return safe;
  }

  function openAthleteEditDrawer(token) {
    var a = state.info.athletes.find(function (x) { return x.token === token; });
    if (!a) return;
    // Close the overflow menu that just dispatched this click, both
    // visually (remove the floating menu element) and in state (so the
    // doc-level click handler doesn't re-render and wipe the modal).
    state.openOverflow = null;
    var staleMenu = document.querySelector('.admin-overflow-menu');
    if (staleMenu) staleMenu.remove();
    var overlay = document.createElement('div');
    overlay.className = 'athlete-edit-overlay';
    overlay.innerHTML =
      '<div class="athlete-edit-drawer">' +
      '<h3>Edit ' + escapeHtml(a.athleteName || 'athlete') + '</h3>' +
      '<label>Email</label>' +
      '<input id="ae-email" type="email" value="' + escapeHtml(a.email || '') + '" placeholder="athlete@example.com">' +
      '<label>Page URL</label>' +
      '<input id="ae-pageurl" type="url" value="' + escapeHtml(a.pageUrl || '') + '" placeholder="https://assassingoods.com/pages/...">' +
      '<label>Plan title</label>' +
      '<input id="ae-plantitle" type="text" value="' + escapeHtml(a.planTitle || '') + '">' +
      '<div class="athlete-edit-actions">' +
      '<button class="secondary" id="ae-cancel">Cancel</button>' +
      '<button id="ae-save">Save</button>' +
      '</div>' +
      '</div>';
    // Append inside .coach-root so the CSS custom properties (--card,
    // --heading, --border, etc.) defined on .coach-root are inherited.
    // Earlier this went on document.body, which inherits no vars and
    // rendered the modal unstyled (transparent inputs, no card).
    var coachRoot = document.querySelector('.coach-root') || document.body;
    coachRoot.appendChild(overlay);
    function close() { overlay.remove(); }
    // stopPropagation so input clicks inside the drawer never reach the
    // doc-level overflow-menu close handler (which would render-wipe us).
    overlay.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target === overlay) close();
    });
    overlay.addEventListener('mousedown', function (e) { e.stopPropagation(); });
    overlay.querySelector('#ae-cancel').addEventListener('click', close);
    overlay.querySelector('#ae-save').addEventListener('click', function () {
      var fields = {
        Email:        overlay.querySelector('#ae-email').value.trim(),
        'Page URL':   overlay.querySelector('#ae-pageurl').value.trim(),
        'Plan Title': overlay.querySelector('#ae-plantitle').value.trim(),
      };
      // Optimistic, apply locally + close the drawer immediately, POST in
      // background. Failure path reverts the state.
      var idx = state.info.athletes.findIndex(function (x) { return x.token === token; });
      var prev = idx >= 0 ? Object.assign({}, state.info.athletes[idx]) : null;
      if (idx >= 0) {
        state.info.athletes[idx].email = fields.Email;
        state.info.athletes[idx].pageUrl = fields['Page URL'];
        state.info.athletes[idx].planTitle = fields['Plan Title'];
      }
      close();
      render();
      writeInfoCache(state.info);
      postAction('updateAthlete', { athleteToken: token, fields: fields })
        .then(function (j) {
          if (!j.ok) {
            if (idx >= 0 && prev) state.info.athletes[idx] = prev;
            render();
            writeInfoCache(state.info);
            toast('Save failed: ' + (j.error || 'unknown'));
            return;
          }
          toast('Saved');
        })
        .catch(function (e) {
          if (idx >= 0 && prev) state.info.athletes[idx] = prev;
          render();
          writeInfoCache(state.info);
          toast('Network error: ' + e.message);
        });
    });
  }

  function submitNewAthlete() {
    var name  = (document.getElementById('ca-name').value || '').trim();
    var email = (document.getElementById('ca-email').value || '').trim();
    var tz    = (document.getElementById('ca-tz').value || 'Europe/London').trim();
    var learn = document.getElementById('ca-learning');
    var learnWeeksEl = document.getElementById('ca-learning-weeks');
    var learningWeeks = (learn && learn.checked && learnWeeksEl)
      ? Math.max(1, Math.min(12, parseInt(learnWeeksEl.value, 10) || 4))
      : 0;
    if (!name) { toast('Name is required'); return; }
    if (!email) { toast('Email is required'); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { toast('Enter a valid email address'); return; }
    var btn = document.getElementById('ca-submit');
    btn.disabled = true; btn.textContent = 'Creating…';
    // Provisioning clones the template sheet via Drive API, usually
    // 5-15 s depending on Apps Script cold-state. Surface a "this is
    // working" hint right under the button so the trainer doesn't
    // wonder if the page froze.
    document.getElementById('ca-result').innerHTML =
      '<div class="coach-result coach-result-pending">' +
        '<div class="tmb-plan-spinner" aria-hidden="true" style="margin: 0 auto 10px;"></div>' +
        '<strong>Creating plan…</strong><br>' +
        '<span class="coach-result-hint">This usually takes 5–15 seconds. We\'re cloning the template sheet, registering the athlete in the directory, and seeding the plan.</span>' +
      '</div>';
    // If the form was pre-filled from a parsed intake, ship the raw
    // markdown through as the Athlete Context seed. Server writes it
    // straight into the Athlete Context tab on provisioning.
    var provisionBody = { name: name, email: email, timeZone: tz, learningWeeks: learningWeeks };
    if (state.intakeSeed) provisionBody.athleteContextSeed = state.intakeSeed;
    postAction('provisionAthlete', provisionBody)
      .then(function (j) {
        if (!j.ok) {
          toast('Failed: ' + j.error);
          btn.disabled = false; btn.textContent = 'Create plan';
          document.getElementById('ca-result').innerHTML = '';
          return;
        }
        var a = j.athlete;
        // Post-create action panel. Primary action: open the athlete's
        // plan in a new tab. Secondary actions vary by what's possible:
        //   • Send invite, if the athlete has an email
        //   • Copy token , for trainers who want it (admin+trainer)
        //   • Import plan, kick straight into the CSV import flow
        // Admins additionally see the raw Sheet link.
        var role = (state.info && state.info.trainer && state.info.trainer.role) || 'trainer';
        var isAdmin = role === 'admin';
        var planUrl = a.pageUrl || '';
        var hasEmail = !!a.email;
        var actions = '';
        if (planUrl) {
          var trainerPlanUrl = addQuery_(planUrl, 'mode=trainer');
          actions += '<a class="coach-result-btn primary" href="' + escapeHtml(trainerPlanUrl) + '" target="_blank" rel="noopener">Open plan ↗</a>';
        }
        if (hasEmail) {
          actions += '<button type="button" class="coach-result-btn" data-result-invite="' + escapeAttr(a.token) + '">Send invite</button>';
        }
        actions += '<button type="button" class="coach-result-btn" data-result-import="' + escapeAttr(a.token) + '" data-athlete-name="' + escapeAttr(a.athleteName || name) + '">Import plan</button>';
        actions += '<button type="button" class="coach-result-btn" data-result-copy-token="' + escapeAttr(a.token) + '">Copy token</button>';

        var resultHtml = '<div class="coach-result">' +
          '<strong>Plan created.</strong><br>' +
          '<span class="coach-result-title">' + escapeHtml(a.planTitle) + '</span>' +
          '<div class="coach-result-actions">' + actions + '</div>';
        if (isAdmin) {
          resultHtml +=
            '<div class="coach-result-admin">' +
            'Token: <code>' + escapeHtml(a.token) + '</code><br>' +
            'Sheet: <a href="' + escapeHtml(a.sheetUrl) + '" target="_blank" rel="noopener">open in new tab</a>' +
            '</div>';
        }
        resultHtml += '</div>';
        document.getElementById('ca-result').innerHTML = resultHtml;
        wireResultPanelActions_(a);
        btn.disabled = false; btn.textContent = 'Create plan';
        document.getElementById('ca-name').value = '';
        // Drop the intake seed so the next manual New Athlete starts
        // empty rather than inheriting the previous athlete's context.
        state.intakeParsed = null;
        state.intakeSeed = '';
        // Re-fetch list to show the new athlete
        fetchInfo().then(function (j2) {
          state.info = j2;
          // Don't full re-render; just update the athletes section?
          // Easier: full re-render but keep form open with the result.
          var preserveResult = document.getElementById('ca-result').innerHTML;
          render();
          state.showNewAthlete = true;
          render();
          var rd = document.getElementById('ca-result');
          if (rd) {
            rd.innerHTML = preserveResult;
            wireResultPanelActions_(j.athlete);
          }
        });
      })
      .catch(function (e) {
        toast('Network error: ' + e.message);
        btn.disabled = false; btn.textContent = 'Create plan';
      });
  }

  // Wire the four post-create result-panel buttons (Open plan / Send
  // invite / Import plan / Copy token). Re-callable so the re-render
  // that happens after fetchInfo doesn't drop the listeners.
  function wireResultPanelActions_(athlete) {
    var rd = document.getElementById('ca-result');
    if (!rd || !athlete) return;

    var inviteBtn = rd.querySelector('[data-result-invite]');
    if (inviteBtn) {
      inviteBtn.addEventListener('click', function () {
        var orig = inviteBtn.textContent;
        inviteBtn.disabled = true; inviteBtn.textContent = 'Sending…';
        postAction('resendAthleteWelcome', { athleteToken: athlete.token })
          .then(function (j) {
            inviteBtn.disabled = false; inviteBtn.textContent = orig;
            if (!j.ok) { toast('Failed: ' + (j.error || 'unknown')); return; }
            toast('Invite sent');
            inviteBtn.textContent = '✓ Invite sent';
          })
          .catch(function (e) {
            inviteBtn.disabled = false; inviteBtn.textContent = orig;
            toast('Network error: ' + e.message);
          });
      });
    }

    var importBtn = rd.querySelector('[data-result-import]');
    if (importBtn) {
      importBtn.addEventListener('click', function () {
        openImportPlanModal_(athlete.token, athlete.athleteName || importBtn.getAttribute('data-athlete-name') || '');
      });
    }

    var copyBtn = rd.querySelector('[data-result-copy-token]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var tok = copyBtn.getAttribute('data-result-copy-token') || '';
        var orig = copyBtn.textContent;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(tok).then(function () {
            copyBtn.textContent = '✓ Copied';
            setTimeout(function () { copyBtn.textContent = orig; }, 1500);
          }).catch(function () {
            toast('Copy failed, token: ' + tok);
          });
        } else {
          // Fallback for older browsers, use a temporary textarea.
          var ta = document.createElement('textarea');
          ta.value = tok;
          ta.style.position = 'fixed'; ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); copyBtn.textContent = '✓ Copied'; }
          catch (e) { toast('Copy failed, token: ' + tok); }
          document.body.removeChild(ta);
          setTimeout(function () { copyBtn.textContent = orig; }, 1500);
        }
      });
    }
  }

  // Parse CSV / TSV pasted into the bulk-paste textarea and merge
  // into state.newGroupMembers. Accepts comma OR tab OR multi-space
  // as the field separator so pasting straight from a spreadsheet
  // works. First field = name, second = email; further fields
  // ignored. Skips header rows that start with "name" / "email".
  function parseBulkCsv_() {
    var ta = document.getElementById('cg-bulk-csv');
    var replaceEl = document.getElementById('cg-bulk-replace');
    if (!ta) return;
    var raw = ta.value || '';
    var replace = !!(replaceEl && replaceEl.checked);
    var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var lines = raw.split(/\r?\n/);
    var parsed = [];
    var skipped = 0;
    lines.forEach(function (line) {
      var s = String(line || '').trim();
      if (!s) return;
      // CSV header line, skip.
      if (/^"?name"?\s*[,\t]/i.test(s)) return;
      // Split on tab OR comma OR 2+ spaces (handles all reasonable
      // copy-paste formats from spreadsheets / text files).
      var parts = s.split(/\t|,|\s{2,}/).map(function (p) {
        return p.replace(/^"|"$/g, '').trim();
      }).filter(Boolean);
      if (parts.length < 2) { skipped++; return; }
      var name = parts[0];
      var email = parts[1];
      if (!emailRe.test(email)) { skipped++; return; }
      parsed.push({ name: name, email: email });
    });
    if (!parsed.length) {
      toast(skipped
        ? 'No valid rows. ' + skipped + ' row(s) skipped. Make sure each line is "Name, email@…"'
        : 'Paste rows as Name, Email');
      return;
    }
    syncNewGroupMembersFromDom_();
    if (replace) {
      state.newGroupMembers = parsed;
    } else {
      // Append, dropping any blank placeholder rows in the current state.
      var keep = state.newGroupMembers.filter(function (m) { return m.name || m.email; });
      state.newGroupMembers = keep.concat(parsed);
    }
    // Hide the bulk area + clear it so re-toggle gives a fresh textarea.
    var area = document.getElementById('cg-bulk-area');
    if (area) area.hidden = true;
    ta.value = '';
    toast('Added ' + parsed.length + ' member' + (parsed.length === 1 ? '' : 's') +
      (skipped ? ' · ' + skipped + ' skipped' : ''));
    render();
  }

  // Export the current state.newGroupMembers as a CSV download.
  // Useful for saving the roster mid-edit, or pulling the list out of
  // a created group for editing elsewhere.
  function exportGroupMembersCsv_() {
    syncNewGroupMembersFromDom_();
    var rows = state.newGroupMembers.filter(function (m) {
      return (m.name || '').trim() || (m.email || '').trim();
    });
    if (!rows.length) { toast('No members to export'); return; }
    var lines = ['Name,Email'];
    rows.forEach(function (m) {
      var n = String(m.name || '').replace(/"/g, '""');
      var e = String(m.email || '').replace(/"/g, '""');
      lines.push('"' + n + '","' + e + '"');
    });
    var blob = new Blob([lines.join('\n')], { type: 'text/csv' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = 'group-members-' + new Date().toISOString().slice(0, 10) + '.csv';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 0);
  }

  // Walk the current DOM rows and write them back into
  // state.newGroupMembers so a re-render preserves typed-but-unsubmitted
  // input. Called from the +Add / remove handlers before they trigger
  // a render that would otherwise wipe the field values.
  function syncNewGroupMembersFromDom_() {
    var rows = document.querySelectorAll('#cg-member-list .cg-member-row');
    if (!rows.length) return;
    var next = [];
    rows.forEach(function (r) {
      var n = r.querySelector('.cg-mname');
      var e = r.querySelector('.cg-memail');
      next.push({
        name:  (n && n.value || '').trim(),
        email: (e && e.value || '').trim(),
      });
    });
    state.newGroupMembers = next;
  }

  // Read the dynamic member rows out of the form, validate them, and
  // POST `provisionGroup`. Pulls name+email from each .cg-member-row,
  // skipping rows where BOTH fields are empty (placeholder rows the
  // user didn't fill in). Validates: at least one member, all members
  // have name + valid email. Result panel mirrors submitNewAthlete.
  function submitNewGroup() {
    var name = (document.getElementById('cg-name').value || '').trim();
    var tz   = (document.getElementById('cg-tz').value || 'Europe/London').trim();
    var typeEl = document.getElementById('cg-type');
    var groupType = (typeEl && typeEl.value) || 'small_group';
    if (!name) { toast('Group name is required'); return; }

    // Sync state.newGroupMembers with current input values then strip
    // empty placeholder rows.
    var rows = document.querySelectorAll('#cg-member-list .cg-member-row');
    var members = [];
    var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    for (var i = 0; i < rows.length; i++) {
      var nameEl  = rows[i].querySelector('.cg-mname');
      var emailEl = rows[i].querySelector('.cg-memail');
      var mName  = (nameEl  && nameEl.value  || '').trim();
      var mEmail = (emailEl && emailEl.value || '').trim();
      if (!mName && !mEmail) continue;  // skip blank placeholder rows
      if (!mName)  { toast('Member ' + (i + 1) + ' is missing a name'); return; }
      if (!mEmail) { toast('Member ' + (i + 1) + ' is missing an email'); return; }
      if (!emailRe.test(mEmail)) { toast('Member ' + (i + 1) + ' email looks invalid'); return; }
      members.push({ name: mName, email: mEmail });
    }
    if (!members.length) { toast('At least one member is required'); return; }

    var btn = document.getElementById('cg-submit');
    btn.disabled = true; btn.textContent = 'Creating…';
    document.getElementById('cg-result').innerHTML =
      '<div class="coach-result coach-result-pending">' +
        '<div class="tmb-plan-spinner" aria-hidden="true" style="margin: 0 auto 10px;"></div>' +
        '<strong>Creating group plan…</strong><br>' +
        '<span class="coach-result-hint">Cloning the template, registering the group, and sending invite emails to each member.</span>' +
      '</div>';

    postAction('provisionGroup', { name: name, timeZone: tz, groupType: groupType, members: members })
      .then(function (j) {
        if (!j.ok) {
          toast('Failed: ' + j.error);
          btn.disabled = false; btn.textContent = 'Create group plan';
          document.getElementById('cg-result').innerHTML = '';
          return;
        }
        var g = j.group;
        var role = (state.info && state.info.trainer && state.info.trainer.role) || 'trainer';
        var isAdmin = role === 'admin';
        var planUrl = g.pageUrl || '';
        var actions = '';
        if (planUrl) {
          // mode=trainer triggers the plan page to forward the cached
          // trainer token to /exec, which lets the server skip the
          // athlete email gate when the trainer is admin or owns
          // this plan. Without it, the page asks the trainer for the
          // member's email.
          var trainerPlanUrl = addQuery_(planUrl, 'mode=trainer');
          actions += '<a class="coach-result-btn primary" href="' + escapeHtml(trainerPlanUrl) + '" target="_blank" rel="noopener">Open plan ↗</a>';
        }
        actions += '<button type="button" class="coach-result-btn" data-result-import="' + escapeAttr(g.token) + '" data-athlete-name="' + escapeAttr(g.athleteName || name) + '">Import plan</button>';
        actions += '<button type="button" class="coach-result-btn" data-result-copy-token="' + escapeAttr(g.token) + '">Copy token</button>';

        var resultHtml = '<div class="coach-result">' +
          '<strong>Group plan created.</strong><br>' +
          '<span class="coach-result-title">' + escapeHtml(g.planTitle || name) + '</span>' +
          '<div class="coach-result-meta">' + members.length + ' member' + (members.length === 1 ? '' : 's') + ', invites sent</div>' +
          '<div class="coach-result-actions">' + actions + '</div>';
        if (isAdmin) {
          resultHtml +=
            '<div class="coach-result-admin">' +
            'Token: <code>' + escapeHtml(g.token) + '</code>' +
            '</div>';
        }
        resultHtml += '</div>';
        document.getElementById('cg-result').innerHTML = resultHtml;

        btn.disabled = false; btn.textContent = 'Create group plan';
        // Reset form for the next group; refresh coachInfo so the new
        // group appears in the roster.
        state.newGroupMembers = [{ name: '', email: '' }, { name: '', email: '' }];
        fetchInfo().then(function (j2) {
          state.info = j2;
          writeInfoCache(j2);
          render();
        }).catch(function () { /* keep showing the result panel */ });
      })
      .catch(function (e) {
        toast('Network error: ' + (e.message || 'unknown'));
        btn.disabled = false; btn.textContent = 'Create group plan';
        document.getElementById('cg-result').innerHTML = '';
      });
  }

  function submitNewTrainer() {
    var name  = (document.getElementById('ct-name').value || '').trim();
    var email = (document.getElementById('ct-email').value || '').trim();
    var role  = (document.getElementById('ct-role').value || 'trainer').trim();
    if (!name) { toast('Name is required'); return; }
    var btn = document.getElementById('ct-submit');
    btn.disabled = true; btn.textContent = 'Creating…';
    postAction('provisionTrainer', { name: name, email: email, role: role })
      .then(function (j) {
        if (!j.ok) { toast('Failed: ' + j.error); btn.disabled = false; btn.textContent = 'Create trainer'; return; }
        var tr = j.trainer;
        document.getElementById('ct-result').innerHTML =
          '<div class="coach-result">' +
          '<strong>Trainer created.</strong><br>' +
          'Token (share with this trainer): <code>' + escapeHtml(tr.token) + '</code><br>' +
          'Role: ' + escapeHtml(tr.role) + '<br>' +
          'They paste this token into <em>this same coach page</em> to access their athletes.' +
          '</div>';
        btn.disabled = false; btn.textContent = 'Create trainer';
        document.getElementById('ct-name').value = '';
        document.getElementById('ct-email').value = '';
        // Refresh list
        fetchInfo().then(function (j2) {
          state.info = j2;
          var preserveResult = document.getElementById('ct-result').innerHTML;
          render();
          state.showNewTrainer = true;
          render();
          var rd = document.getElementById('ct-result');
          if (rd) rd.innerHTML = preserveResult;
        });
      })
      .catch(function (e) {
        toast('Network error: ' + e.message);
        btn.disabled = false; btn.textContent = 'Create trainer';
      });
  }

  function signIn() {
    var input = document.getElementById('coach-token-input');
    var v = (input.value || '').trim();
    if (!v) return;
    state.token = v;
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    state.error = '';
    state.info = null;
    render();
    fetchInfo()
      .then(function (j) { state.info = j; writeInfoCache(j); render(); })
      .catch(function (e) {
        state.error = 'Authentication failed: ' + e.message;
        render();
      });
  }

  // Initial load, stale-while-revalidate via localStorage so a return
  // visit renders instantly from cache while the fresh fetch runs in
  // the background. Cache key is recomputed from the CURRENT token on
  // each access so a sign-in flow doesn't share its key with a previous
  // empty-token IIFE startup. Two coaches on the same browser stay
  // isolated.
  function infoCacheKey_() {
    return 'tmb_coach_info_' + simpleHash_(state.token || '');
  }
  function readInfoCache() {
    if (!state.token) return null;
    try {
      var raw = localStorage.getItem(infoCacheKey_());
      if (!raw) return null;
      var obj = JSON.parse(raw);
      return obj && obj.data ? obj.data : null;
    } catch (e) { return null; }
  }
  function writeInfoCache(data) {
    if (!state.token) return;
    try { localStorage.setItem(infoCacheKey_(), JSON.stringify({ ts: Date.now(), data: data })); }
    catch (e) {}
  }
  function simpleHash_(s) {
    var h = 0;
    for (var i = 0; i < s.length; i++) {
      h = ((h << 5) - h) + s.charCodeAt(i);
      h |= 0;
    }
    return Math.abs(h).toString(36);
  }
  if (state.token) {
    var cached = readInfoCache();
    if (cached) { state.info = cached; render(); }
    else { render(); }
    fetchInfo()
      .then(function (j) {
        state.info = j; writeInfoCache(j); render();
        startCoachAutoRefresh_();
      })
      .catch(function (e) {
        if (!cached) {
          state.error = 'Authentication failed: ' + e.message;
          render();
        }
      });
  } else {
    render();
  }

  // ── Coach-page background refresh ─────────────────────────────────────
  // Coach page used to fetchInfo() only on explicit trainer actions
  // (status changes, group adds, etc.). If athletes were ticking
  // sessions or uploading photos in the background, the trainer's
  // dashboard sat stale until they manually clicked something. Add a
  // 30s background poll with a signature-check skip, same pattern as
  // the athlete page. Render only fires when something actually
  // changed (athlete added, status flipped, last-active timestamp
  // bumped, member confirmed an invite, etc.).
  var COACH_REFRESH_INTERVAL_MS = 30000;
  var _coachRefreshStarted = false;
  var _lastInfoSig = '';

  function coachInfoSignature_(info) {
    if (!info) return '';
    var parts = [];
    // Athlete + trainer + group lengths catch additions/removals.
    var ath = info.athletes || [];
    var tra = info.trainers || [];
    var grp = info.groups || [];
    parts.push('a:' + ath.length + ',t:' + tra.length + ',g:' + grp.length);
    // Latest Last Active across all athletes catches background activity
    // (an athlete ticked a session → Last Active bumps server-side).
    var maxAct = '';
    for (var i = 0; i < ath.length; i++) {
      var a = ath[i] || {};
      var la = String(a.lastActive || '');
      if (la > maxAct) maxAct = la;
      // Status + emailConfirmed flips are visible on the card; include
      // them so the trainer sees those instantly when they change.
      parts.push((a.token || '') + ':' + (a.status || '') + ':' + (a.emailConfirmed ? '1' : '0'));
    }
    parts.push('maxAct:' + maxAct);
    return parts.join('|');
  }

  function startCoachAutoRefresh_() {
    if (_coachRefreshStarted) return;
    _coachRefreshStarted = true;
    _lastInfoSig = coachInfoSignature_(state.info);
    setInterval(function () {
      // Skip if a modal / form is open, re-render would wipe their
      // typing. Same defensive pattern as the athlete page.
      if (document.querySelector('.athlete-edit-overlay, .coach-bug-modal')) return;
      if (state.showNewAthlete || state.showNewGroup || state.showNewTrainer ||
          state.showFromIntake || state.showIntake) return;
      // Pause polling while the AI chat drawer is open, it's portaled to
      // <body> so escapes the .athlete-edit-overlay guard above, and a
      // mid-chat full re-render wipes the drawer + typed input. Drawer
      // close re-arms the poll on the next interval tick. (#65 perf F8 / D)
      if (document.getElementById('tmb-ai-chat-drawer')) return;
      // Also skip while the tab is hidden so we don't burn /exec quota
      // on a backgrounded browser tab.
      if (document.hidden) return;
      fetchInfo().then(function (j) {
        state.info = j;
        writeInfoCache(j);
        var sig = coachInfoSignature_(j);
        if (sig === _lastInfoSig) return;  // no-op poll, skip render
        _lastInfoSig = sig;
        // Re-check modal-open state HERE too: the outer interval guard
        // prevents new fetches when a modal is up, but a fetch that
        // started just BEFORE the user opened a modal would otherwise
        // resolve mid-modal and render() would wipe the overlay. This
        // was the "Import plan modal opens then closes 2 sec later"
        // bug. Cache stays warm; next poll re-renders once modal closes.
        if (document.querySelector('.athlete-edit-overlay, .coach-bug-modal')) return;
        if (state.showNewAthlete || state.showNewGroup || state.showNewTrainer ||
            state.showFromIntake || state.showIntake) return;
        render();
      }).catch(function () {
        // Silent, transient network blip will recover on the next tick.
      });
    }, COACH_REFRESH_INTERVAL_MS);
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // AI CHAT DRAWER, per-athlete chat that mutates the sheet directly via
  // tool calls (no CSV round-trip). Mounted on document.body so it survives
  // every #coach-root re-render. State lives in state.aiChat so it's
  // session-scoped (clears on page reload, durable memory is in the
  // athlete's Athlete Context + Update Log sheet tabs).
  //
  // Open from: PLAN / 🤖 AI overflow-menu entry (data-athlete-ai-chat).
  // Close: ╳ button, ESC, or backdrop click.
  // ═══════════════════════════════════════════════════════════════════════════
  state.aiChat = {
    open: false,
    athleteToken: null,
    athleteName: '',
    messages: [],
    sending: false,
    model: localStorage.getItem('tmb_ai_chat_model') || 'haiku',
    totalCostUsd: 0,
    pendingInput: '',
  };

  var AI_CHAT_MODELS = [
    { key: 'haiku',   label: 'Haiku 4.5, cheapest' },
    { key: 'sonnet',  label: 'Sonnet 4.6' },
    { key: 'opus',    label: 'Opus 4.7, smartest' },
    { key: 'gpt-4.1', label: 'GPT-4.1' },
    { key: 'gpt-5',   label: 'GPT-5' },
  ];

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-athlete-ai-chat]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var token = btn.getAttribute('data-athlete-ai-chat');
    var name  = btn.getAttribute('data-athlete-name') || '';
    try { closeOpenOverflowMenu_(); } catch (_e) {}
    openAiChatDrawer_(token, name);
  }, true);

  // Close drawer on ESC, but only if no inner control is being typed
  // into (textarea ESC should NOT collapse a half-written prompt).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!state.aiChat.open) return;
    if (e.target && e.target.matches && e.target.matches('.tmb-ai-input, .tmb-ai-input *')) return;
    closeAiChatDrawer_();
  });

  function openAiChatDrawer_(athleteToken, athleteName) {
    state.aiChat.open = true;
    state.aiChat.athleteToken = athleteToken;
    state.aiChat.athleteName = athleteName || '';
    state.aiChat.messages = [];
    state.aiChat.sending = false;
    state.aiChat.totalCostUsd = 0;
    renderAiChatDrawer_();
    // Load history in the background, render placeholder immediately.
    postAction('aiChat', { subAction: 'history', athleteToken: athleteToken })
      .then(function (r) {
        if (!r || !r.ok) {
          state.aiChat.messages = [];
          if (r && r.error) {
            state.aiChat.messages.push({ role: 'system', message: r.error });
          }
          renderAiChatDrawer_();
          return;
        }
        state.aiChat.messages = r.messages || [];
        state.aiChat.totalCostUsd = Number(r.totalCostUsd || 0);
        renderAiChatDrawer_();
        scrollAiChatToEnd_();
      })
      .catch(function (err) {
        state.aiChat.messages = [{ role: 'system', message: '(failed to load history: ' + err + ')' }];
        renderAiChatDrawer_();
      });
  }

  function closeAiChatDrawer_(opts) {
    opts = opts || {};
    // Heavy-thread prompt, if the trainer is closing a long thread
    // without saving, offer to save+clear first so durable memory
    // (Athlete Memory + Update Log) reflects what was discussed.
    // Skipped via opts.skipPrompt for programmatic closes (e.g. after
    // a Save & clear succeeds).
    var msgCount = (state.aiChat.messages || []).length;
    if (!opts.skipPrompt && msgCount > 10 && !state.aiChat.sending) {
      var choice = confirm(
        'This thread has ' + msgCount + ' turns. Save to Athlete Memory + Update Log first?\n\n' +
        'OK = Save & clear (recommended)\n' +
        'Cancel = Just close (the chat stays on the sheet; durable memory may be stale)'
      );
      if (choice) {
        // Trigger save-and-clear, then close once it completes.
        state.aiChat.sending = true;
        renderAiChatDrawer_();
        postAction('aiChat', {
          subAction: 'clear',
          athleteToken: state.aiChat.athleteToken,
          saveToMemory: true,
          model: state.aiChat.model,
        }).then(function () {
          state.aiChat.sending = false;
          closeAiChatDrawer_({ skipPrompt: true });
        }).catch(function () {
          state.aiChat.sending = false;
          // Still close, don't trap the trainer if save fails.
          closeAiChatDrawer_({ skipPrompt: true });
        });
        return;
      }
    }
    // Stash whatever was being typed so reopening the same athlete
    // restores it. Keyed per-athlete; one in-flight prompt per athlete.
    try {
      var ta = document.querySelector('.tmb-ai-input textarea');
      if (ta && state.aiChat.athleteToken) {
        var draft = ta.value || '';
        if (draft) localStorage.setItem('tmb_ai_draft_' + state.aiChat.athleteToken, draft);
        else localStorage.removeItem('tmb_ai_draft_' + state.aiChat.athleteToken);
      }
    } catch (_e) {}
    state.aiChat.open = false;
    var el = document.getElementById('tmb-ai-chat-drawer');
    if (el) el.remove();
    var bd = document.getElementById('tmb-ai-chat-backdrop');
    if (bd) bd.remove();
  }

  // Page-unload guard, if the trainer tries to leave/refresh the page
  // mid-thread, browser shows a generic "Leave site?" confirm. The
  // message text is browser-controlled (modern browsers ignore custom
  // strings); we just trigger the prompt. The trainer can still leave;
  // the chat persists to the sheet's AI Chat tab so nothing's lost,
  // this just nudges them to Save & clear so Athlete Memory is fresh.
  window.addEventListener('beforeunload', function (e) {
    try {
      if (state.aiChat && state.aiChat.open && (state.aiChat.messages || []).length > 2) {
        e.preventDefault();
        e.returnValue = '';
        return '';
      }
    } catch (_e) {}
  });

  function renderAiChatDrawer_() {
    var existing = document.getElementById('tmb-ai-chat-drawer');
    if (existing) existing.remove();
    var existingBd = document.getElementById('tmb-ai-chat-backdrop');
    if (existingBd) existingBd.remove();
    if (!state.aiChat.open) return;

    var backdrop = document.createElement('div');
    backdrop.id = 'tmb-ai-chat-backdrop';
    backdrop.className = 'tmb-ai-backdrop';
    backdrop.addEventListener('click', closeAiChatDrawer_);

    var drawer = document.createElement('div');
    drawer.id = 'tmb-ai-chat-drawer';
    drawer.className = 'tmb-ai-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-label', 'AI Plan Author');

    var modelOptions = AI_CHAT_MODELS.map(function (m) {
      var sel = m.key === state.aiChat.model ? ' selected' : '';
      return '<option value="' + m.key + '"' + sel + '>' + escapeHtml(m.label) + '</option>';
    }).join('');

    var costStr = state.aiChat.totalCostUsd > 0
      ? '$' + state.aiChat.totalCostUsd.toFixed(3)
      : '-';

    var messagesHtml = renderAiMessages_(state.aiChat.messages);

    // Pull any saved draft for this athlete so a half-written prompt
    // isn't lost when the trainer closes + reopens the drawer.
    var draftKey = 'tmb_ai_draft_' + state.aiChat.athleteToken;
    var draft = '';
    try { draft = localStorage.getItem(draftKey) || ''; } catch (_e) {}

    drawer.innerHTML =
      '<div class="tmb-ai-header">' +
        '<div class="tmb-ai-title">' +
          '<div class="tmb-ai-title-row1">AI Plan Author</div>' +
          '<div class="tmb-ai-title-row2">' + escapeHtml(state.aiChat.athleteName || '(athlete)') + '</div>' +
        '</div>' +
        '<button class="tmb-ai-close" data-tmb-ai-close aria-label="Close">×</button>' +
      '</div>' +
      '<div class="tmb-ai-controls">' +
        '<label class="tmb-ai-model">' +
          '<span>Model</span>' +
          '<select data-tmb-ai-model>' + modelOptions + '</select>' +
        '</label>' +
        '<div class="tmb-ai-cost" title="Total spend on this thread (input + output tokens)">' +
          'Cost <strong>' + costStr + '</strong>' +
        '</div>' +
        ((state.aiChat.messages || []).length > 12
          ? '<button class="tmb-ai-compress" data-tmb-ai-compress title="Summarise the oldest turns into a single Update Log digest and delete them from this chat. Keeps the last 5 turns visible.">Compress older</button>'
          : '') +
        '<button class="tmb-ai-clear" data-tmb-ai-clear title="Asks the model to save the gist to Athlete Memory + Update Log, then wipes the chat history.">Save &amp; clear</button>' +
      '</div>' +
      '<div class="tmb-ai-messages" data-tmb-ai-messages>' + messagesHtml + '</div>' +
      '<div class="tmb-ai-input">' +
        '<textarea rows="3" placeholder="Ask the AI to author or edit the plan… (Enter to send, Shift+Enter for newline)">' + escapeHtml(draft) + '</textarea>' +
        '<button class="tmb-ai-send" data-tmb-ai-send>Send</button>' +
      '</div>' +
      '<div class="tmb-ai-hint">' +
        'Durable memory lives in <strong>Athlete Context</strong> + <strong>Update Log</strong> on the sheet. ' +
        'The chat itself is ephemeral. Hit <em>Save &amp; clear</em> when it gets long.' +
      '</div>';

    document.body.appendChild(backdrop);
    document.body.appendChild(drawer);
    wireAiChatDrawer_(drawer);
    // Focus the textarea after mount so the trainer can start typing
    // immediately. Skipped if there's no athlete loaded (shouldn't
    // happen but defensive).
    var ta = drawer.querySelector('.tmb-ai-input textarea');
    if (ta) {
      ta.focus();
      // Put caret at end of any restored draft.
      try { ta.setSelectionRange(ta.value.length, ta.value.length); } catch (_e) {}
    }
  }

  function wireAiChatDrawer_(drawer) {
    drawer.querySelector('[data-tmb-ai-close]').addEventListener('click', closeAiChatDrawer_);

    drawer.querySelector('[data-tmb-ai-model]').addEventListener('change', function (e) {
      state.aiChat.model = e.target.value;
      try { localStorage.setItem('tmb_ai_chat_model', state.aiChat.model); } catch (_e) {}
    });

    var compressBtn = drawer.querySelector('[data-tmb-ai-compress]');
    if (compressBtn) {
      compressBtn.addEventListener('click', function () {
        if (state.aiChat.sending) return;
        var confirmed = confirm('Summarise the oldest turns into a single Update Log digest and delete them from this chat? Keeps the last 5 turns visible.');
        if (!confirmed) return;
        state.aiChat.sending = true;
        renderAiChatDrawer_();
        postAction('aiChat', {
          subAction: 'compress',
          athleteToken: state.aiChat.athleteToken,
          keep: 5,
          model: state.aiChat.model,
        }).then(function (r) {
          state.aiChat.sending = false;
          if (!r || !r.ok) {
            state.aiChat.messages.push({ role: 'system', message: r && r.error ? r.error : '(compress failed)' });
            renderAiChatDrawer_();
            return;
          }
          // Reload history from server, older rows are now deleted +
          // digest is in the Update Log.
          postAction('aiChat', { subAction: 'history', athleteToken: state.aiChat.athleteToken })
            .then(function (h) {
              if (h && h.ok) {
                state.aiChat.messages = h.messages || [];
                state.aiChat.totalCostUsd = Number(h.totalCostUsd || 0);
                state.aiChat.messages.push({
                  role: 'system',
                  message: 'Compressed ' + r.compressed + ' older turn' + (r.compressed === 1 ? '' : 's') +
                           ' into the Update Log. Searchable via search_update_log.',
                });
              }
              renderAiChatDrawer_();
              scrollAiChatToEnd_();
            });
        }).catch(function (err) {
          state.aiChat.sending = false;
          state.aiChat.messages.push({ role: 'system', message: '(compress failed: ' + err + ')' });
          renderAiChatDrawer_();
        });
      });
    }

    drawer.querySelector('[data-tmb-ai-clear]').addEventListener('click', function () {
      if (state.aiChat.sending) return;
      var confirmed = confirm('Save the gist of this chat to Athlete Context + Update Log, then clear the thread?');
      if (!confirmed) return;
      state.aiChat.sending = true;
      renderAiChatDrawer_();
      postAction('aiChat', {
        subAction: 'clear',
        athleteToken: state.aiChat.athleteToken,
        saveToMemory: true,
        model: state.aiChat.model,
      }).then(function (r) {
        state.aiChat.sending = false;
        if (!r || !r.ok) {
          state.aiChat.messages.push({ role: 'system', message: r && r.error ? r.error : '(clear failed)' });
          renderAiChatDrawer_();
          return;
        }
        state.aiChat.messages = [];
        state.aiChat.totalCostUsd = 0;
        renderAiChatDrawer_();
      }).catch(function (err) {
        state.aiChat.sending = false;
        state.aiChat.messages.push({ role: 'system', message: '(clear failed: ' + err + ')' });
        renderAiChatDrawer_();
      });
    });

    var ta = drawer.querySelector('.tmb-ai-input textarea');
    var sendBtn = drawer.querySelector('[data-tmb-ai-send]');

    function send() {
      if (state.aiChat.sending) return;
      var msg = (ta.value || '').trim();
      if (!msg) return;
      state.aiChat.sending = true;
      state.aiChat.messages.push({ role: 'user', message: msg });
      var draftKey = 'tmb_ai_draft_' + state.aiChat.athleteToken;
      try { localStorage.removeItem(draftKey); } catch (_e) {}
      ta.value = '';
      renderAiChatDrawer_();
      scrollAiChatToEnd_();
      postAction('aiChat', {
        subAction: 'send',
        athleteToken: state.aiChat.athleteToken,
        message: msg,
        model: state.aiChat.model,
      }).then(function (r) {
        state.aiChat.sending = false;
        if (!r || !r.ok) {
          state.aiChat.messages.push({ role: 'system', message: r && r.error ? r.error : '(send failed)' });
          renderAiChatDrawer_();
          scrollAiChatToEnd_();
          return;
        }
        state.aiChat.messages.push({
          role:      'assistant',
          message:   r.reply,
          toolCalls: r.toolCalls || [],
          costUsd:   r.costUsd || 0,
          model:     r.model || state.aiChat.model,
          provider:  r.provider || '',
          usage:     r.usage || null,
        });
        state.aiChat.totalCostUsd += Number(r.costUsd || 0);
        renderAiChatDrawer_();
        scrollAiChatToEnd_();
        // The model may have mutated the sheet, refresh the coach
        // info so any visible athlete-card stats update.
        if (typeof fetchInfo === 'function') {
          fetchInfo().then(function (j) {
            state.info = j;
            writeInfoCache(j);
            render();
          }).catch(function () {});
        }
      }).catch(function (err) {
        state.aiChat.sending = false;
        state.aiChat.messages.push({ role: 'system', message: '(send failed: ' + err + ')' });
        renderAiChatDrawer_();
      });
    }

    sendBtn.addEventListener('click', send);

    ta.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        send();
      }
    });

    // Persist drafts as the trainer types so a tab refresh doesn't
    // eat a half-written 200-word prompt.
    var draftKey = 'tmb_ai_draft_' + state.aiChat.athleteToken;
    ta.addEventListener('input', function () {
      try {
        if (ta.value) localStorage.setItem(draftKey, ta.value);
        else localStorage.removeItem(draftKey);
      } catch (_e) {}
    });
  }

  function renderAiMessages_(messages) {
    if (!messages.length) {
      return '<div class="tmb-ai-empty">' +
        '<p><strong>Hi.</strong> Ask me to author a fresh plan, add a deload week, fix a session, ' +
          'or anything else about <em>' + escapeHtml(state.aiChat.athleteName || 'this athlete') + '</em>\'s programming.</p>' +
        '<p>I\'ll write directly to the sheet, no CSV files. The first thing I usually do is read the current state of the plan, so give me a couple of seconds.</p>' +
      '</div>';
    }
    var bubbles = messages.map(function (m) {
      var cls = 'tmb-ai-msg tmb-ai-msg-' + m.role;
      var body = '';
      if (m.role === 'user') {
        body = '<div class="tmb-ai-body">' + renderAiMarkdown_(m.message) + '</div>';
      } else if (m.role === 'system') {
        body = '<div class="tmb-ai-body tmb-ai-system">' + escapeHtml(m.message) + '</div>';
      } else {
        // assistant, optional tool call summary, then the reply.
        var toolHtml = '';
        if (m.toolCalls && m.toolCalls.length) {
          toolHtml = '<div class="tmb-ai-tools">' + m.toolCalls.map(function (tc) {
            var ok = tc.result && tc.result.ok !== false;
            var icon = ok ? '✓' : '✕';
            var summary = tc.name;
            // Count fallback chain: prefer the input array length (matches
            // what the model TRIED to do), fall back to the result count
            // (what the server actually applied) so a history-loaded turn
            // with a truncated input field still shows a meaningful number.
            var bulkCount = null;
            if (tc.name === 'bulk_apply_changes') {
              if (tc.input && Array.isArray(tc.input.changes)) bulkCount = tc.input.changes.length;
              else if (tc.result && typeof tc.result.count === 'number') bulkCount = tc.result.count;
            } else if (tc.name === 'bulk_edit_rows') {
              if (tc.input && Array.isArray(tc.input.edits)) bulkCount = tc.input.edits.length;
              else if (tc.result && typeof tc.result.count === 'number') bulkCount = tc.result.count;
            } else if (tc.name === 'bulk_add_rows') {
              if (tc.input && Array.isArray(tc.input.adds)) bulkCount = tc.input.adds.length;
              else if (tc.result && typeof tc.result.count === 'number') bulkCount = tc.result.count;
            }
            if (bulkCount != null) {
              summary += ' (' + bulkCount + ' row' + (bulkCount === 1 ? '' : 's') + ')';
            } else if (tc.input) {
              if (tc.input.tab && tc.input.key) summary += ' (' + tc.input.tab + ': ' + tc.input.key + ')';
              else if (tc.input.tab)            summary += ' (' + tc.input.tab + ')';
              else if (tc.input.type)           summary += ' (' + tc.input.type + ')';
            }
            // Bulk tools, if some sub-edits errored, show how many AND
            // append a details-list of which specific rows failed so the
            // trainer doesn't have to chase the model for a breakdown.
            var subErr = '';
            var subDetails = '';
            if (tc.result && typeof tc.result.errored === 'number' && tc.result.errored > 0) {
              subErr = ' · ' + tc.result.errored + ' failed';
              if (Array.isArray(tc.result.results)) {
                var failures = tc.result.results.filter(function (r) { return r && r.ok === false; });
                if (failures.length) {
                  subDetails = '<div class="tmb-ai-tool-fails">' +
                    failures.slice(0, 10).map(function (f) {
                      var label = '';
                      if (f.op) label += f.op + ' ';
                      if (f.tab) label += f.tab;
                      if (f.key) label += ': ' + f.key;
                      return '<div>• ' + escapeHtml(label || '(unknown)') + '-' +
                        escapeHtml(f.error || 'unknown error') + '</div>';
                    }).join('') +
                    (failures.length > 10 ? '<div>… +' + (failures.length - 10) + ' more</div>' : '') +
                  '</div>';
                }
              }
            }
            // Verification, server-measured actual row deltas per tab.
            // Trainer-visible source of truth: if the model claimed to
            // add 7 rows but the verification delta is 0, the chip
            // shows the discrepancy here rather than burying it in
            // model prose. Shown for any bulk_apply_changes result
            // that came back with a verification block.
            if (tc.result && tc.result.verification) {
              var vRows = [];
              Object.keys(tc.result.verification).forEach(function (t) {
                var v = tc.result.verification[t] || {};
                var delta = Number(v.delta || 0);
                var deltaStr = (delta > 0 ? '+' + delta : String(delta));
                var cls = delta < 0 ? 'tmb-ai-verify-down'
                        : delta > 0 ? 'tmb-ai-verify-up'
                        : 'tmb-ai-verify-flat';
                vRows.push('<div class="' + cls + '">• ' +
                  escapeHtml(t) + ': ' + deltaStr + ' row' + (Math.abs(delta) === 1 ? '' : 's') +
                  ' (now ' + Number(v.after || 0) + ' total)</div>');
              });
              if (vRows.length) {
                subDetails += '<div class="tmb-ai-tool-verify">' + vRows.join('') + '</div>';
              }
            }
            return '<div class="tmb-ai-tool-wrap">' +
              '<div class="tmb-ai-tool ' + (ok ? 'ok' : 'err') + '">' +
                '<span class="tmb-ai-tool-icon">' + icon + '</span>' +
                '<span class="tmb-ai-tool-name">' + escapeHtml(summary + subErr) + '</span>' +
                (!ok && tc.result && tc.result.error ? '<span class="tmb-ai-tool-err">' + escapeHtml(tc.result.error) + '</span>' : '') +
              '</div>' +
              subDetails +
            '</div>';
          }).join('') + '</div>';
        }
        var meta = '';
        if (m.costUsd || m.model || m.usage) {
          var metaBits = [];
          if (m.model) metaBits.push(escapeHtml(m.model));
          if (m.usage) {
            var inTok  = Number(m.usage.input_tokens || 0);
            var outTok = Number(m.usage.output_tokens || 0);
            var crTok  = Number(m.usage.cache_read_input_tokens || 0);
            var tokStr = '↑' + (inTok + crTok) + ' ↓' + outTok;
            if (crTok) tokStr += ' (cache ' + crTok + ')';
            metaBits.push(tokStr);
          }
          if (m.costUsd) metaBits.push('$' + Number(m.costUsd).toFixed(4));
          meta = '<div class="tmb-ai-meta">' + metaBits.join(' · ') + '</div>';
        }
        body = toolHtml +
          '<div class="tmb-ai-body">' + renderAiMarkdown_(m.message) + '</div>' +
          meta;
      }
      return '<div class="' + cls + '">' + body + '</div>';
    }).join('');
    if (state.aiChat.sending) {
      bubbles += '<div class="tmb-ai-msg tmb-ai-msg-assistant tmb-ai-pending">' +
        '<div class="tmb-ai-body"><span class="tmb-ai-dots"><span></span><span></span><span></span></span> thinking…</div>' +
      '</div>';
    }
    return bubbles;
  }

  // Very small markdown renderer, just enough for chat replies.
  // Escapes everything first, then unescapes the markdown patterns
  // we whitelist. No HTML injection surface.
  function renderAiMarkdown_(s) {
    var t = escapeHtml(String(s || ''));
    // Code fences
    t = t.replace(/```([\s\S]*?)```/g, function (_, code) {
      return '<pre><code>' + code + '</code></pre>';
    });
    // Inline code
    t = t.replace(/`([^`]+)`/g, '<code>$1</code>');
    // Bold
    t = t.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    // Italic, single * not at start of a list line
    t = t.replace(/(^|[^*])\*([^*\n]+)\*/g, '$1<em>$2</em>');
    // Bullet lists
    t = t.replace(/(^|\n)- (.+)/g, '$1<li>$2</li>');
    t = t.replace(/(<li>[\s\S]*?<\/li>)/g, function (m) {
      // Group consecutive <li>s under one <ul>
      return '<ul>' + m + '</ul>';
    });
    t = t.replace(/<\/ul>\s*<ul>/g, '');
    // Line breaks
    t = t.replace(/\n/g, '<br>');
    return t;
  }

  function scrollAiChatToEnd_() {
    setTimeout(function () {
      var el = document.querySelector('[data-tmb-ai-messages]');
      if (el) el.scrollTop = el.scrollHeight;
    }, 10);
  }

})();
